/* eslint-disable class-methods-use-this */
/* eslint-disable object-curly-newline */
/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import ReactHoverObserver from 'react-hover-observer';
import SwipeableViews from 'hb-react-swipeable-views-new';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { FormSection, Field, Fields, FieldArray, reduxForm } from 'redux-form';
import { useDropzone } from 'react-dropzone';
import {
  Grid,
  Paper,
  Typography,
  FormLabel,
  FormControl,
  FormGroup,
  FormControlLabel,
  FormHelperText,
  Input,
  InputLabel,
  InputAdornment,
  Divider,
  Button,
  IconButton,
  Badge,
  Tooltip,
  Select as MuiSelect,
  Switch as MuiSwitch,
  Radio,
  RadioGroup as MuiRadioGroup,
  Checkbox as MuiCheckbox,
  MenuItem,
  AppBar,
  Tabs as MuiTabs,
  Tab as MuiTab,
  Stepper as MuiStepper,
  Step,
  StepButton,
  Modal,
  Fab,
  Avatar as MuiAvatar,
  Box,
  Menu,
  ListItemIcon,
  ListItemText,
  ClickAwayListener,
  Popper,
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { createMuiTheme, ThemeProvider, makeStyles } from '@material-ui/core/styles';
import {
  AddAlarm,
  AlarmOn,
  AddPhotoAlternate,
  Close,
  Clear,
  Delete,
  DeleteForever,
  ModeEdit,
  CheckCircle,
  Error,
  Save,
  InsertPhoto,
  ArrowDropUp,
  ArrowDropDown,
  RotateLeft,
  RotateRight,
  ZoomIn,
  ZoomOut,
  Visibility,
  VisibilityOff,
  Favorite,
  InfoOutline,
} from 'utilsModule/material-ui-icons';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import {
  ExchangeIcon,
  TrashBinIcon,
  UploadFileIcon,
  CalendarIcon,
} from 'utilsModule/customIcons';
import IconCalendar from 'dataModule/assets/img/IconCalendar.svg';
import {
  DatePicker as MuiDatePicker,
  TimePicker as MuiTimePicker,
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import MomentUtils from '@date-io/moment';
import { createSliderWithTooltip, Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
import ReactVirtualizedSelect from 'react-virtualized-select';
import AvatarEditor from 'react-avatar-editor';
import classNames from 'classnames';
import update from 'immutability-helper';
import uuidv4 from 'uuid/v4';
import moment from 'moment-timezone';
import debounce from 'lodash/debounce';
import isFunction from 'lodash/isFunction';
import * as R from 'ramda';
import * as _ from 'lodash';
import FontFaceObserver from 'fontfaceobserver';
import { memoize, switchProp, findIndexBy, joinSpecificValue } from 'utilsModule';
import commonUtil from 'utilsModule/common';
import { Loading, ImageAvatar } from 'utilsModule/components';
import { defaultMeta, reduceMetas, decideStatusFromMeta, StatusIndicator, normalize } from '.';
import { roundFloatToFixedDecimal } from 'utilsModule/common';
import './index.scss';
import DialogProgramValidation from 'appModule/program/components/DialogProgramValidation';
import InfoTooltipWrapper from 'utilsModule/components/InfoTooltip';
import HBModalDialog from 'utilsModule/components/HBModalDialog';
import i18n from 'appModule/i18n';
import PhotoIcon from 'dataModule/assets/img/PhotoIcon.png';
import ImageIcon from 'dataModule/assets/img/ImageIcon.svg';
import VideoIcon from 'dataModule/assets/img/VideoIcon.svg';
import { NamespacesConsumer, withNamespaces } from 'react-i18next';

const getLocalizedText = (t, key, defaultValue) => {
  const translated = t ? t(key, { defaultValue }) : i18n.t(key, { defaultValue });
  return translated === key ? defaultValue : translated;
};

const resolvePlaceholderText = (placeholder, key, defaultValue, fallbackWhenEmpty = false) => {
  const localized = getLocalizedText(null, key, defaultValue);

  if (placeholder === undefined || placeholder === null) return localized;
  if (fallbackWhenEmpty && placeholder === '') return localized;

  const normalizedPlaceholder = `${placeholder}`.trim().toLowerCase().replace(/\s+/g, '');
  const normalizedDefault = `${defaultValue}`.trim().toLowerCase().replace(/\s+/g, '');

  return normalizedPlaceholder === normalizedDefault ? localized : placeholder;
};

const getCurrentAppLanguage = () => {
  const currentLanguage = i18n.language || sessionStorage.getItem('language') || 'en';
  return commonUtil.getLanguageCode(currentLanguage);
};

class LocalizedTimeDateFnsUtils extends DateFnsUtils {
  constructor(options = {}) {
    super(options);
    this.meridiemLocale = options.instance || 'en';
  }

  getMeridiemText(ampm) {
    const meridiemHour = ampm === 'am' ? 1 : 13;
    return moment().locale(this.meridiemLocale).hour(meridiemHour).minute(0).format('A');
  }
}


const styles = (theme) => ({
  status: {
    pristine: {
      color: '#00b3b3',
    },
    dirty: {
      color: '#FFC107',
    },
    touchedValid: {
      color: '#81C784',
    },
    visiblyInvalid: {
      color: 'lightcoral',
    },
  },
  underline: {
    borderBottom: '2px solid white',
    '&:after': {
      // The MUI source seems to use this but it doesn't work
      borderBottom: '2px solid white',
    },
  },
  root: {
    underline: {
      '&:before': {
        backgroundColor: '#e0e0e0',
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        height: 1,
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('background-color', {
          duration: theme.transitions.duration.shorter,
        }),
        pointerEvents: 'none', // Transparent to the hover style.
      },
      '&:hover:not($disabled):before': {
        backgroundColor: '#9e9e9e',
        height: '2px',
      },
      '&$disabled:before': {
        background: 'transparent',
        backgroundImage: 'linear-gradient(to right, #e0e0e0 33%, transparent 0%)',
        backgroundPosition: 'left top',
        backgroundRepeat: 'repeat-x',
        backgroundSize: '5px 1px',
      },
      '&:hover$error:before': {
        backgroundColor: theme.palette.error.main,
        transform: 'scaleX(1)', // error is always underlined in red
      },
      '&$error:before': {
        backgroundColor: theme.palette.error.main,
        transform: 'scaleX(1)', // error is always underlined in red
      },
    },
    root: {
      '&:after': {
        backgroundColor: '#414EC1',
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        height: 2,
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut,
        }),
        pointerEvents: 'none', // Transparent to the hover style.
      },
      '&$focused:after': {
        transform: 'scaleX(1)',
      },
      // Increase specificity
      '&$error:after': {
        backgroundColor: theme.palette.error.main,
        transform: 'scaleX(1)', // error is always underlined in red
      },
    },
    focused: {},
    error: {},
    disabled: {},
  },
});

const InfoTooltip = withStyles(() => ({
  tooltip: {
    background: '#212121 0% 0% no-repeat padding-box',
    boxShadow: '0px 4px 16px #00000052',
    color: 'white',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontSize: '12px',
    lineHeight: '16px',
    padding: '10px 12px',
    marginTop: 8,
    fontWeight: '400',
    letterSpacing: '0.5px',
    borderRadius: '8px',
  },
}))(Tooltip);

const defaultMaterialTheme = createMuiTheme({
  overrides: {
    MuiInput: {
      underline: {
        '&:before': {
          borderBottom: '1px solid #e0e0e0',
        },
        '&:hover:not(.Mui-disabled):before': {
          borderBottom: '2px solid rgb(144 144 144 / 87%) !important',
        },
      },
      input: {
        '&::placeholder': {
          letterSpacing: '0.08px',
          fontStyle: 'normal',
        },
      },
    },
  },
});

const defaultMaterialThemeTimePicker = createMuiTheme({
  overrides: {
    MuiInput: {
      underline: {
        '&:before': {
          borderBottom: '1px solid #e0e0e0',
        },
        '&:after': {
          borderBottom: '0px solid #e0e0e0',
        },
        '&:hover:not(.Mui-disabled):before': {
          borderBottom: '0px solid rgb(144 144 144 / 87%) !important',
        },
      },
      input: {
        '&::placeholder': {
          letterSpacing: '0.08px',
          fontStyle: 'normal',
        },
      },
    },
  },
});

const usePlaceholderStyles = makeStyles((theme) => ({
  placeholder: {
    color: '#aaa',
    fontWeight: '400',
  },
}));

const Placeholder = ({ children }) => {
  const classes = usePlaceholderStyles();
  return <div className={classes.placeholder}>{children}</div>;
};

class Section extends React.PureComponent {
  static propTypes = {
    name: PropTypes.string,
    component: PropTypes.any,
    rows: PropTypes.array.isRequired,
    itemProps: PropTypes.shape({
      overall: PropTypes.object,
      body: PropTypes.object,
    }),
    containerProps: PropTypes.shape({
      overall: PropTypes.object,
      body: PropTypes.object,
    }),
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
  };

  defaultComponent = ({
    title,
    typography = { variant: 'h5' },
    children,
    prefixAvatar = null,
    prefixAvatarStatus = null,
  }) => {
    const {
      itemProps: { body: sectionBodyItemProps = {} } = {},
      containerProps: { overall: sectionOverallContainerProps = {}, header: sectionHeaderProps = {} } = {},
    } = this.props;

    const avatarChoices = {
      pristine: {
        style: { backgroundColor: '#212121', color: '#FFFFFF' },
      },
      dirty: {
        style: { backgroundColor: '#212121', fontSize: '16px' },
      },
      touchedValid: {
        style: { backgroundColor: '#212121', fontSize: '16px' },
      },
      visiblyInvalid: {
        style: { backgroundColor: '#212121', fontSize: '16px' },
      },
    };

    return (
      <Grid container {...sectionOverallContainerProps}>
        {title && (
          <Grid item xs={12} style={{ padding: '0px' }}>
            <Grid item xs={12} style={sectionHeaderProps.style ? sectionHeaderProps.style : {}}>
              <div
                style={{
                  display: 'flex',
                  gap: '16px',
                  alignItems: 'center',
                }}
              >
                {prefixAvatar && prefixAvatarStatus && (
                  <MuiAvatar aria-label={title} style={avatarChoices[prefixAvatarStatus].style}>
                    {prefixAvatar}
                  </MuiAvatar>
                )}
                <Typography {...typography}>{title}</Typography>
              </div>
            </Grid>
            {/* <div
              style={{
                backgroundColor: '#212121',
                // width: '100%',
                fontSize: '16px',
                display: 'flex',
                alignItems: 'center',
                padding: '20px 24px',
                margin: '0px -8px'
              }}
            >
              <Typography variant="body1" style={{color: 'white'}}>
                Organisation Information descriptions
              </Typography>
            </div> */}
          </Grid>
        )}

        <Grid item xs={12} {...sectionBodyItemProps}>
          {children}
        </Grid>
      </Grid>
    );
  };

  constructor(props) {
    super(props);
    const { rows } = props;
    const metas = {};
    const components = R.flatten(R.map(({ cols }) => cols, rows));

    R.pipe(
      R.filter(({ ignoreMeta }) => !ignoreMeta),
      R.forEach(({ name }) => {
        metas[name] = R.clone(defaultMeta);
      }),
    )(components);

    this.state = { metas };
  }

  changeSectionMeta = memoize((componentName) => (meta) =>
    this.setState(({ metas: prevMetas }, { onMetaChange: onSectionMetaChange }) => {
      const nextMetas = update(prevMetas, { [componentName]: { $set: meta } });
      const sectionMeta = reduceMetas(nextMetas);
      onSectionMetaChange && onSectionMetaChange(sectionMeta);
      return { metas: nextMetas };
    }),
  );

  renderLayout({
    rows,
    containerProps: { body: sectionBodyContainerProps = {} } = {},
    disabled: sectionDisabled,
    readonly: sectionReadonly,
    ...rest
  }) {
    return (
      <Grid container {...sectionBodyContainerProps}>
        {rows.map(({ id: rowKey, containerProps: rowContainerProps, cols }, rowIndex) => (
          <Grid key={rowKey || `row-${rowIndex}`} item xs={12}>
            <Grid container justify="center" spacing={2} {...rowContainerProps}>
              {cols.map(
                ({ id: colKey, name, component: Component, colSpans, inject, ignoreMeta, ...props }, colIndex) => (
                  <Grid key={colKey || name || `col-${rowIndex}-${colIndex}`} item xs {...colSpans}>
                    <Component
                      name={name}
                      disabled={!!sectionDisabled}
                      readonly={!!sectionReadonly}
                      {...props}
                      {...(inject ? inject(rest) : {})}
                      // NOTE: onMetaChange should be destructured above or put as last here since this component can receive onMetaChange
                      {...(ignoreMeta ? {} : { onMetaChange: this.changeSectionMeta(name) })}
                    />
                  </Grid>
                ),
              )}
            </Grid>
          </Grid>
        ))}
      </Grid>
    );
  }

  render() {
    const { metas } = this.state;
    const {
      name,
      component: Component = this.defaultComponent,
      itemProps: { overall: sectionOverallItemProps = {} } = {},
      style,
      displayCondition = null,
      ...rest
    } = this.props;

    // console.log('%crender Section', 'font-size: 12px; color: #00b3b3', this.state, this.props);

    /*
      displayCondition
      - is a function to determine if a section needs to be rendered / displayed
      - is an optional field in a Form Section
      - is useful when there is a section that needs to be hidden based on a condition(s)
      - The condition's prop needs to be passed into the <Form> component for it to be accessible here
    */
    if (displayCondition && !displayCondition(this.props)) {
      return null;
    }

    return ((content) => (name ? <FormSection name={name}>{content}</FormSection> : content))(
      <Grid item xs={12} {...sectionOverallItemProps} style={{ marginTop: 20, ...style }}>
        <Component {...rest} meta={reduceMetas(metas)}>
          {this.renderLayout(rest)}
        </Component>
      </Grid>,
    );
  }
}

const withOnMetaChange = (subMeta = ['pristine', 'dirty', 'touchedValid', 'visiblyInvalid']) => (RawField) => {
  class WithOnMetaChange extends React.PureComponent {
    addTouchedValid = (meta) => ({ ...meta, touchedValid: meta.touched && meta.valid });

    addVisiblyInvalid = (meta) => ({ ...meta, visiblyInvalid: meta.touched && meta.invalid });

    getExtraMeta = R.pipe(this.addTouchedValid, this.addVisiblyInvalid);

    getReportedMeta = R.pipe(this.getExtraMeta, R.pick(subMeta));

    reportMetaChange = (prevMeta, meta) => {
      const { onMetaChange, ignoreMeta } = this.props;

      if (ignoreMeta) return;

      const reportedMeta = this.getReportedMeta(meta);
      const prevReportedMeta = this.getReportedMeta(prevMeta);

      !R.equals(reportedMeta, prevReportedMeta) && onMetaChange && onMetaChange(reportedMeta);
    };

    componentDidMount() {
      this.reportMetaChange({}, this.props.meta);
    }

    componentDidUpdate({ meta: prevMeta }) {
      this.reportMetaChange(prevMeta, this.props.meta);
    }

    render() {
      const { meta } = this.props;
      return <RawField {...R.omit(['onMetaChange'], this.props)} meta={this.getExtraMeta(meta)} />;
    }
  }

  return WithOnMetaChange;
};

@withStyles((theme) => ({ ...styles(theme), ...styles(theme).root }), {
  name: 'reduxFormMui',
})
@withOnMetaChange()
class RawTextField extends React.PureComponent {
  static propTypes = {
    multiline: PropTypes.bool,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
    disableUnderline: PropTypes.bool,
  };

  static defaultProps = {
    disableUnderline: false,
  };

  renderView() {
    const {
      input: { name },
      label,
      multiline = false,
      adornment: { position = 'start', component = null } = {},
      adornmentLabel: { positionAdornmentLabel = 'start', componentAdornmentLabel = null } = {},
      istruncate = false,
      isWordBreak = false,
      containerStyle = {},
    } = this.props;
    let {
      input: { value },
    } = this.props;
    const changePostalLabel = R.prop('isusa', this.props) === undefined ? false : this.props.isusa;
    if (name === 'basicInfo.weight') {
      if (value === 0) value = '0.00';
      if (value > 0) value = roundFloatToFixedDecimal(parseFloat(value), 2).toFixed(2);
    }
    if (name === 'basicInfo.height') {
      if (value === 0) value = '0.0';
      if (value > 0) value = roundFloatToFixedDecimal(parseFloat(value), 1).toFixed(1);
    }

    return (
      <Grid container spacing={1} alignItems="center" style={containerStyle}>
        <Grid item xs={12}>
          <Typography variant="caption">
            {componentAdornmentLabel && positionAdornmentLabel === 'start' && (
              <span item>{componentAdornmentLabel}</span>
            )}
            {changePostalLabel ? 'Zip Code' : label}
            {componentAdornmentLabel && positionAdornmentLabel === 'end' && <span item>{componentAdornmentLabel}</span>}
          </Typography>
        </Grid>
        {component && position === 'start' && (
          <Grid item>
            <Typography color="textSecondary">{component}</Typography>
          </Grid>
        )}
        {istruncate && (
          <Grid item xs>
            <Typography noWrap style={{ whiteSpace: 'noWrap' }}>
              {value || ''}
            </Typography>
          </Grid>
        )}
        {isWordBreak && (
          <Grid item xs>
            <Typography style={{ wordBreak: 'break-word' }}>{value || '-'}</Typography>
          </Grid>
        )}
        {!istruncate && !isWordBreak && (
          <Grid item>
            <Typography variant="body1" style={{ whiteSpace: multiline ? 'pre-line' : 'normal' }}>
              {value || '-'}
            </Typography>
          </Grid>
        )}
        {component && position === 'end' && (
          <Grid item>
            <Typography color="textSecondary">{component}</Typography>
          </Grid>
        )}
      </Grid>
    );
  }

  renderEdit() {
    const {
      input,
      meta,
      fullWidth,
      required,
      label,
      hasHelperText = true,
      helperText = null,
      showHelperText = null,
      adornment: { position = 'start', component = null, adornmentStyle = {} } = {},
      adornmentLabel: { positionAdornmentLabel = 'start', componentAdornmentLabel = null } = {},
      readonly,
      showStatus,
      classes,
      inputWidth = '100%',
      disableUnderline,
      placeholder,
      limit = null,
      shrink = true,
      useShrink = true,
      absoluteWholeNumber = false,
      labelStyle = null,
      fieldStyle = {},
      allowEntry = true,
      ...props
    } = this.props;
    const { touched, error, warning } = meta;
    const { disabled } = props;

    // only allow whole and absolute numbers
    if (absoluteWholeNumber && input && input.value) {
      input.value = Number(`${input.value}`.replace(/[^0-9]/g, ''));
    }

    // do not allow leading zeros
    if (absoluteWholeNumber && input && input.value == 0) {
      input.value = '';
    }

    const statusAdornment = {
      position: 'end',
      component: (() => {
        const status = decideStatusFromMeta(meta);
        if (['pristine'].includes(status)) return null;
        const statusProps = {
          color: disabled ? 'disabled' : 'primary',
          classes: { colorPrimary: classes[status] },
        };
        const StatusComponent = {
          dirty: ModeEdit,
          touchedValid: CheckCircle,
          visiblyInvalid: Error,
        }[status];
        return <StatusComponent {...statusProps} />;
      })(),
    };

    const inputStyle = Object.assign(
      { width: inputWidth },
      {
        ...fieldStyle,
      },
    );

    const changePostalLabel = R.prop('isusa', this.props) === undefined ? false : this.props.isusa;
    const changePostalErrRequire = error ? R.replace('Postal Code', 'Zip Code', error) : error;
    const errorResult = changePostalLabel ? changePostalErrRequire : error;
    const requireSetting = isFunction(required) ? required(props) : required;
    const resolvedPlaceholder = resolvePlaceholderText(placeholder, 'common:placeholder.enter', 'Enter ...');

    return (
      <FormControl error={touched && !!error} fullWidth={fullWidth} required={requireSetting}>
        <ThemeProvider theme={defaultMaterialTheme}>
          {useShrink
            ? label && (
              <InputLabel htmlFor={label} shrink={shrink} style={labelStyle}>
                {componentAdornmentLabel && positionAdornmentLabel === 'start' && (
                  <span item>{componentAdornmentLabel}</span>
                )}
                {changePostalLabel ? 'Zip Code' : label}
                {componentAdornmentLabel && positionAdornmentLabel === 'end' && (
                  <span item>{componentAdornmentLabel}</span>
                )}
              </InputLabel>
            )
            : label && (
              <InputLabel htmlFor={label} style={labelStyle}>
                {componentAdornmentLabel && positionAdornmentLabel === 'start' && (
                  <span item>{componentAdornmentLabel}</span>
                )}
                {changePostalLabel ? 'Zip Code' : label}
                {componentAdornmentLabel && positionAdornmentLabel === 'end' && (
                  <span item>{componentAdornmentLabel}</span>
                )}
              </InputLabel>
            )}
          <Input
            placeholder={resolvedPlaceholder}
            disableUnderline={disableUnderline}
            style={inputStyle}
            onKeyDown={(e) => {
              if (!allowEntry) {
                e.preventDefault();
              }
              const { multiline, limit, input } = this.props;

              const navigationKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Tab'];

              // Prevent Enter key for single-line
              if (!multiline && e.key === 'Enter') {
                e.preventDefault();
              }

              // Prevent typing beyond limit (except for control/navigation keys)
              if (limit && input.value.length >= limit && !navigationKeys.includes(e.key) && !e.ctrlKey && !e.metaKey) {
                e.preventDefault();
              }

              if (props.onKeyDown) {
                props.onKeyDown(e);
              }
            }}
            onPaste={(e) => {
              const { limit, input } = this.props;
              const paste = e.clipboardData.getData('text');
              const currentLength = input.value.length;

              if (limit && currentLength + paste.length > limit) {
                e.preventDefault();
              }
            }}
            onChange={(e) => {
              const { limit, input } = this.props;
              let newValue = e.target.value;

              // Trim if value exceeds limit
              if (limit && newValue.length > limit) {
                newValue = newValue.substring(0, limit);
              }

              if (input && input.onChange) {
                input.onChange(newValue);
              }

              if (this.props.onChange) {
                this.props.onChange(e);
              }
            }}
            {...{
              [`${statusAdornment.position}Adornment`]: showStatus && (
                <InputAdornment position={statusAdornment.position}>{statusAdornment.component}</InputAdornment>
              ),
            }}
            {...{
              [`${position}Adornment`]: position && component && (
                <InputAdornment position={position}>
                  <span style={adornmentStyle}>{component}</span>
                </InputAdornment>
              ),
            }}
            {...input}
            {...props}
          />

          {hasHelperText && (
            // <FormHelperText style={{ whiteSpace: 'pre' }}>
            <FormHelperText>{(touched && (errorResult || warning)) || helperText || showHelperText}</FormHelperText>
          )}
          {limit && (
            <Typography
              variant="caption"
              style={{
                textAlign: 'right',
                fontSize: '12px',
                marginTop: '-15px',
                color: touched && (errorResult || warning) ? '#FF453A' : '#9e9e9e',
              }}
            >
              {this.props.input.value.length} / {limit}
            </Typography>
          )}
        </ThemeProvider>
      </FormControl>
    );
  }

  render() {
    const { readonly } = this.props;

    return readonly ? this.renderView() : this.renderEdit();
  }
}

class TextField extends React.PureComponent {
  render() {
    const { name, helperText, ...props } = this.props;

    return (
      <div style={{ width: '100%' }}>
        <Field name={name} component={RawTextField} fullWidth {...props} />
        {helperText && (
          <Typography
            variant="caption"
            style={{ textAlign: 'right', fontSize: '12px', marginTop: '-15px', color: '#9e9e9e' }}
          >
            {helperText}
          </Typography>
        )}
      </div>
    );
  }
}

const freeTextFieldstyles = (theme) => ({
  container: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  label: {
    marginBottom: theme.spacing(1),
    fontSize: '12px',
    lineHeight: '14px',
    fontWeight: 400,
    color: '#9E9E9E',
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      backgroundColor: '#ffffff',
      '& fieldset': {
        borderColor: '#e0e0e0',
        borderWidth: '1px',
      },
      '&:hover fieldset': {
        borderColor: '#bdbdbd',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#1976d2',
        borderWidth: '2px',
      },
      '&.Mui-error fieldset': {
        borderColor: '#f44336',
        borderWidth: '2px',
      },
    },
    '& .MuiOutlinedInput-input': {
      padding: '16px',
      fontSize: '14px',
      lineHeight: '1.5',
      color: '#424242',
      '&::placeholder': {
        color: '#9e9e9e',
        opacity: 1,
      },
    },
    '& .MuiOutlinedInput-multiline': {
      padding: 0,
      '& .MuiOutlinedInput-input': {
        padding: '16px',
        minHeight: '120px',
        resize: 'vertical',
      },
    },
    marginBottom: '-13px',
  },
  helperArea: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  characterCounter: {
    display: 'flex',
    justifyContent: 'flex-end',
    fontSize: '12px',
    color: '#9e9e9e',
    '&.error': {
      color: '#f44336',
    },
    float: 'right',
  },
  errorText: {
    color: '#f44336',
    fontSize: '12px',
  },
  helperText: {
    fontSize: '12px',
    color: '#757575',
  },
});

@withStyles(freeTextFieldstyles)
class RawFreeTextField extends React.PureComponent {
  static propTypes = {
    label: PropTypes.string,
    placeholder: PropTypes.string,
    multiline: PropTypes.bool,
    rows: PropTypes.number,
    limit: PropTypes.number,
    readonly: PropTypes.bool,
    helperText: PropTypes.string,
    showCharacterCount: PropTypes.bool,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    placeholder: undefined,
    multiline: false,
    rows: 4,
    limit: null,
    readonly: false,
    showCharacterCount: true,
    disabled: false,
  };

  handleChange = (event) => {
    const { input, limit } = this.props;
    let newValue = event.target.value;

    // Enforce character limit
    if (limit && newValue.length > limit) {
      newValue = newValue.substring(0, limit);
    }

    // Update field value
    if (input && input.onChange) {
      input.onChange(newValue);
    }
  };

  handleKeyDown = (event) => {
    const { limit, input } = this.props;

    const navigationKeys = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
      'Tab',
      'Home',
      'End',
    ];

    // Prevent typing beyond limit (but allow navigation and deletion)
    if (
      limit &&
      input.value &&
      input.value.length >= limit &&
      !navigationKeys.includes(event.key) &&
      !event.ctrlKey && // Allow Ctrl commands (copy/paste/select all)
      !event.metaKey && // Allow Cmd commands on Mac
      event.key.length === 1 // Only prevent printable characters
    ) {
      event.preventDefault();
    }
  };

  renderView() {
    const { input, label, classes, multiline } = this.props;
    const value = input.value || '';

    return (
      <Box className={classes.container}>
        {label && <Typography className={classes.label}>{label}</Typography>}
        <Box
          sx={{
            padding: '16px',
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            backgroundColor: '#f9f9f9',
            minHeight: multiline ? '120px' : 'auto',
          }}
        >
          <Typography
            variant="body2"
            style={{
              whiteSpace: multiline ? 'pre-wrap' : 'normal',
              wordBreak: 'break-word',
            }}
          >
            {value || '-'}
          </Typography>
        </Box>
      </Box>
    );
  }

  renderEdit() {
    const {
      input,
      meta,
      label,
      placeholder = getLocalizedText(null, 'common:placeholder.enter', 'Enter ...'),
      multiline,
      rows,
      limit,
      helperText,
      showCharacterCount,
      classes,
      ...props
    } = this.props;

    const { touched, error } = meta || {};
    const value = input.value || '';
    const hasError = touched && error;
    const isOverLimit = limit && value.length >= limit;

    return (
      <Box className={classes.container}>
        {label && <Typography className={classes.label}>{label}</Typography>}

        <TextField
          variant="outlined"
          fullWidth
          multiline={multiline}
          rows={multiline ? rows : 1}
          placeholder={placeholder}
          value={value}
          onChange={this.handleChange}
          onKeyDown={this.handleKeyDown}
          error={hasError}
          className={classes.textField}
          {...props}
        />
        <div className={classes.helperArea}>
          <div>
            {/* Error Message */}
            {hasError && <Typography className={classes.errorText}>{error}</Typography>}

            {/* Helper Text */}
            {helperText && !hasError && <Typography className={classes.helperText}>{helperText}</Typography>}
          </div>

          {/* Character Counter */}
          {showCharacterCount && limit && (
            <Typography className={`${classes.characterCounter} ${isOverLimit ? 'error' : ''}`}>
              {value.length} / {limit}
            </Typography>
          )}
        </div>
      </Box>
    );
  }

  render() {
    const { readonly } = this.props;
    return readonly ? this.renderView() : this.renderEdit();
  }
}

class FreeTextField extends React.PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    multiline: PropTypes.bool,
    limit: PropTypes.number,
    readonly: PropTypes.bool,
    helperText: PropTypes.string,
    showCharacterCount: PropTypes.bool,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    label: undefined,
    placeholder: undefined,
    multiline: true,
    limit: 500,
    readonly: false,
    showCharacterCount: true,
    disabled: false,
  };

  render() {
    const { name, ...props } = this.props;

    return <Field name={name} component={RawFreeTextField} {...props} />;
  }
}

export const validateFreeText = (maxLength = null, required = false) => (value) => {
  if (required && (!value || value.trim() === '')) {
    return 'This field is required';
  }

  if (maxLength && value && value.length > maxLength) {
    return `Maximum ${maxLength} characters allowed`;
  }

  return undefined;
};

@withStyles((theme) => ({ ...styles(theme).status, ...styles(theme).root }), {
  name: 'reduxFormMui',
})
@withOnMetaChange()
class RawShowHidePasswordTextField extends React.PureComponent {
  static propTypes = {
    input: PropTypes.object.isRequired,
    label: PropTypes.string,
    className: PropTypes.string,
    required: PropTypes.bool,
  };

  state = { showPassword: false };

  render() {
    const {
      /* Field */
      input,
      meta: { touched, error, warning },
      /* FormControl */
      fullWidth,
      required,
      /* InputLabel */
      label = 'Password',
      /* FormHelperText */
      helperText = null,
      /* Input */
      disabled,
      classes,
      ...props
    } = this.props;

    return (
      <FormControl error={touched && !!error} fullWidth={fullWidth} required={required}>
        {label && <InputLabel htmlFor={label}>{label}</InputLabel>}
        <Input
          type={this.state.showPassword ? 'text' : 'password'}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                tabIndex={-1}
                onClick={() => !disabled && this.setState({ showPassword: !this.state.showPassword })}
                onMouseDown={(e) => e.preventDefault()}
              >
                {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
          disabled={!!disabled}
          classes={R.pick(['underline', 'focused', 'error', 'disabled'], classes)}
          {...input}
          {...props}
        />
        <FormHelperText style={{ whiteSpace: 'none' }}>{(touched && (error || warning)) || helperText}</FormHelperText>
      </FormControl>
    );
  }
}

class ShowHidePasswordTextField extends React.PureComponent {
  render() {
    const { name, ...props } = this.props;
    return <Field name={name} component={RawShowHidePasswordTextField} fullWidth {...props} />;
  }
}

class RawPhone extends React.PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    landline: PropTypes.bool,
    delimiter: PropTypes.string,
    fullWidth: PropTypes.bool,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
  };

  state = {
    metas: {
      countryCode: R.clone(defaultMeta),
      areaCode: R.clone(defaultMeta),
      value: R.clone(defaultMeta),
    },
  };

  itemTemplate = ({ label: countryCode, iso, flag }) => (
    <Grid container justify="flex-start" alignItems="center" spacing={1}>
      <Grid item>
        <img src={flag} style={{ display: 'block' }} />
      </Grid>
      <Grid item>{iso}</Grid>
      <Grid item>({countryCode})</Grid>
    </Grid>
  );

  reportMetaChange = (metas) => {
    const { onMetaChange: onPhoneMetaChange } = this.props;
    const phoneMeta = R.pipe(
      R.unless(R.always(R.prop('landline', this.props)), R.omit(['areaCode'])),
      reduceMetas,
    )(metas);
    onPhoneMetaChange && onPhoneMetaChange(phoneMeta);
  };

  changeMeta = memoize((name) => (meta) =>
    this.setState(({ metas: prevMetas }) => {
      const nextMetas = update(prevMetas, { [name]: { $set: meta } });
      this.reportMetaChange(nextMetas);
      return { metas: nextMetas };
    }),
  );

  renderView() {
    const {
      [this.props.name]: {
        countryCode: {
          input: { value: { value: countryCode } = {} },
        },
        value: {
          input: { value },
        },
      },
      label,
      istruncate = false,
    } = this.props;

    return (
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography variant="caption">{label}</Typography>
        </Grid>
        <Grid item xs={12}>
          {istruncate ? (
            <Typography noWrap style={{ whiteSpace: 'noWrap' }}>
              {`+${countryCode} ${value}`}
            </Typography>
          ) : (
            <Typography variant="body1">{`+${countryCode} ${value}`}</Typography>
          )}
        </Grid>
      </Grid>
    );
  }

  renderEdit() {
    const { metas } = this.state;
    const {
      /* Fields */
      [this.props.name]: {
        countryCode: { input: countryCodeInput, meta: countryCodeMeta },
        areaCode: { input: areaCodeInput, meta: areaCodeMeta },
        value: { input: phoneNoInput, meta: phoneNoMeta },
      },
      label,
      landline,
      fullWidth,
      required,
      placeholder = '',
      disabled,
      readonly,
      updateisusa,
    } = this.props;

    // console.log('%cPhone', 'font-size: 12px; color: #00b3b3', this.state, this.props);

    return (
      <FormControl
        error={R.pipe(reduceMetas, R.prop('visiblyInvalid'))(metas)}
        fullWidth={!!fullWidth}
        required={!!required}
      >
        <FormLabel style={{ transformOrigin: 'top left', transform: 'translate(0, 1.5px) scale(0.75)' }}>
          {label}
        </FormLabel>
        <Grid container spacing={1}>
          <Grid item>
            <RawSelect
              updateisusa={updateisusa}
              itemTemplate={this.itemTemplate}
              renderValue={(value) => `+${value}`}
              input={countryCodeInput}
              meta={countryCodeMeta}
              onMetaChange={this.changeMeta('countryCode')}
              disabled={!!disabled}
              readonly={!!readonly}
            />
          </Grid>
          {landline && (
            <Grid item xs={2}>
              <RawTextField
                fullWidth={true}
                input={{
                  ...areaCodeInput,
                  onChange: (e) =>
                    areaCodeInput.onChange &&
                    areaCodeInput.onChange(normalize.toDigits(e.target.value, areaCodeInput.value)),
                }}
                meta={areaCodeMeta}
                onMetaChange={this.changeMeta('areaCode')}
                disabled={!!disabled}
                readonly={!!readonly}
                placeholder
              />
            </Grid>
          )}
          <Grid item xs>
            <RawTextField
              fullWidth={true}
              input={{
                ...phoneNoInput,
                onChange: (e) =>
                  phoneNoInput.onChange &&
                  phoneNoInput.onChange(normalize.toDigits(e.target.value, phoneNoInput.value)),
              }}
              meta={phoneNoMeta}
              onMetaChange={this.changeMeta('value')}
              disabled={!!disabled}
              readonly={!!readonly}
              placeholder
            />
          </Grid>
        </Grid>
      </FormControl>
    );
  }

  render() {
    const { readonly } = this.props;

    return readonly ? this.renderView() : this.renderEdit();
  }
}

class Phone extends React.PureComponent {
  render() {
    const names = [
      `${R.pathOr('phone', ['name'], this.props)}.countryCode`,
      `${R.pathOr('phone', ['name'], this.props)}.areaCode`,
      `${R.pathOr('phone', ['name'], this.props)}.value`,
    ];
    return <Fields names={names} component={RawPhone} fullWidth {...this.props} />;
  }
}

@withStyles(() => ({
  '@global': {
    'div::-webkit-scrollbar': {
      minWidth: '1px',
      minHeight: '1px',
    },
    'div::-webkit-scrollbar-thumb': {
      borderRadius: '8px',
      border: '2px solid white',
      backgroundColor: 'rgba(0, 0, 0, .5)',
    },
    'div::-webkit-scrollbar:vertical': {
      width: '13px',
    },
    'div::-webkit-scrollbar:horizontal': {
      height: '13px',
    },
  },
}))
@withStyles((theme) => ({ ...styles(theme).root }), { name: 'reduxFormMui' })
@withOnMetaChange()
class RawSelect extends React.PureComponent {
  static propTypes = {
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
    disableUnderline: PropTypes.bool,
    preserveSelectedOption: PropTypes.bool,
  };

  static defaultProps = {
    disabled: false,
    readonly: false,
    disableUnderline: false,
    preserveSelectedOption: false,
  };

  defaultItemTemplate = ({ label }) => label;

  renderView() {
    const {
      input: {
        value: { options = [], value, label: selectedLabel },
      },
      label,
      adornmentLabel: { position = 'start', component = null } = {},
      labelStyle = null,
    } = this.props;

    return (
      <Grid container spacing={1}>
        {label && (
          <Grid item xs={12}>
            <Typography variant="caption">
              {position === 'start' && component && <span item>{component}</span>}
              {label}
              {position === 'end' && component && <span item>{component}</span>}
            </Typography>
          </Grid>
        )}
        <Grid item xs={12}>
          <Typography variant="body1" style={labelStyle}>
            {switchProp('label', 'value', value, options) || selectedLabel || value || '-'}
          </Typography>
        </Grid>
      </Grid>
    );
  }

  renderEdit() {
    const {
      input: {
        value: { options = [], value, label: selectedLabel },
        onChange,
        onBlur,
        onFocus,
      },
      label,
      itemTemplate: ItemTemplate = this.defaultItemTemplate,
      meta: { touched, error, warning },
      adornmentLabel: { position = 'start', component = null, adornmentAction = null } = {},
      hasHelperText = true,
      helperText = null,
      renderValue,
      disabled,
      placeholder,
      readonly,
      useShrink = true,
      disableUnderline,
      preserveSelectedOption,
      classes,
      ...custom
    } = this.props;
    const resolvedOptions = (() => {
      if (!preserveSelectedOption) return options;

      const normalizeOptionValue = (optionValue) =>
        `${optionValue || ''}`.trim().toLowerCase();
      const normalizeOptionIdentity = ({ value: optionValue, label: optionLabel } = {}) =>
        normalizeOptionValue(optionValue || optionLabel);
      const optionsWithSelectedValue =
        value && !options.some((option) =>
          normalizeOptionIdentity(option) ===
          normalizeOptionIdentity({ value, label: selectedLabel }),
        )
          ? [{ id: value, value, label: selectedLabel || value }].concat(options)
          : options;

      return optionsWithSelectedValue.filter(
        (option, index, list) =>
          index ===
          list.findIndex(
            (candidate) =>
              normalizeOptionIdentity(candidate) ===
              normalizeOptionIdentity(option),
          ),
      );
    })();
    const className = classNames({
      [classes.disabled]: disabled,
      [classes.root]: !disableUnderline,
      [classes.underline]: !disableUnderline,
    });
    const resolvedPlaceholder = resolvePlaceholderText(placeholder, 'common:placeholder.select', 'Select ...');

    return (
      <FormControl error={touched && !!error} disabled={disabled} {...custom}>
        <ThemeProvider theme={defaultMaterialTheme}>
          {label && (
            <InputLabel htmlFor={label} shrink={useShrink}>
              {position === 'start' && component && (
                <span onClick={() => adornmentAction()} item>
                  {component}
                </span>
              )}
              {label}
              {position === 'end' && component && (
                <span onClick={() => adornmentAction()} item>
                  {component}
                </span>
              )}
            </InputLabel>
          )}
          <MuiSelect
            disableUnderline={disableUnderline}
            value={value || ''}
            onChange={(e) => onChange && onChange({ options: resolvedOptions, value: e.target.value || '' })}
            onFocus={onFocus}
            onBlur={onBlur && onBlur.bind(null, { options: resolvedOptions, value, label: selectedLabel })}
            displayEmpty={true}
            renderValue={
              value === undefined || value === '' || value === null
                ? () => <Placeholder>{resolvedPlaceholder}</Placeholder>
                : renderValue
            }
          >
            {resolvedOptions &&
              Array.isArray(resolvedOptions) &&
              resolvedOptions.map(({ id: optionKey, value: optionValue, ...props }) => (
                <MenuItem
                  style={{ width: '100%', height: '45px', marginRight: '3px' }}
                  key={optionKey || optionValue}
                  value={optionValue}
                >
                  <ItemTemplate {...props} />
                </MenuItem>
              ))}
          </MuiSelect>
          {hasHelperText && (
            <FormHelperText style={{ whiteSpace: 'pre' }}>
              {(touched && (error || warning)) || helperText}
            </FormHelperText>
          )}
        </ThemeProvider>
      </FormControl>
    );
  }

  render() {
    const { readonly } = this.props;

    return readonly ? this.renderView() : this.renderEdit();
  }
}

class Select extends React.PureComponent {
  render() {
    const { name, ...props } = this.props;

    return <Field name={name} component={RawSelect} fullWidth {...props} />;
  }
}

@withStyles((theme) => ({ ...styles(theme).root }), { name: 'reduxFormMui' })
@withOnMetaChange()
class RawMultiSelect extends React.PureComponent {
  static propTypes = {
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
    disableUnderline: PropTypes.bool,
  };

  static defaultProps = {
    disabled: false,
    readonly: false,
    disableUnderline: false,
  };

  defaultItemTemplate = ({ label }) => label;

  renderView() {
    const {
      input: {
        value: { options = [], value },
      },
      label,
    } = this.props;
    const showValue = joinSpecificValue('label', 'value', value, options);

    return (
      <Grid container spacing={1}>
        {label && (
          <Grid item xs={12}>
            <Typography variant="caption">{label}</Typography>
          </Grid>
        )}
        <Grid item xs={12}>
          <Typography variant="body1">{showValue || getLocalizedText(null, 'common:tags.status.notApplicable', 'Not Applicable')}</Typography>
        </Grid>
      </Grid>
    );
  }

  renderEdit() {
    const {
      input: {
        value: { options = [], value },
        onChange,
        onBlur,
        onFocus,
      },
      label,
      itemTemplate: ItemTemplate = this.defaultItemTemplate,
      meta: { touched, error, warning },
      hasHelperText = true,
      helperText = null,
      renderValue,
      disabled,
      readonly,
      useShrink = true,
      disableUnderline,
      maxSelectedOptions = null,
      classes,
      placeholder,
      ...custom
    } = this.props;
    const resolvedPlaceholder = resolvePlaceholderText(
      placeholder,
      'common:placeholder.select',
      'Select ...',
      true,
    );

    const className = classNames({
      [classes.disabled]: disabled,
      [classes.inkbar]: !disableUnderline,
      [classes.underline]: !disableUnderline,
    });
    const checkBoxChecked = value || [];

    return (
      <FormControl error={touched && !!error} disabled={disabled} {...custom}>
        <ThemeProvider theme={defaultMaterialTheme}>
          {label && (
            <InputLabel
              htmlFor={label}
              style={{ color: touched && !!error ? '#f44336' : '#737373' }}
              shrink={useShrink}
            >
              {label}
            </InputLabel>
          )}
          <MuiSelect
            multiple
            value={value || []}
            onChange={(e) => onChange && onChange({ options, value: e.target.value || [] })}
            onFocus={onFocus}
            onBlur={onBlur && onBlur.bind(null, { options, value })}
            displayEmpty={true}
            renderValue={(selected) =>
              !value || value.length === 0 ? (
                <Placeholder>{resolvedPlaceholder}</Placeholder>
              ) : (
                joinSpecificValue('label', 'value', selected, options)
              )
            }
          >
            {options &&
              Array.isArray(options) &&
              options.map(({ id: optionKey, value: optionValue, ...props }) => (
                <MenuItem
                  style={{ width: '100%' }}
                  key={optionKey || optionValue}
                  value={optionValue}
                  disabled={
                    maxSelectedOptions === null
                      ? false
                      : checkBoxChecked.length >= 5 && !checkBoxChecked.includes(optionValue)
                  }
                >
                  <MuiCheckbox checked={R.indexOf(optionValue, checkBoxChecked) > -1} />
                  <ItemTemplate {...props} />
                </MenuItem>
              ))}
          </MuiSelect>
          {hasHelperText && (
            <FormHelperText style={{ whiteSpace: 'pre' }}>
              {(touched && (error || warning)) || helperText}
            </FormHelperText>
          )}
        </ThemeProvider>
      </FormControl>
    );
  }

  render() {
    const { readonly } = this.props;

    return readonly ? this.renderView() : this.renderEdit();
  }
}

class MultiSelect extends React.PureComponent {
  render() {
    const { name, ...props } = this.props;

    return <Field name={name} component={RawMultiSelect} fullWidth {...props} />;
  }
}
const ITEM_HEIGHT = 48;
@withStyles((theme) => ({
  // We had to use a lot of global selectors in order to style react-select.
  // We are waiting on https://github.com/JedWatson/react-select/issues/1679
  // to provide a much better implementation.
  // Also, we had to reset the default style injected by the library.
  '@global': {
    '.Select-control': {
      display: 'flex',
      alignItems: 'center',
      border: 0,
      height: 'auto',
      background: 'transparent !important',
      '&:hover': {
        boxShadow: 'none',
      },
    },
    '.Select-multi-value-wrapper': {
      flexGrow: 1,
      display: 'flex',
      flexWrap: 'wrap',
    },
    '.Select--multi .Select-input': {
      margin: 0,
    },
    '.Select.has-value.is-clearable.Select--single > .Select-control .Select-value': {
      padding: 0,
    },
    '.Select-noresults': {
      padding: theme.spacing(2),
    },
    '.Select-input': {
      display: 'inline-flex !important',
      padding: 0,
      height: 'auto',
    },
    '.Select-input input': {
      background: 'transparent',
      border: 0,
      padding: 0,
      cursor: 'default',
      display: 'inline-block',
      fontFamily: 'inherit',
      fontSize: 'inherit',
      margin: 0,
      outline: 0,
    },
    '.Select-placeholder, .Select--single > .Select-control .Select-value': {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center',
      color: 'inherit',
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(16),
      padding: 0,
    },
    '.Select-placeholder': {
      opacity: 0.42,
      color: theme.palette.common.black,
    },
    '.Select-menu-outer': {
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[2],
      position: 'absolute',
      left: 0,
      top: `calc(100% + ${theme.spacing()}px)`,
      width: '100%',
      zIndex: '99999 !important',
      maxHeight: ITEM_HEIGHT * 4.5,
    },
    '.Select.is-focused:not(.is-open) > .Select-control': {
      boxShadow: 'none',
    },
    '.Select-menu': {
      maxHeight: ITEM_HEIGHT * 4.5,
      overflowY: 'auto',
    },
    '.Select-arrow-zone, .Select-clear-zone': {
      color: theme.palette.action.active,
      cursor: 'pointer',
      height: 19,
      width: 19,
      zIndex: 1,
      pointerEvents: 'none',
    },
    '.Select-arrow-zone > svg, .Select-clear-zone > svg': {
      position: 'relative',
      top: -2,
      right: 5,
    },
    // Only for screen readers. We can't use display none.
    '.Select-aria-only': {
      position: 'absolute',
      overflow: 'hidden',
      clip: 'rect(0 0 0 0)',
      height: 1,
      width: 1,
      margin: -1,
    },
    'div::-webkit-scrollbar': {
      minWidth: '1px',
      minHeight: '1px',
    },
    'div::-webkit-scrollbar-thumb': {
      borderRadius: '8px',
      border: '2px solid white',
      backgroundColor: 'rgba(0, 0, 0, .5)',
    },
    'div::-webkit-scrollbar:vertical': {
      width: '13px',
    },
    'div::-webkit-scrollbar:horizontal': {
      height: '13px',
    },
  },
}))
@withStyles(
  (theme) => ({
    ...styles(theme).root,
    clear: {
      '&:hover': {
        color: '#D0021B',
      },
    },
  }),
  { name: 'reduxFormMui' },
)
@withNamespaces(['common'], { wait: true })
@withOnMetaChange()
class RawTypeSelect extends React.PureComponent {
  static propTypes = {
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
  };
  static SelectWrapped = class extends React.PureComponent {
    defaultItemTemplate = ({ label }) => label;

    render() {
      const {
        t,
        classes,
        options,
        selectedValue,
        selectValue,
        updateisusa,
        itemTemplate: ItemTemplate = this.defaultItemTemplate,
        menuwidth,
        ...rest
      } = this.props;

      if (updateisusa !== undefined) {
        updateisusa(R.prop('value', this.props));
      }

      return (
        <ReactVirtualizedSelect
          menuContainerStyle={{
            marginTop: '-6px',
            zIndex: 9999,
            width: menuwidth ? menuwidth : '100%',
            borderBottomLeftRadius: '8px',
            borderBottomRightRadius: '8px',
            boxShadow: '0px 8px 16px 0px rgba(0, 0, 0, 0.20)',
          }}
          options={options}
          optionRenderer={({
            key,
            option: { id: optionId, value: optionValue, ...optionProps },
            style,
            selectValue: rvsSelectValue,
          }) => {
            const selected = selectedValue === optionValue;

            return (
              <MenuItem
                selected={selected}
                key={optionId || key}
                onClick={() => {
                  rvsSelectValue(optionValue);
                  // BUG: ReactVirtualizedSelect doesn't trigger onChange passed to it as expected
                  selectValue({ options, value: optionValue || '' });
                }}
                style={{
                  ...style,
                  boxSizing: 'border-box',
                  width: '100%',
                  fontWeight: selected ? 500 : 400,
                  zIndex: 9999,

                  // ✅ Flex for vertical centering
                  display: 'flex',
                  alignItems: 'center',

                  // wrapping
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',

                  // clamp to 2 lines
                  overflow: 'hidden',
                }}
              >
                <ItemTemplate {...optionProps} />
              </MenuItem>
            );
          }}
          optionHeight={56}
          simpleValue
          noResultsText={<Typography>{getLocalizedText(t, 'common:emptyState.noResultsFound', 'No results found')}</Typography>}
          arrowRenderer={({ isOpen }) =>
            isOpen ? <ArrowDropUp style={{ paddingLeft: '0px' }} /> : <ArrowDropDown style={{ paddingLeft: '0px' }} />
          }
          clearRenderer={() => <Clear className={classes.clear} onClick={() => selectValue({ options, value: '' })} />}
          {...rest}
        />
      );
    }
  };

  renderView() {
    const {
      input: {
        value: { options = [], value },
      },
      label,
      adornment: { position = 'start', component = null } = {},
      containerStyle = {},
    } = this.props;

    return (
      <Grid container spacing={1} style={containerStyle}>
        {label && (
          <Grid item xs={12}>
            <Typography variant="caption">{label}</Typography>
          </Grid>
        )}
        {position === 'start' && component && <Grid item>{component}</Grid>}
        <Grid
          item
          style={{
            margin: '0px 10px 0px 0px',
            overflow: 'hidden',
            wordWrap: 'break-word',
          }}
        >
          <Typography variant="body1">{switchProp('label', 'value', value, options) || '-'}</Typography>
        </Grid>
        {position === 'end' && component && <Grid item>{component}</Grid>}
      </Grid>
    );
  }

  renderEdit() {
    const {
      /* Field */
      input: {
        value: { options = [], value: selectedValue },
        onChange,
        onFocus,
        onBlur,
      },
      meta: { touched, error, warning },
      /* FormControl */
      fullWidth,
      required,
      /* InputLabel */
      label,
      shrink = true,
      /* FormHelperText */
      hasHelperText = true,
      helperText = null,
      /* Input */
      clearable = false,
      adornment: { position = 'start', component = null, width = null } = {},
      classes,
      disableUnderline = false,
      notApplicable = false,
      inputWidth = '100%',
      inputHeight = 'auto',
      ...rest
    } = this.props;

    return notApplicable ? (
      <Grid container spacing={1}>
        {label && (
          <Grid item xs={12}>
            <Typography variant="caption">{label}</Typography>
          </Grid>
        )}
        <Grid item xs={12}>
          <Typography variant="body1">-</Typography>
        </Grid>
      </Grid>
    ) : (
      <FormControl error={touched && !!error} fullWidth={fullWidth} required={required}>
        <ThemeProvider theme={defaultMaterialTheme}>
          {label && (
            <InputLabel htmlFor={label} shrink={shrink}>
              {label}
            </InputLabel>
          )}
          <Input
            disableUnderline={disableUnderline}
            inputComponent={RawTypeSelect.SelectWrapped}
            placeholder={getLocalizedText(this.props.t, 'common:placeholder.select', 'Select ...')}
            inputProps={{
              classes,
              clearable,
              options,
              selectedValue,
              selectValue: onChange,
              ...rest,
            }}
            style={{ width: inputWidth, whiteSpace: 'unset', wordBreak: 'break-word' }}
            value={selectedValue || ''}
            onFocus={onFocus}
            onBlur={onBlur.bind(null, { options, value: selectedValue })}
            {...{
              [`${position}Adornment`]: position && component && (
                <InputAdornment style={{ width }} position={position}>
                  {component}
                </InputAdornment>
              ),
            }}
            {...rest}
          />
          {hasHelperText && (
            <FormHelperText style={{ whiteSpace: 'pre' }}>
              {(touched && (error || warning)) || helperText}
            </FormHelperText>
          )}
        </ThemeProvider>
      </FormControl>
    );
  }

  render() {
    const { readonly } = this.props;

    return readonly ? this.renderView() : this.renderEdit();
  }
}

class TypeSelect extends React.PureComponent {
  render() {
    const { name, ...props } = this.props;

    return <Field name={name} component={RawTypeSelect} fullWidth {...props} />;
  }
}

const TypeSelectorStyles = (theme) => ({
  formControl: {
    width: '100%',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  selectContainer: {
    minWidth: 154,
    maxWidth: 'max-content',
    height: 10,
    display: 'flex',
    alignItems: 'center',
    padding: '12px',
    border: '1px solid #E5E5E7',
    borderRadius: 8,
    cursor: 'pointer',
    backgroundColor: '#ffffff',
    '&:hover': {
      borderColor: '#007AFF',
    },
  },
  selectContainerOffline: {
    minWidth: 194,
    height: 10,
    display: 'flex',
    alignItems: 'center',
    padding: '12px',
    border: '1px solid #E5E5E7',
    borderRadius: 8,
    cursor: 'pointer',
    backgroundColor: '#ffffff',
    '&:hover': {
      borderColor: '#007AFF',
    },
  },
  selectOpen: {
    borderColor: '#007AFF',
    boxShadow: '0 0 0 3px rgba(0, 122, 255, 0.1)',
  },
  selectedOption: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
  },
  optionText: {
    fontSize: 12,
    letterSpacing: '0.4px',
    fontWeight: 400,
    color: '#212121',
  },
  dropdown: {
    marginTop: 4,
    borderRadius: 8,
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
    border: '1px solid #E5E5E7',
    minWidth: 'max-content',
    width: '100%',
    maxHeight: 300,
    overflow: 'auto',
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    zIndex: 1000,
    backgroundColor: '#ffffff',
  },
  option: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 16px',
    cursor: 'pointer',
    // borderBottom: '1px solid #F2F2F7',
    '&:hover': {
      backgroundColor: '#F2F2F7',
    },
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  tooltip: {
    background: '#212121 0% 0% no-repeat padding-box',
    boxShadow: '0px 4px 16px #00000052',
    color: '#ffffff',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontSize: '12px',
    lineHeight: '16px',
    padding: '10px 12px',
    marginTop: 8,
    fontWeight: 400,
    letterSpacing: '0.5px',
    borderRadius: 8,
    maxWidth: 320,
    zIndex: 1300,
  },
  tooltipHeader: {
    fontWeight: 600,
    marginBottom: 8,
    fontSize: 14,
  },
  tooltipSection: {
    marginBottom: 12,
    '&:last-child': {
      marginBottom: 0,
    },
  },
  tooltipTitle: {
    fontWeight: 600,
    marginBottom: 4,
    display: 'flex',
    alignItems: 'center',
  },
  tooltipDescription: {
    opacity: 0.9,
    lineHeight: 1.3,
  },
  helpIcon: {
    marginLeft: 8,
    marginRight: 4,
    fontSize: 22,
    color: '#FFFFFF',
    cursor: 'pointer',
  },
  closeButton: {
    position: 'absolute',
    top: 8,
    right: 8,
    color: '#8E8E93',
    '&:hover': {
      color: '#ffffff',
    },
  },
  disabled: {
    cursor: 'default',
    opacity: 0.6,
  },
});

@withStyles(TypeSelectorStyles)
@withOnMetaChange()
class RawTypeSelector extends React.PureComponent {
  static propTypes = {
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
    label: PropTypes.string,
  };

  static defaultProps = {
    disabled: false,
    readonly: false,
    disableUnderline: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      showTooltip: false,
      tooltipAnchorEl: null,
    };
    this.selectRef = React.createRef();
  }

  getOptions = () => {
    const {
      input: {
        value: { options },
      },
    } = this.props;
    return options;
  };

  getSelectedOption = () => {
    const {
      input: {
        value: { value },
      },
    } = this.props;
    const options = this.getOptions();
    return (
      (Array.isArray(options) && options.find((option) => option.value === value)) ||
      (Array.isArray(options) && options.length > 0 && options[0]) || {
        label: getLocalizedText(this.props.t, 'common:placeholder.select', 'Select ...'),
        icon: null,
      }
    );
  };

  handleToggle = () => {
    if (this.props.disabled || this.props.readonly) return;

    this.setState((prevState) => ({
      open: !prevState.open,
    }));
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  handleSelect = (option) => {
    const {
      input: { onChange, value },
      updateValue,
    } = this.props;

    onChange({
      ...value,
      value: option.value,
      options: this.getOptions(),
    });
    this.handleClose();
    updateValue && updateValue(option.value);
  };

  handleTooltipToggle = (event) => {
    event.stopPropagation();
    this.setState((prevState) => ({
      showTooltip: !prevState.showTooltip,
      tooltipAnchorEl: prevState.showTooltip ? null : event.currentTarget,
    }));
  };

  handleTooltipClose = () => {
    this.setState({
      showTooltip: false,
      tooltipAnchorEl: null,
    });
  };

  renderTooltipContent = () => {
    const { classes } = this.props;

    return (
      <div>
        <IconButton className={classes.closeButton} size="small" onClick={this.handleTooltipClose}>
          <Close fontSize="small" />
        </IconButton>

        <div className={classes.tooltipHeader}>All media files will be unavailable during offline.</div>

        <div className={classes.tooltipSection}>
          <div className={classes.tooltipTitle}>⭕ Applicable:</div>
          <div className={classes.tooltipDescription}>
            The question can be responded without media file. During offline, we will continue to display the question.
          </div>
        </div>

        <div className={classes.tooltipSection}>
          <div className={classes.tooltipTitle}>❌ Not Applicable:</div>
          <div className={classes.tooltipDescription}>
            The question cannot be responded without media file. During offline, we will skip the question.
          </div>
        </div>
      </div>
    );
  };

  renderView() {
    const {
      input: {
        value: { value },
      },
      label,
      adornmentLabel: { position = 'start', component = null } = {},
      labelStyle = null,
    } = this.props;

    const selectedOption = this.getSelectedOption();

    return (
      <Grid container spacing={1}>
        {label && (
          <Grid item xs={12}>
            <Typography variant="caption">
              {position === 'start' && component && <span>{component}</span>}
              {label}
              {position === 'end' && component && <span>{component}</span>}
            </Typography>
          </Grid>
        )}
        <Grid item xs={12}>
          <div style={{ display: 'flex', alignItems: 'center', ...labelStyle }}>
            {selectedOption.icon}
            <Typography variant="body1" style={{ color: '#FFFFFF' }}>
              {selectedOption.label || '-'}
            </Typography>
          </div>
        </Grid>
      </Grid>
    );
  }

  renderEdit() {
    const { classes, label, disabled, readonly } = this.props;

    const { open, showTooltip, tooltipAnchorEl } = this.state;
    const selectedOption = this.getSelectedOption();
    const options = this.getOptions();
    const isOfflineSelector = label === 'Offline';

    const tooltipMessage = (
      <Typography
        style={{ fontFamily: 'Roboto', fontSize: '16px', lineHeight: '19px', letter: '0.5px', padding: '5px' }}
        color="inherit"
      >
        All media files will be unavailable during offline.
        <br />
        <br />
        ⭕ Applicable:
        <br />
        The question can be responded without media file. During offline, we will continue to display the question.
        <br />
        <br />
        ❌ Not Applicable:
        <br />
        The question cannot be responded without media file. During offline, we will skip the question.
        <br />
      </Typography>
    );

    return (
      <div className={classes.formControl}>
        {isOfflineSelector && (
          <InfoTooltipWrapper placement="top-end" title={tooltipMessage}>
            <InfoOutline className={classes.helpIcon} />
          </InfoTooltipWrapper>
        )}
        <Typography
          variant="body2"
          style={{
            color: '#FFFFFF',
            fontSize: '14px',
            lineHeight: '16px',
            fontWeight: 500,
            letterSpacing: '0.15px',
            marginRight: '8px',
          }}
        >
          {label}:
        </Typography>

        <ClickAwayListener onClickAway={this.handleClose}>
          <div style={{ position: 'relative' }}>
            <div
              ref={this.selectRef}
              className={`${isOfflineSelector ? classes.selectContainerOffline : classes.selectContainer} ${open ? classes.selectOpen : ''
                } ${disabled ? classes.disabled : ''}`}
              onClick={this.handleToggle}
              style={{ cursor: disabled || readonly ? 'default' : 'pointer' }}
            >
              <div className={classes.selectedOption}>
                <div style={{ marginRight: '8px' }}>{selectedOption.icon}</div>
                <Typography className={classes.optionText}>{selectedOption.label}</Typography>
              </div>
              {!readonly && !disabled && (
                <ArrowDropDown
                  style={{
                    color: '#212121',
                    transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.2s ease-in-out',
                  }}
                />
              )}
            </div>

            {open && !readonly && !disabled && (
              <Paper className={classes.dropdown}>
                {options.map((option) => (
                  <div key={option.id} className={classes.option} onClick={() => this.handleSelect(option)}>
                    <div style={{ marginRight: '8px' }}>{option.icon}</div>
                    <Typography className={classes.optionText}>{option.label}</Typography>
                  </div>
                ))}
              </Paper>
            )}
          </div>
        </ClickAwayListener>

        {/* Tooltip for Offline selector */}
        {isOfflineSelector && (
          <Popper
            open={showTooltip}
            anchorEl={tooltipAnchorEl}
            placement="right"
            modifiers={{
              offset: {
                enabled: true,
                offset: '0,10',
              },
            }}
            style={{ zIndex: 1300 }}
          >
            <ClickAwayListener onClickAway={this.handleTooltipClose}>
              <Paper className={classes.tooltip}>{this.renderTooltipContent()}</Paper>
            </ClickAwayListener>
          </Popper>
        )}
      </div>
    );
  }

  render() {
    return this.renderEdit();
  }
}

class TypeSelector extends React.PureComponent {
  render() {
    const { name, ...props } = this.props;
    return <Field name={name} component={RawTypeSelector} {...props} />;
  }
}

@withOnMetaChange()
class RawSwitch extends React.PureComponent {
  render() {
    const {
      input: { value: checked, onChange, onBlur, onFocus },
      variant = null,
      labelIcon = null,
      labelStyle = null,
      label,
      meta: { touched, error, warning },
      helperText = null,
      disabled = false,
      ...custom
    } = this.props;

    return (
      <FormControl error={touched && !!error} {...custom}>
        {variant ? (
          <Typography variant="caption" style={labelStyle}>
            {label} {labelIcon && <span> {labelIcon}</span>}
          </Typography>
        ) : (
          <FormLabel component="legend" style={labelStyle}>
            {label} {labelIcon && <span> {labelIcon}</span>}
          </FormLabel>
        )}

        <MuiSwitch
          aria-label={label}
          checked={checked}
          onChange={(e, switchChecked) => onChange(switchChecked)}
          onFocus={(e) => onFocus(e)}
          onBlur={onBlur.bind(null, checked)}
          disabled={disabled}
        />
        <FormHelperText style={{ whiteSpace: 'pre' }}>{(touched && (error || warning)) || helperText}</FormHelperText>
      </FormControl>
    );
  }
}

class Switch extends React.PureComponent {
  render() {
    const { name, ...props } = this.props;

    return <Field name={name} component={RawSwitch} fullWidth {...props} />;
  }
}

@withStyles({
  checkboxStyle: {
    '&&:hover': {
      backgroundColor: 'transparent',
    },
  },
})
@withOnMetaChange()
class RawCheckbox extends React.PureComponent {
  render() {
    const {
      input: { value: checked, onChange, onFocus, onBlur },
      label,
      /* InputLabel */
      shrink = true,
      meta: { touched, error, warning },
      helperText = null,
      styleCheckbox = null,
      disabled = false,
      classes,
      ...custom
    } = this.props;

    return (
      <FormControl error={touched && !!error} {...custom}>
        {label && (
          <InputLabel shrink={shrink} htmlFor={label}>
            {label}
          </InputLabel>
        )}
        <MuiCheckbox
          aria-label={label}
          checked={checked}
          className={classes.checkboxStyle}
          style={styleCheckbox}
          onChange={(e, checkBoxChecked) => onChange(checkBoxChecked)}
          onFocus={(e) => onFocus(e)}
          onBlur={onBlur.bind(null, checked)}
          disabled={disabled}
        />
        <FormHelperText style={{ whiteSpace: 'pre' }}>{(touched && (error || warning)) || helperText}</FormHelperText>
      </FormControl>
    );
  }
}

class Checkbox extends React.PureComponent {
  render() {
    const { name, ...props } = this.props;

    return <Field name={name} component={RawCheckbox} fullWidth {...props} />;
  }
}

@withOnMetaChange()
class RawCheckboxRightLabelGroup extends React.PureComponent {
  render() {
    const {
      input: { value: checked, onChange, onFocus, onBlur },
      label,
      required,
      hasHelperText = true,
      helperText = null,
      /* InputLabel */
      meta: { touched, error, warning },
      ...custom
    } = this.props;

    return (
      <FormControl error={touched && !!error} required={required} {...custom}>
        {
          <FormControlLabel
            control={
              <MuiCheckbox
                label={label}
                aria-label={label}
                checked={checked}
                onChange={(e, checkBoxChecked) => onChange(checkBoxChecked)}
                onFocus={(e) => onFocus(e)}
                onBlur={onBlur.bind(null, checked)}
              />
            }
            label={<Typography variant="body1">{label}</Typography>}
            labelplacement="end"
          />
        }
        {hasHelperText && (
          <FormHelperText style={{ whiteSpace: 'pre', marginTop: '-5px' }}>
            {(touched && (error || warning)) || helperText}
          </FormHelperText>
        )}
      </FormControl>
    );
  }
}

const radioStyle = (theme) => ({
  radio: {
    '&$checked': {
      color: '#FF5722',
    },
  },
  checked: {},
  description: {
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '16px',
    letterSpacing: '0.1px',
  },
});

class CheckboxRightLabelGroup extends React.PureComponent {
  render() {
    const { name, ...props } = this.props;

    return <Field name={name} component={RawCheckboxRightLabelGroup} fullWidth {...props} />;
  }
}
@withStyles(radioStyle, { index: 1 })
@withOnMetaChange()
class RawRadioGroup extends React.PureComponent {
  static propTypes = {
    readonly: PropTypes.bool,
  };

  renderView() {
    const {
      input: {
        value: { options, value },
      },
      label,
      labelStyle = null,
    } = this.props;

    const getLabel = Array.isArray(options) && options.length > 0 ? options.find(e => e.value === value) && options.find(e => e.value === value).label : value;

    return (
      <Grid container justify="flex-start" alignItems="flex-start">
        <Grid item>
          {/* <Typography variant='body1' style={style}>{switchProp('label', 'value', value, options)}</Typography> */}
          <Typography variant="caption" style={labelStyle}>
            {label}
          </Typography>
          <Typography variant="body1" style={{ marginTop: '6px' }}>
            {commonUtil.toTitleCase(getLabel)}
          </Typography>
        </Grid>
      </Grid>
    );
  }

  renderEdit() {
    const {
      classes,
      input: {
        value: { options = [], value },
        onChange,
        onBlur,
        onFocus,
      },
      label,
      meta: { touched, error, warning },
      row,
      hasHelperText = true,
      helperText = null,
      disabled = false,
      readonly,
      labelStyle = null,
      customPadding = '95px',
      customStyle = {},
      ...custom
    } = this.props;

    const disabledEdit = disabled;

    return (
      <FormControl component="fieldset" error={touched && !!error} {...custom}>
        <FormLabel component="legend" style={labelStyle}>
          {label}
        </FormLabel>
        <MuiRadioGroup
          aria-label={label}
          row={row}
          value={value || ''}
          onChange={(evt, value) => onChange({ options, value })}
          onFocus={(e) => onFocus(e)}
          onBlur={onBlur.bind(null, { options, value })}
          style={customStyle}
        >
          {options.map(
            (
              {
                id: optionKey,
                value: optionValue,
                label: optionLabel,
                description,
                disabled = disabledEdit,
                labelStyle = null,
                descriptionStyle = null,
                ...optionProps
              },
              index,
            ) => (
              <Box key={optionKey || optionValue} style={{ flexDirection: 'column' }}>
                <FormControlLabel
                  label={labelStyle ? <Typography style={labelStyle}>{optionLabel}</Typography> : optionLabel}
                  style={{ paddingRight: index === 0 ? customPadding : '0px' }}
                  value={optionValue}
                  control={<Radio classes={{ root: classes.radio, checked: classes.checked }} disabled={disabled} />}
                  {...optionProps}
                />
                {descriptionStyle ? (
                  <Typography style={descriptionStyle}>{description}</Typography>
                ) : (
                  <Typography variant="body2">{description}</Typography>
                )}
              </Box>
            ),
          )}
        </MuiRadioGroup>
        {hasHelperText && (
          <FormHelperText style={{ whiteSpace: 'pre' }}>{(touched && (error || warning)) || helperText}</FormHelperText>
        )}
      </FormControl>
    );
  }

  render() {
    const { readonly } = this.props;

    return readonly ? this.renderView() : this.renderEdit();
  }
}

class RadioGroup extends React.PureComponent {
  render() {
    const { name, ...props } = this.props;

    return <Field name={name} component={RawRadioGroup} fullWidth {...props} />;
  }
}

@withOnMetaChange()
class RawCheckboxGroup extends React.PureComponent {
  static propTypes = {
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
  };

  render() {
    const {
      input: {
        value: { options = [], checkeds = {} },
        onChange,
        onBlur,
        onFocus,
      },
      label,
      meta: { touched, error, warning },
      row,
      controlProps,
      hasHelperText = true,
      helperText = null,
      formGroupProps,
      disabled,
      readonly,
      customWidth = null,
      onCheckboxGroupChange,
      getOptionDisabled,
      ...custom
    } = this.props;

    return (
      <FormControl component="fieldset" error={touched && !!error} disabled={!!disabled || !!readonly} {...custom}>
        <FormLabel component="legend">{label}</FormLabel>
        <FormGroup row={row} {...formGroupProps}>
          <Grid container>
            {options.map(
              ({
                id: optionKey,
                value: optionValue,
                label: optionLabel,
                tooltiptext: optionTooltipText,
                disabled: optionDisabled,
                ...optionProps
              }) => (
                <Grid key={optionKey || optionValue} item style={{ width: customWidth }}>
                  <Grid container alignContent="flex-start" alignItems="center" spacing={0}>
                    <Grid item>
                      <FormControlLabel
                        label={
                          <Typography variant={'body1'} style={{ fontSize: '14px' }}>
                            {optionLabel}
                          </Typography>
                        }
                        control={
                          <MuiCheckbox
                            /* The group's own disabled/readonly must be part of this. MUI only
                               falls back to the FormControl's disabled state when this prop is
                               undefined, and `getOptionDisabled` returns an explicit `false` —
                               which re-enabled every checkbox in a read-only group that used it
                               (the alert dialog's Send to Care Team row, in view mode).
                               A checked option is never disabled by `getOptionDisabled`, so saved
                               data that breaks the rule (e.g. SMS + In-App) can still be cleared. */
                            disabled={
                              !!disabled ||
                              !!readonly ||
                              !!optionDisabled ||
                              !!(getOptionDisabled && !checkeds[optionValue] && getOptionDisabled(optionValue, checkeds))
                            }
                            disableRipple={true}
                            value={optionValue}
                            checked={!!checkeds[optionValue]}
                            onChange={(e) => {
                              const nextValue = {
                                options,
                                checkeds: { ...checkeds, [optionValue]: e.target.checked },
                              };
                              onChange(onCheckboxGroupChange ? onCheckboxGroupChange(nextValue, optionValue) || nextValue : nextValue);
                            }}
                            onFocus={(e) => onFocus(e)}
                            onBlur={onBlur.bind(null, { options, checkeds })}
                            {...controlProps}
                          />
                        }
                        {...optionProps}
                      />
                    </Grid>
                    {optionTooltipText && (
                      <Grid item style={{ marginLeft: -10 }}>
                        <InfoTooltip
                          placement="bottom-end"
                          title={
                            <React.Fragment>
                              <Typography
                                style={{
                                  fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
                                  fontSize: '12px',
                                  color: '#FFFFFF',
                                  lineHeight: '16px',
                                  letterSpacing: '0.5px',
                                  fontWeight: '400',
                                  padding: 0,
                                  margin: 0,
                                }}
                                color="inherit"
                              >
                                {optionTooltipText}
                              </Typography>
                            </React.Fragment>
                          }
                        >
                          <InfoOutline style={{ height: 18, width: 18, color: '#9E9E9E' }} />
                        </InfoTooltip>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              ),
            )}
          </Grid>
        </FormGroup>
        {hasHelperText && (
          <FormHelperText style={{ whiteSpace: 'pre' }}>{(touched && (error || warning)) || helperText}</FormHelperText>
        )}
      </FormControl>
    );
  }
}

class CheckboxGroup extends React.PureComponent {
  render() {
    const { name, ...props } = this.props;

    return <Field name={name} component={RawCheckboxGroup} fullWidth {...props} />;
  }
}

@withOnMetaChange()
class RawCheckboxLabel extends React.PureComponent {
  static propTypes = {
    readonly: PropTypes.bool,
  };

  renderView() {
    const { label, labelStyle = null } = this.props;

    return (
      <Grid container justify="center">
        <Grid item>
          <Typography variant="body1" style={labelStyle}>
            {label}
          </Typography>
        </Grid>
      </Grid>
    );
  }

  renderEdit() {
    const {
      input: { value, onChange, onBlur, onFocus },
      label,
      link = true,
      controlProps,
      readonly,
      labelStyle = null,
      cmConfig = null,
      ...custom
    } = this.props;

    return (
      <FormControlLabel
        label={
          <Typography variant="body1" style={labelStyle}>
            {label}
          </Typography>
        }
        htmlFor={link ? null : 'none'}
        control={
          <MuiCheckbox
            disableRipple={true}
            value={label}
            checked={!!value}
            onChange={(e) => {
              if (this.props.hasExistCMEnabled) {
                this.props.handleShowProgramValidationDialog('DUPLICATE_VITALS');
              } else {
                onChange(e.target.checked);
              }
            }}
            onFocus={(e) => onFocus(e)}
            onBlur={onBlur.bind(null, value)}
            {...controlProps}
          />
        }
        {...custom}
      />
    );
  }

  render() {
    const { readonly } = this.props;

    return readonly ? this.renderView() : this.renderEdit();
  }
}

class CheckboxLabel extends React.PureComponent {
  render() {
    const { name, ...props } = this.props;

    return <Field name={name} component={RawCheckboxLabel} {...props} />;
  }
}

@withStyles(radioStyle, { index: 1 })
@withOnMetaChange()
class RawRadioboxLabel extends React.PureComponent {
  static propTypes = {
    readonly: PropTypes.bool,
  };

  renderView() {
    const { label, labelStyle = null } = this.props;

    return (
      <Grid container justify="center">
        <Grid item>
          <Typography variant="body1" style={labelStyle}>
            {label}
          </Typography>
        </Grid>
      </Grid>
    );
  }

  renderEdit() {
    const {
      classes,
      input: { value, onChange, onBlur, onFocus },
      label,
      labelStyle = null,
      link = true,
      controlProps,
      controlValue,
      readonly,
      ...custom
    } = this.props;

    return (
      <FormControlLabel
        label={
          <Typography variant="body1" style={labelStyle}>
            {label}
          </Typography>
        }
        htmlFor={link ? null : 'none'}
        value={controlValue}
        control={
          <Radio
            classes={{ root: classes.radio, checked: classes.checked }}
            // disableRipple={true}
            // value={label}
            // checked={!!value}
            onChange={(e) => onChange(e.target.checked)}
            onFocus={(e) => onFocus(e)}
            onBlur={onBlur.bind(null, value)}
            {...controlProps}
          />
        }
        {...custom}
      />
    );
  }

  render() {
    const { readonly } = this.props;

    return readonly ? this.renderView() : this.renderEdit();
  }
}

class RadioboxLabel extends React.PureComponent {
  render() {
    const { name, ...props } = this.props;

    return <Field name={name} component={RawRadioboxLabel} {...props} />;
  }
}

@withStyles((theme) => ({ ...styles(theme).root }), { name: 'reduxFormMui' })
@withOnMetaChange()
class RawDatePicker extends React.PureComponent {
  static propTypes = {
    containerProps: PropTypes.shape({
      justify: PropTypes.string,
      alignItems: PropTypes.string,
      spacing: PropTypes.number,
    }),
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
  };

  renderView = () => {
    const infoAdormentValue = { infoAdornmentPosition: 'end', infoAdornmentComponent: null };
    const {
      input: { value },
      label,
      dateFormat = 'DD-MM-YYYY',
      invalidLabel = '-',
      containerProps,
      removeIcon = true,
      containerStyle = null,
      infoAdornment = infoAdormentValue,
      mode = 'create',
    } = this.props;
    const { infoAdornmentPosition, infoAdornmentComponent } = infoAdornment;

    return (
      <Grid container spacing={1} alignItems="center" {...containerProps} style={containerStyle}>
        {infoAdornmentPosition === 'start' && infoAdornmentComponent && (
          <Grid style={{ padding: 0, zIndex: 9 }} item xs>
            {infoAdornmentComponent}
          </Grid>
        )}
        <Grid item xs={infoAdornmentComponent ? 10 : 12}>
          <Typography variant="caption">{label}</Typography>
        </Grid>
        {infoAdornmentPosition === 'end' && infoAdornmentComponent && (
          <Grid style={{ padding: 0, zIndex: 9 }} item xs>
            {infoAdornmentComponent}
          </Grid>
        )}
        <Grid item>
          <Typography variant="body1">
            {R.ifElse(
              (v) => v.isValid(),
              (v) => v.format(dateFormat),
              R.always(invalidLabel),
            )(moment(value))}
          </Typography>
        </Grid>
        {!removeIcon && mode !== 'view' && (
          <Grid item>
            <CalendarIcon style={{ marginLeft: '16px' }} />
          </Grid>
        )}
      </Grid>
    );
  };

  renderEdit() {
    const infoAdormentValue = { infoAdornmentPosition: 'end', infoAdornmentComponent: null };
    // Check user's web browser
    const checkAgent = window.navigator.userAgent;
    const trident = checkAgent.indexOf('Trident/');
    let ieBrowser = false;
    if (trident > 0) {
      const rv = checkAgent.indexOf('rv:');
      const ie = parseInt(checkAgent.substring(rv + 3, checkAgent.indexOf('.', rv)), 10);
      ieBrowser = ie === 11;
    }
    const {
      input: { value, onChange, onBlur, onFocus },
      meta: { touched, error, warning },
      helperText = null,
      adornment: { position = 'end', Component = () => <img src={IconCalendar} style={{ marginRight: 2 }} /> } = {},
      infoAdornment = infoAdormentValue,
      dateFormat = 'DD-MMM-YYYY',
      invalidLabel = '',
      label = '',
      removeIcon = false,
      disablePast = false,
      additionalStyle = null,
      maxDate = new Date('2100-01-01'),
      isEndDate = false,
      inputLabelProps = {},
      placeholder = '',
      minDate = moment(new Date('1900-01-01')),
      isPeriod = false,
      ...rest
    } = this.props;
    const { infoAdornmentPosition, infoAdornmentComponent } = infoAdornment;

    const passedThroughProps = R.omit(['containerProps'], rest);
    const currentLanguage = getCurrentAppLanguage();
    const momentLocale = commonUtil.getMomentLocaleMap(currentLanguage);
    const cancelLabel = getLocalizedText(this.props.t, 'common:buttonLabels.cancel', 'Cancel');
    const okLabel = getLocalizedText(this.props.t, 'common:buttonLabels.ok', 'OK');

    return (
      <Grid container style={additionalStyle && { ...additionalStyle, marginTop: value ? 'auto' : '0px' }}>
        {infoAdornmentPosition === 'start' && infoAdornmentComponent && (
          <Grid style={{ padding: 0, zIndex: 9 }} item xs>
            {infoAdornmentComponent}
          </Grid>
        )}
        <Grid item xs={infoAdornmentComponent ? 10 : 12} style={{ padding: 0 }}>
          <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale={momentLocale}>
            <ThemeProvider theme={defaultMaterialTheme}>
              {isEndDate ? (
                <MuiDatePicker
                  value={value || null}
                  format={dateFormat}
                  invalidLabel={invalidLabel}
                  emptyLabel={invalidLabel}
                  label={label}
                  cancelLabel={cancelLabel}
                  okLabel={okLabel}
                  readOnly={true}
                  InputProps={{
                    disableUnderline: true,
                    [`${position}Adornment`]: position && Component && !removeIcon && (
                      <InputAdornment position={position}>
                        <Component style={{ color: 'rgba(0, 0, 0, 0.54)' }} />
                      </InputAdornment>
                    ),
                  }}
                />
              ) : (
                <MuiDatePicker
                  value={value || null}
                  onChange={(newValue) => {
                    onFocus(); // HACK: redux-form needs this to set 'visited' properly
                    onChange(newValue);
                    onBlur(newValue); // HACK: redux-form needs this to set 'touched' properly
                  }}
                  format={dateFormat}
                  invalidLabel={invalidLabel}
                  emptyLabel=""
                  InputLabelProps={inputLabelProps}
                  placeholder={placeholder}
                  label={label}
                  cancelLabel={cancelLabel}
                  okLabel={okLabel}
                  disablePast={!!disablePast}
                  error={touched && !!error}
                  minDate={isPeriod ? minDate.format(dateFormat) : minDate}
                  maxDate={maxDate}
                  helperText={(touched && (error || warning)) || helperText}
                  InputProps={{
                    [`${position}Adornment`]: position && Component && !removeIcon && (
                      <InputAdornment position={position}>
                        <Component style={{ color: 'rgba(0, 0, 0, 0.54)' }} />
                      </InputAdornment>
                    ),
                  }}
                  {...passedThroughProps}
                />
              )}
            </ThemeProvider>
          </MuiPickersUtilsProvider>
        </Grid>
        {infoAdornmentPosition === 'end' && infoAdornmentComponent && (
          <Grid style={{ padding: 0, zIndex: 9 }} item xs>
            {infoAdornmentComponent}
          </Grid>
        )}
      </Grid>
    );
  }

  render() {
    const { readonly } = this.props;

    return readonly ? this.renderView() : this.renderEdit();
  }
}

class DatePicker extends React.PureComponent {
  render() {
    const { name, ...props } = this.props;

    return <Field name={name} component={RawDatePicker} fullWidth {...props} />;
  }
}

@withStyles((theme) => ({ ...styles(theme).root }), { name: 'reduxFormMui' })
@withOnMetaChange()
class RawTimePicker extends React.PureComponent {
  static propTypes = {
    containerProps: PropTypes.shape({
      justify: PropTypes.string,
      alignItems: PropTypes.string,
      spacing: PropTypes.number,
    }),
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
  };

  state = {
    selectedTime: '',
    valueTime: '',
  };

  componentDidMount() {
    const time = this.getDefaultTime();
    this.setState({ selectedTime: time });
  }

  getDefaultTime = () => {
    const date = new Date();
    date.setHours(0, 0, 0); // default hour hand to 12 and minute hand to 0 min.
    return date;
  };

  renderView = () => {
    const {
      input: { value },
      label,
      timeFormat = 'HH:mm:ss',
      containerProps,
      removeIcon = false,
    } = this.props;

    return (
      <Grid container spacing={1} alignItems="center" {...containerProps}>
        <Grid item xs={12}>
          <Typography variant="caption">{label}</Typography>
        </Grid>
        <Grid item>{moment(value).format(timeFormat)}</Grid>
        <Grid item>{!removeIcon && <AlarmOn />}</Grid>
      </Grid>
    );
  };

  renderEdit() {
    const { selectedTime } = this.state;
    const {
      input: { value, onChange, onBlur, onFocus },
      label,
      meta: { touched, error, warning },
      helperText = null,
      adornment: {
        position = 'end',
        component: Component = () => (
          <IconButton>
            <AddAlarm />
          </IconButton>
        ),
      } = {},
      timeFormat = 'HH:mm:ss',
      useIconCalendar = false,
      readonly,
      classes,
      timeStyle = null,
      keyboard = false,
      autoOk = false,
      ampm = true,
      inputsdornmentstyle = null,
      placeholder = '',
      ...rest
    } = this.props;

    const passedThroughProps = R.omit(['containerProps'], rest);
    const currentLanguage = getCurrentAppLanguage();
    const dateFnsLocale = commonUtil.getDateFnsLocaleMap(currentLanguage);
    const momentLocale = commonUtil.getMomentLocaleMap(currentLanguage);
    const cancelLabel = getLocalizedText(this.props.t, 'common:buttonLabels.cancel', 'Cancel');
    const okLabel = getLocalizedText(this.props.t, 'common:buttonLabels.ok', 'OK');
    const resolvedAmPm = ampm;

    return (
      <Grid style={timeStyle}>
        {!keyboard ? (
          <MuiPickersUtilsProvider utils={LocalizedTimeDateFnsUtils} locale={dateFnsLocale} libInstance={momentLocale}>
            {!value ? (
              <ThemeProvider theme={defaultMaterialThemeTimePicker}>
                <MuiTimePicker
                  style={{ width: '100%' }}
                  value={selectedTime}
                  onChange={(newValue) => {
                    onFocus(); // HACK: redux-form needs this to set 'visited' properly
                    onChange(newValue);
                    onBlur(); // HACK: redux-form needs this to set 'touched' properly
                  }}
                  autoOk={autoOk}
                  ampm={resolvedAmPm}
                  cancelLabel={cancelLabel}
                  okLabel={okLabel}
                  label={label}
                  keyboardIcon={<AddAlarm fontSize="inherit" />}
                  format=" "
                  invalidLabel=" "
                  placeholder={placeholder}
                  error={touched && !!error}
                  helperText={(touched && (error || warning)) || helperText}
                  required={this.props.required || (touched && !!error)}
                  InputProps={
                    !keyboard && {
                      [`${position}Adornment`]: position && Component && (
                        <React.Fragment>
                          <div
                            style={{
                              fontFamily: 'Roboto',
                              fontSize: '16px',
                              fontWeight: '400',
                              lineHeight: '19px',
                              letterSpacing: '0.5px',
                              color: '#aaa',
                              position: 'absolute',
                              left: 0,
                            }}
                          >
                            {placeholder}
                          </div>
                          <InputAdornment style={{ marginLeft: '0px' }} position={position}>
                            {!useIconCalendar && (
                              <Component style={{ color: 'rgba(0, 0, 0, 0.54)', marginLeft: '20px' }} />
                            )}
                            {useIconCalendar && (
                              <img
                                src={IconCalendar}
                                style={{ marginRight: 2, color: 'rgba(0, 0, 0, 0.54)', marginLeft: '20px' }}
                              />
                            )}
                          </InputAdornment>
                        </React.Fragment>
                      ),
                      classes,
                    }
                  }
                />
              </ThemeProvider>
            ) : (
              <ThemeProvider theme={defaultMaterialThemeTimePicker}>
                <MuiTimePicker
                  value={value}
                  onChange={(newValue) => {
                    onFocus(); // HACK: redux-form needs this to set 'visited' properly
                    onChange(newValue);
                    onBlur(); // HACK: redux-form needs this to set 'touched' properly
                  }}
                  autoOk={autoOk}
                  ampm={resolvedAmPm}
                  cancelLabel={cancelLabel}
                  okLabel={okLabel}
                  label={label}
                  keyboardIcon={<AddAlarm fontSize="inherit" />}
                  format={timeFormat}
                  invalidLabel=""
                  placeholder={placeholder}
                  error={touched && !!error}
                  required={this.props.required || (touched && !!error)}
                  helperText={(touched && (error || warning)) || helperText}
                  InputProps={
                    !keyboard && {
                      [`${position}Adornment`]: position && Component && (
                        <InputAdornment position={position} style={inputsdornmentstyle}>
                          {!useIconCalendar && (
                            <Component style={{ color: 'rgba(0, 0, 0, 0.54)', marginLeft: '20px' }} />
                          )}
                          {useIconCalendar && (
                            <img
                              src={IconCalendar}
                              style={{ marginRight: 2, color: 'rgba(0, 0, 0, 0.54)', marginLeft: '20px' }}
                            />
                          )}
                        </InputAdornment>
                      ),
                      classes,
                    }
                  }
                  {...passedThroughProps}
                />
              </ThemeProvider>
            )}
          </MuiPickersUtilsProvider>
        ) : (
          <MuiPickersUtilsProvider utils={LocalizedTimeDateFnsUtils} locale={dateFnsLocale} libInstance={momentLocale}>
            <ThemeProvider theme={defaultMaterialTheme}>
              <KeyboardTimePicker
                value={value}
                onChange={(newValue) => {
                  onFocus();
                  onChange(newValue);
                  onBlur();
                }}
                mask="__:__"
                autoOk={autoOk}
                ampm={resolvedAmPm}
                cancelLabel={cancelLabel}
                okLabel={okLabel}
                label={label}
                keyboardIcon={<AddAlarm fontSize="inherit" />}
                format={timeFormat}
                invalidLabel=""
                error={touched && !!error}
                required={this.props.required || (touched && !!error)}
                helperText={(touched && (error || warning)) || helperText}
                InputProps={{ disableUnderline: false }}
                {...passedThroughProps}
              />
            </ThemeProvider>
          </MuiPickersUtilsProvider>
        )}
      </Grid>
    );
  }

  render() {
    const { readonly } = this.props;

    return readonly ? this.renderView() : this.renderEdit();
  }
}

class TimePicker extends React.PureComponent {
  render() {
    const { name, ...props } = this.props;

    return <Field name={name} component={RawTimePicker} fullWidth {...props} />;
  }
}

const RangeSliderWithTooltip = createSliderWithTooltip(Range);
@withOnMetaChange()
class RawRangeSlider extends React.PureComponent {
  render() {
    const {
      input,
      label,
      meta: { touched, error, warning },
      helperText = null,
      ...custom
    } = this.props;

    return (
      <FormControl component="fieldset" error={touched && !!error} {...custom}>
        <FormLabel component="legend">{label}</FormLabel>
        <RangeSliderWithTooltip
          min={0}
          max={100}
          /* allowCross={false} BUGGY: handles will be collapsed when one of them is adjusted */
          {...input}
        />
        <FormHelperText style={{ whiteSpace: 'pre' }}>{(touched && (error || warning)) || helperText}</FormHelperText>
      </FormControl>
    );
  }
}

class RangeSlider extends React.PureComponent {
  render() {
    const { name, ...props } = this.props;

    return <Field name={name} component={RawRangeSlider} fullWidth {...props} />;
  }
}

class RawSingle extends React.PureComponent {
  static propTypes = {
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
  };

  state = {
    metas: R.pipe(
      R.filter(({ ignoreMeta }) => !ignoreMeta),
      R.pipe(
        R.map(({ name }) => [name, R.clone(defaultMeta)]),
        R.fromPairs,
      ),
    )(R.pathOr([], ['template', 'components'], this.props)),
  };

  render() {
    const { metas } = this.state;
    const {
      name: compositeName,
      index,
      removeSpace,
      template: { label, containerProps, wrapper: Wrapper, components, remove = {} },
      showBtnRemove = true,
      onRemove,
      disabled: singleDisabled,
      readonly: singleReadonly,
      onMetaChange: onSingleMetaChange,
      style,
      meta: { form },
      label: labelT,
      ...rest
    } = this.props;
    const globalProfileForm = form === 'globalProfile';

    return (
      <ReactHoverObserver>
        {({ isHovering }) => (
          <div>
            <Wrapper
              style={{ ...style, position: 'relative', marginRight: removeSpace }}
              isHovering={!singleDisabled && !singleReadonly && isHovering}
              meta={reduceMetas(metas)}
            >
              <Grid container {...containerProps}>
                {label ||
                  (labelT &&
                    (_.isString(label || labelT) ? (
                      <Grid item xs={12}>
                        <Typography variant="caption">
                          {label || labelT} {index + 1}
                        </Typography>
                      </Grid>
                    ) : null))}
                {components.map(({ name, component: Component, colSpans, injectWithIndex, ignoreMeta, ...props }) => {

                  return (
                    <Grid key={name} item xs {...colSpans}>
                      <Component
                        name={`${compositeName}.${name}`}
                        disabled={!!singleDisabled}
                        readonly={!!singleReadonly}
                        {...props}
                        {...(injectWithIndex ? injectWithIndex(index)(rest) : {})}
                        /* NOTE: onMetaChange should be destructured above or put as last here
                        since this component can receive onMetaChange
                      */
                        {...(ignoreMeta
                          ? {}
                          : {
                            onMetaChange: (meta) =>
                              this.setState(({ metas: prevMetas }) => {
                                const nextMetas = update(prevMetas, { [name]: { $set: meta } });
                                const singleMeta = reduceMetas(nextMetas);
                                onSingleMetaChange && onSingleMetaChange(singleMeta);
                                return { metas: nextMetas };
                              }),
                          })}
                      />
                    </Grid>
                  );
                })}
              </Grid>
              {!singleDisabled &&
                !singleReadonly &&
                !globalProfileForm &&
                showBtnRemove &&
                isHovering &&
                (({ icon: RemoveIcon = DeleteForever, injectWithIndex, style: removeStyle, ...removeProps }) => {
                  const { style: injectedStyle, ...injectedProps } = injectWithIndex
                    ? injectWithIndex(index)(rest)
                    : {};
                  return (
                    <div
                      onClick={onRemove}
                      style={{
                        width: '40px',
                        height: '40px',
                        position: 'absolute',
                        boxShadow: 'none',
                        top: '10%',
                        right: 10,
                        cursor: 'pointer',
                        ...removeStyle,
                        ...injectedStyle,
                      }}
                      {...removeProps}
                      {...injectedProps}
                    >
                      <RemoveIcon style={{ fontSize: 25, color: '#9E9E9E' }} />
                    </div>
                  );
                })(remove)}
            </Wrapper>
          </div>
        )}
      </ReactHoverObserver>
    );
  }
}

class RawMultiple extends React.PureComponent {
  static propTypes = {
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
  };

  state = {
    /* NOTE: Do not use R.repeat or R.always,
      since both approaches will return array of same referenced elements
    */
    metas: R.times(() => R.clone(defaultMeta), R.pathOr(0, ['fields', 'length'], this.props)),
  };

  triggerMetaChange(metas) {
    const { onMetaChange: onMultipleMetaChange } = this.props;
    onMultipleMetaChange && onMultipleMetaChange(reduceMetas(metas));
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const noOfSingles = this.props.fields.length;
    const nextNoOfSingles = nextProps.fields.length;

    // Added
    if (noOfSingles < nextNoOfSingles) {
      this.setState(({ metas: prevMetas }) => {
        const nextMetas = R.append(R.clone(defaultMeta), prevMetas);
        this.triggerMetaChange(nextMetas);
        return { metas: nextMetas };
      });
    }

    // Removed
    if (noOfSingles > nextNoOfSingles) {
      this.setState(({ metas: prevMetas }) => {
        const nextMetas = R.remove(this.removeIndex, 1, prevMetas);
        this.triggerMetaChange(nextMetas);
        return { metas: nextMetas };
      });
    }
  }

  render() {
    const {
      // NOTE: Take note that reduxForm also injects its own 'meta' via FieldArray
      fields,
      template,
      initialValues,
      disabled: multipleDisabled,
      readonly: multipleReadonly,
      wrapperMaxHeight = 'none',
      gutterBottom = 0,
      removeSpace = 20,
      onMetaChange: onMultipleMetaChange,
      ...rest
    } = this.props;

    // console.log('%cMultiple', 'font-size: 12px; color: #00b3b3', this.state, this.props);
    const setTemplate = { ...template };

    console.log('>> RawMultiple: ', this.props);

    return (
      <Grid container>
        <Grid
          item
          xs={12}
          style={{
            maxHeight: wrapperMaxHeight + (multipleReadonly ? 20 : 0),
            overflowY: 'scroll',
            overflowX: 'hidden',
          }}
        >
          <ReactCSSTransitionGroup transitionName="multiple" transitionEnterTimeout={500} transitionLeaveTimeout={300}>
            {fields.map((field, index) => {
              const { id } = fields.get(index);
              /* NOTE: Do not use index as React element key. We encountered few expected problems:
                - Component is re-rendered & possibly losing its state though it doesn't need to
                - Meta change is triggered to the wrong component
              */
              return (
                <Grid key={id} container style={{ marginTop: index > 0 ? gutterBottom : 0 }}>
                  <Grid item xs={12}>
                    <RawSingle
                      name={field}
                      index={index}
                      removeSpace={removeSpace}
                      template={setTemplate}
                      showBtnRemove={fields.length > 1}
                      onRemove={() => {
                        this.removeIndex = index;
                        fields.remove(index);
                      }}
                      disabled={!!multipleDisabled}
                      readonly={!!multipleReadonly}
                      {...rest}
                      /* NOTE: onMetaChange should be destructured above or put as last here
                        since this component can receive onMetaChange
                      */
                      onMetaChange={(meta) =>
                        this.setState(({ metas: prevMetas }, { fields: prevFields }) => {
                          /* TRICKY: redux-form fires a series of
                            UNREGISTERED_FIELD after ARRAY_REMOVE
                            which causes onMetaChange to trigger on removed Single
                            --> Ignore if index doesn't exist.
                            Donot use fields from the outer scope
                            since it will retain the original length
                            (before removing item) due to closure
                          */
                          if (index > prevFields.length - 1) return {};
                          const nextMetas = update(prevMetas, { [index]: { $set: meta } });
                          this.triggerMetaChange(nextMetas);
                          return { metas: nextMetas };
                        })
                      }
                    />
                  </Grid>
                </Grid>
              );
            })}
          </ReactCSSTransitionGroup>
        </Grid>
        {(() => {
          const {
            add: { component: Component, colSpans, onClick, inject, style, ...props },
          } = template;
          const { onClick: injectedOnClick, ...injectedProps } = inject ? inject(rest) : {};

          return (
            !multipleReadonly && (
              <Grid item xs {...colSpans}>
                <Component
                  style={{
                    ...style,
                    width: R.when(
                      R.endsWith('%'),
                      (widthInPercentage) => `calc(${widthInPercentage} - ${removeSpace}px)`,
                    )(R.prop('width', style)),
                  }}
                  disabled={!!multipleDisabled}
                  readonly={!!multipleReadonly}
                  {...props}
                  {...injectedProps}
                  onClick={(e) => {
                    onClick && onClick(e);
                    injectedOnClick && injectedOnClick(e);
                    fields.push({ id: uuidv4(), ...(R.clone(initialValues) || {}) });
                  }}
                />
              </Grid>
            )
          );
        })()}
      </Grid>
    );
  }
}

class Multiple extends React.PureComponent {
  render() {
    const { name, ...props } = this.props;

    return <FieldArray name={name} component={RawMultiple} {...props} />;
  }
}

class RawSingle2 extends React.PureComponent {
  static propTypes = {
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
  };

  state = {
    metas: R.pipe(
      R.filter(({ ignoreMeta }) => !ignoreMeta),
      R.pipe(
        R.map(({ name }) => [name, R.clone(defaultMeta)]),
        R.fromPairs,
      ),
    )(R.pathOr([], ['template', 'components'], this.props)),
  };

  render() {
    const { metas } = this.state;
    const {
      name: compositeName,
      index,
      removeSpace,
      template: { label, containerProps, wrapper: Wrapper, components, remove = {} },
      showBtnRemove = true,
      onRemove,
      disabled: singleDisabled,
      readonly: singleReadonly,
      onMetaChange: onSingleMetaChange,
      style,
      meta: { form },
      ...rest
    } = this.props;
    const globalProfileForm = form === 'globalProfile';

    return (
      <ReactHoverObserver>
        {({ isHovering }) => (
          <div>
            <Wrapper
              style={{ ...style, position: 'relative', marginRight: removeSpace }}
              isHovering={!singleDisabled && !singleReadonly && isHovering}
              meta={reduceMetas(metas)}
            >
              <Grid container {...containerProps}>
                {label &&
                  (_.isString(label) ? (
                    <Grid item xs={12}>
                      <Typography variant="caption">
                        {label} {index + 1}
                      </Typography>
                    </Grid>
                  ) : null)}
                {components.map(({ name, component: Component, colSpans, injectWithIndex, ignoreMeta, ...props }) => (
                  <Grid key={name} item xs {...colSpans}>
                    <Component
                      name={`${compositeName}.${name}`}
                      disabled={!!singleDisabled}
                      readonly={!!singleReadonly}
                      {...props}
                      {...(injectWithIndex ? injectWithIndex(index)(rest) : {})}
                      /* NOTE: onMetaChange should be destructured above or put as last here
                        since this component can receive onMetaChange
                      */
                      {...(ignoreMeta
                        ? {}
                        : {
                          onMetaChange: (meta) =>
                            this.setState(({ metas: prevMetas }) => {
                              const nextMetas = update(prevMetas, { [name]: { $set: meta } });
                              const singleMeta = reduceMetas(nextMetas);
                              onSingleMetaChange && onSingleMetaChange(singleMeta);
                              return { metas: nextMetas };
                            }),
                        })}
                    />
                  </Grid>
                ))}
              </Grid>
              {!singleDisabled &&
                !singleReadonly &&
                !globalProfileForm &&
                showBtnRemove &&
                isHovering &&
                (({ icon: RemoveIcon = DeleteForever, injectWithIndex, style: removeStyle, ...removeProps }) => {
                  const { style: injectedStyle, ...injectedProps } = injectWithIndex
                    ? injectWithIndex(index)(rest)
                    : {};
                  return (
                    <div
                      onClick={onRemove}
                      style={{
                        width: '40px',
                        height: '40px',
                        position: 'absolute',
                        boxShadow: 'none',
                        top: '10%',
                        right: 10,
                        cursor: 'pointer',
                        ...removeStyle,
                        ...injectedStyle,
                      }}
                      {...removeProps}
                      {...injectedProps}
                    >
                      <RemoveIcon style={{ fontSize: 25, color: '#9E9E9E' }} />
                    </div>
                  );
                })(remove)}
            </Wrapper>
          </div>
        )}
      </ReactHoverObserver>
    );
  }
}

class RawMultiple2 extends React.PureComponent {
  static propTypes = {
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
  };

  state = {
    /* NOTE: Do not use R.repeat or R.always,
      since both approaches will return array of same referenced elements
    */
    metas: R.times(() => R.clone(defaultMeta), R.pathOr(0, ['fields', 'length'], this.props)),
  };

  triggerMetaChange(metas) {
    const { onMetaChange: onMultipleMetaChange } = this.props;
    onMultipleMetaChange && onMultipleMetaChange(reduceMetas(metas));
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const noOfSingles = this.props.fields.length;
    const nextNoOfSingles = nextProps.fields.length;

    // Added
    if (noOfSingles < nextNoOfSingles) {
      this.setState(({ metas: prevMetas }) => {
        const nextMetas = R.append(R.clone(defaultMeta), prevMetas);
        this.triggerMetaChange(nextMetas);
        return { metas: nextMetas };
      });
    }

    // Removed
    if (noOfSingles > nextNoOfSingles) {
      this.setState(({ metas: prevMetas }) => {
        const nextMetas = R.remove(this.removeIndex, 1, prevMetas);
        this.triggerMetaChange(nextMetas);
        return { metas: nextMetas };
      });
    }
  }

  render() {
    const {
      // NOTE: Take note that reduxForm also injects its own 'meta' via FieldArray
      fields,
      template,
      initialValues,
      disabled: multipleDisabled,
      readonly: multipleReadonly,
      wrapperMaxHeight = 'none',
      gutterBottom = 0,
      removeSpace = 20,
      onMetaChange: onMultipleMetaChange,
      ...rest
    } = this.props;

    // console.log('%cMultiple', 'font-size: 12px; color: #00b3b3', this.state, this.props);

    return (
      <Grid container>
        <Grid
          item
          xs={12}
          style={{
            maxHeight: wrapperMaxHeight + (multipleReadonly ? 20 : 0),
            overflowY: 'scroll',
            overflowX: 'hidden',
          }}
        >
          <ReactCSSTransitionGroup transitionName="multiple" transitionEnterTimeout={500} transitionLeaveTimeout={300}>
            {fields.map((field, index) => {
              const { id } = fields.get(index);
              /* NOTE: Do not use index as React element key. We encountered few expected problems:
                - Component is re-rendered & possibly losing its state though it doesn't need to
                - Meta change is triggered to the wrong component
              */
              return (
                <Grid key={id} container style={{ marginTop: index > 0 ? gutterBottom : 0 }}>
                  <Grid item xs={12}>
                    <RawSingle2
                      name={field}
                      index={index}
                      removeSpace={removeSpace}
                      template={template}
                      showBtnRemove={fields.length > 1}
                      onRemove={() => {
                        this.removeIndex = index;
                        fields.remove(index);
                      }}
                      disabled={!!multipleDisabled}
                      readonly={!!multipleReadonly}
                      {...rest}
                      /* NOTE: onMetaChange should be destructured above or put as last here
                        since this component can receive onMetaChange
                      */
                      onMetaChange={(meta) =>
                        this.setState(({ metas: prevMetas }, { fields: prevFields }) => {
                          /* TRICKY: redux-form fires a series of
                            UNREGISTERED_FIELD after ARRAY_REMOVE
                            which causes onMetaChange to trigger on removed Single
                            --> Ignore if index doesn't exist.
                            Donot use fields from the outer scope
                            since it will retain the original length
                            (before removing item) due to closure
                          */
                          if (index > prevFields.length - 1) return {};
                          const nextMetas = update(prevMetas, { [index]: { $set: meta } });
                          this.triggerMetaChange(nextMetas);
                          return { metas: nextMetas };
                        })
                      }
                    />
                  </Grid>
                </Grid>
              );
            })}
          </ReactCSSTransitionGroup>
        </Grid>
        {(() => {
          const {
            add: { component: Component, colSpans, onClick, inject, style, ...props },
          } = template;
          const { onClick: injectedOnClick, ...injectedProps } = inject ? inject(rest) : {};

          return (
            !multipleReadonly && (
              <Grid item xs {...colSpans}>
                <Component
                  style={{
                    ...style,
                    width: R.when(
                      R.endsWith('%'),
                      (widthInPercentage) => `calc(${widthInPercentage} - ${removeSpace}px)`,
                    )(R.prop('width', style)),
                  }}
                  disabled={!!multipleDisabled}
                  readonly={!!multipleReadonly}
                  {...props}
                  {...injectedProps}
                  onClick={(e) => {
                    onClick && onClick(e);
                    injectedOnClick && injectedOnClick(e);
                    fields.push({ id: uuidv4(), ...(R.clone(initialValues) || {}) });
                  }}
                />
              </Grid>
            )
          );
        })()}
      </Grid>
    );
  }
}

class Multiple2 extends React.PureComponent {
  render() {
    const { name, ...props } = this.props;

    return <FieldArray name={name} component={RawMultiple2} {...props} />;
  }
}

// TODO: Consider support dynamic changes to body.sections
@withStyles({
  resetContainer: {
    width: '100%',
    margin: 0,
  },
})
class RawView extends React.PureComponent {
  static propTypes = {
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string.isRequired,
    body: PropTypes.object.isRequired,
    active: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
    onMetaChange: PropTypes.func,
  };

  state = {
    metas: R.pipe(
      R.pathOr([], ['body', 'sections']),
      R.map(({ id: sectionId }) => [`section-${sectionId}`, R.clone(defaultMeta)]),
      R.fromPairs,
    )(this.props),
  };

  // shouldComponentUpdate(nextProps, nextState) {
  //   const diffState = shallowDiff(this.state, nextState);
  //   const diffProps = shallowDiff(this.props, nextProps);
  //   diffState && console.log('%cRawView - diffState', 'font-size: 12px; color: lightcoral', diffState, this.state, nextState);
  //   diffProps && console.log('%cRawView - diffProps', 'font-size: 12px; color: lightcoral', diffProps, this.props, nextProps);
  //   return !!diffState || !!diffProps;
  // }

  reportMetaChange = (metas) => {
    const { onMetaChange: onViewMetaChange } = this.props;
    const viewMeta = reduceMetas(metas);
    onViewMetaChange && onViewMetaChange(viewMeta);
  };

  changeMeta = memoize((name) => (meta) =>
    this.setState(({ metas: prevMetas }) => {
      const nextMetas = update(prevMetas, { [name]: { $set: meta } });
      this.reportMetaChange(nextMetas);
      return { metas: nextMetas };
    }),
  );

  render() {
    const {
      name,
      body: { containerProps = {}, sections = [] } = {},
      active,
      disabled: viewDisabled,
      classes,
      ...rest
    } = this.props;

    const passedThroughProps = R.omit(['id', 'onMetaChange', 'classes'], rest);

    return (
      <FormSection name={name}>
        <Grid container className={classes.resetContainer} justify="center" spacing={2} {...containerProps}>
          {R.addIndex(R.map)(({ id: sectionId, inject, style, ...props }, index) => (
            <Section
              key={sectionId}
              {...passedThroughProps}
              {...props}
              {...(inject ? inject(passedThroughProps) : {})}
              /* NOTE: Only active view should have all controls disabled
                  since the view control is disabled and won't be able to switch to other views.
                  We also overrides the disability by Section */
              disabled={!!viewDisabled && active}
              style={{ marginTop: index === 0 ? 0 : R.pathOr(0, ['marginTop'], style), ...style }}
              onMetaChange={this.changeMeta(`section-${sectionId}`)}
            />
          ))(sections)}
        </Grid>
      </FormSection>
    );
  }
}

// @withTheme()
class RawViews extends React.PureComponent {
  static propTypes = {
    views: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        name: PropTypes.string.isRequired,
        body: PropTypes.object.isRequired,
      }),
    ).isRequired,
    activeIndex: PropTypes.number.isRequired,
    onActiveIndexChange: PropTypes.func,
    // theme: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
    springConfig: PropTypes.object,
    onMetasChange: PropTypes.func,
  };

  state = {
    metas: R.pipe(
      R.pathOr([], ['views']),
      R.map(({ name: viewName }) => [viewName, R.clone(defaultMeta)]),
      R.fromPairs,
    )(this.props),
  };

  // shouldComponentUpdate(nextProps, nextState) {
  //   const diffState = shallowDiff(this.state, nextState);
  //   const diffProps = shallowDiff(this.props, nextProps);
  //   diffState && console.log('%cRawViews - diffState', 'font-size: 12px; color: lightcoral', diffState, this.state, nextState);
  //   diffProps && console.log('%cRawViews - diffProps', 'font-size: 12px; color: lightcoral', diffProps, this.props, nextProps);
  //   return !!diffState || !!diffProps;
  // }

  reportMetaChange = (metas) => {
    const { onMetasChange: onViewsMetasChange } = this.props;
    const viewsMetas = metas;
    onViewsMetasChange && onViewsMetasChange(viewsMetas);
  };

  changeMeta = memoize((name) => (meta) =>
    this.setState(({ metas: prevMetas }) => {
      const nextMetas = update(prevMetas, { [name]: { $set: meta } });
      this.reportMetaChange(nextMetas);
      return { metas: nextMetas };
    }),
  );

  UNSAFE_componentWillReceiveProps({ views: nextViews }) {
    nextViews !== this.props.views &&
      ((views) => {
        const { metas } = this.state;
        const nextMetas = {};
        R.forEach(({ name: viewName }) => {
          nextMetas[viewName] = metas[viewName] || R.clone(defaultMeta);
        })(views);
        this.reportMetaChange(nextMetas);
        this.setState({ metas: nextMetas });
      })(nextViews);
  }

  /* NOTE: SwipeableViews measures the active slide from inside its own render, so it always
     reads the height of the content it is about to replace. A slide whose content grew stays
     clipped (slideStyle sets overflowY: hidden) until some later render happens to re-measure.
     Re-measure after commit, once the new content has actually been laid out. */
  componentDidUpdate() {
    if (!this.props.animateHeight) return;

    clearTimeout(this.heightUpdateTimer);
    this.heightUpdateTimer = setTimeout(() => {
      this.swipeableActions && this.swipeableActions.updateHeight();
    }, 0);
  }

  componentWillUnmount() {
    clearTimeout(this.heightUpdateTimer);
  }

  setSwipeableActions = (actions) => {
    this.swipeableActions = actions;
  };

  render() {
    const {
      views,
      activeIndex,
      onActiveIndexChange,
      theme = {},
      springConfig,
      animateHeight = false,
      ...rest
    } = this.props;

    // console.log('%crender RawViews', 'font-size: 12px; color: #00b3b3', this.state, this.props);
    const passedThroughProps = R.omit(['onMetasChange', 'classes'], rest);

    return (
      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={activeIndex}
        onChangeIndex={onActiveIndexChange}
        disabled={R.pathOr(false, ['disabled'], rest)} // NOTE: For mobile
        springConfig={{
          duration: '1s',
          easeFunction: 'cubic-bezier(0.15, 0.3, 0.25, 1)',
          delay: '0s',
          ...springConfig,
        }}
        animateHeight={animateHeight}
        action={this.setSwipeableActions}
      >
        {R.addIndex(R.map)(({ inject, ...props }, index) => (
          <RawView
            key={R.path(['id'], props) || R.path(['name'], props)}
            {...passedThroughProps}
            {...props}
            {...(inject ? inject(rest) : {})}
            active={index === activeIndex}
            onMetaChange={this.changeMeta(R.path(['name'], props))}
          />
        ))(views)}
      </SwipeableViews>
    );
  }
}

@withStyles({
  tabs: {
    minHeight: 0,
  },
  tab: {
    maxWidth: 'none',
    height: 'auto',
    minWidth: '225px',
    padding: '6px 22px 6px 10px',
  },
  subHeading: {
    top: 8,
    right: '-12px',
  },
  radio: {
    '&$checked': {
      color: '#FF5722',
    },
  },
  checked: {},
})
class RawBars extends React.PureComponent {
  static propTypes = {
    bars: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        name: PropTypes.string.isRequired,
        header: PropTypes.object.isRequired,
      }),
    ).isRequired,
    ignoreMetas: PropTypes.arrayOf(PropTypes.string),
    metas: PropTypes.object.isRequired,
    activeIndex: PropTypes.number.isRequired,
    onActiveIndexChange: PropTypes.func,
    appBarProps: PropTypes.object,
    tabsProps: PropTypes.object,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
    classes: PropTypes.object,
  };

  render() {
    const {
      // bars,
      activeIndex,
      onActiveIndexChange,
      appBarProps,
      tabsProps,
      disabled: barsDisabled,
      readonly: barsReadonly,
      filterBars = false,
      filterValue = null,
      classes,
      isRadioStyle,
      radioControlValue,
      ...rest
    } = this.props;
    let { bars } = this.props;
    if (filterBars) {
      bars = bars.filter((f) => f.value === filterValue);
    }

    // console.log('%crender Tabs Bar', 'font-size: 12px; color: #00b3b3', this.props);

    const passedThroughProps = R.omit(['classes'], rest);
    const { fullWidth: tabsFullWidth, ...sanitizedTabsProps } = tabsProps || {};
    const handleRadioStyleTabChange = (event, value) => {
      onActiveIndexChange(value);
      const nextCategory = R.path([value, 'name'], bars);
      if (nextCategory !== 'oneTime' && nextCategory !== 'advanced') return;
      /* `handleSelectCategory` already lifts this into the owning component's state, which
         comes back down as `selectedValue`. It used to also be mirrored into sessionStorage —
         global, and outliving the dialog — so a category chosen for one vital leaked into the
         next vital's dialog and was read in preference to that dialog's own value. */
      this.props.handleSelectCategory(nextCategory);
    };

    if (isRadioStyle) {
      return (
        <AppBar position="static" {...appBarProps}>
          <MuiRadioGroup value={radioControlValue}>
            <MuiTabs
              className={classes.tabs}
              value={activeIndex}
              onChange={handleRadioStyleTabChange}
              variant={(barsReadonly || tabsFullWidth) && bars.length <= 3 ? 'fullWidth' : 'scrollable'}
              scrollButtons="auto"
              TabIndicatorProps={{
                style: {
                  backgroundColor: '#FF5722',
                },
              }}
              {...sanitizedTabsProps}
            >
              {R.map(
                ({
                  id: tabId,
                  name: tabName,
                  header: { components: headerComponents = [], containerProps: headerContainerProps },
                }) => (
                  <MuiTab
                    key={tabId || tabName}
                    className={classes.tab}
                    disabled={!!barsDisabled}
                    label={
                      <FormSection name={tabName}>
                        <Grid className={classes.subHeading}>
                          <Grid container justify="center" alignItems="center" spacing={0} {...headerContainerProps}>
                            {headerComponents.map(
                              ({
                                id: headerKey,
                                component: Component,
                                colSpans: headerColSpans,
                                inject,
                                onClick,
                                ...props
                              }) => {
                                const { onClick: injectedOnClick, ...injectedProps } = inject
                                  ? inject(passedThroughProps)
                                  : {};

                                return (
                                  <Grid key={headerKey} item {...headerColSpans}>
                                    <Component
                                      // control={<Radio />}
                                      disabled={!!barsDisabled}
                                      readonly={!!barsReadonly}
                                      {...props}
                                      {...injectedProps}
                                      onClick={(e) => {
                                        onClick && onClick(e);
                                        injectedOnClick && injectedOnClick(e);
                                      }}
                                    />
                                    {/* <FormControlLabel value={tabName} control={<Radio />} label={tabName} /> */}
                                  </Grid>
                                );
                              },
                            )}
                          </Grid>
                        </Grid>
                      </FormSection>
                    }
                  />
                ),
              )(bars)}
            </MuiTabs>
          </MuiRadioGroup>
        </AppBar>
      );
    }

    return (
      <AppBar position="static" {...appBarProps}>
        <MuiTabs
          className={classes.tabs}
          value={activeIndex}
          onChange={(event, value) => onActiveIndexChange(value)}
          variant={(barsReadonly || tabsFullWidth) && bars.length <= 3 ? 'fullWidth' : 'scrollable'}
          scrollButtons="auto"
          TabIndicatorProps={{
            style: {
              backgroundColor: '#FF5722',
            },
          }}
          {...sanitizedTabsProps}
        >
          {R.map(
            ({
              id: tabId,
              name: tabName,
              header: { components: headerComponents = [], containerProps: headerContainerProps },
            }) => (
              <MuiTab
                key={tabId || tabName}
                className={classes.tab}
                disabled={!!barsDisabled}
                label={
                  <FormSection name={tabName}>
                    <Grid className={classes.subHeading}>
                      <Grid container justify="center" alignItems="center" spacing={0} {...headerContainerProps}>
                        {headerComponents.map(
                          ({
                            id: headerKey,
                            component: Component,
                            colSpans: headerColSpans,
                            inject,
                            onClick,
                            ...props
                          }) => {
                            const { onClick: injectedOnClick, ...injectedProps } = inject
                              ? inject(passedThroughProps)
                              : {};

                            return (
                              <Grid key={headerKey} item {...headerColSpans}>
                                <Component
                                  disabled={!!barsDisabled}
                                  readonly={!!barsReadonly}
                                  {...props}
                                  {...injectedProps}
                                  onClick={(e) => {
                                    onClick && onClick(e);
                                    injectedOnClick && injectedOnClick(e);
                                  }}
                                />
                              </Grid>
                            );
                          },
                        )}
                      </Grid>
                    </Grid>
                  </FormSection>
                }
              />
            ),
          )(bars)}
        </MuiTabs>
      </AppBar>
    );
  }
}

class RawTabs extends React.PureComponent {
  static propTypes = {
    tabs: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        name: PropTypes.string.isRequired,
        header: PropTypes.object.isRequired,
        body: PropTypes.object.isRequired,
      }),
    ).isRequired,
    ignoreMetas: PropTypes.arrayOf(PropTypes.string),
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
  };

  state = {
    activeIndex: this.props.radioControlValue === 'advanced' ? 1 : 0,
    metas: R.pipe(
      R.pathOr([], ['tabs']),
      R.map(({ name: tabName }) => [tabName, R.clone(defaultMeta)]),
      R.fromPairs,
    )(this.props),
  };

  componentDidMount() {
    if (this.props.ignoreMetas) {
      const activeIndex =
        R.findIndex(
          R.propEq(
            'name',
            R.pipe(R.map(R.prop('name')), R.difference(R.__, this.props.ignoreMetas))(this.props.tabs)[0],
          ),
        )(this.props.tabs) === -1
          ? 0
          : R.findIndex(
            R.propEq(
              'name',
              R.pipe(R.map(R.prop('name')), R.difference(R.__, this.props.ignoreMetas))(this.props.tabs)[0],
            ),
          )(this.props.tabs);
      this.setState({ activeIndex });
    }
  }
  changeActiveIndex = (activeIndex) => this.setState({ activeIndex });

  reportMetaChange = (metas, ignoreMetas = []) => {
    const { onMetaChange: onTabsMetaChange } = this.props;
    const tabsMeta = R.pipe(R.omit(ignoreMetas), reduceMetas)(metas);
    onTabsMetaChange && onTabsMetaChange(tabsMeta);
  };

  changeMetas = (metas) =>
    this.setState((_, { ignoreMetas = [] }) => {
      const nextMetas = metas;
      this.reportMetaChange(nextMetas, ignoreMetas);
      return { metas: nextMetas };
    });

  UNSAFE_componentWillReceiveProps({ tabs: nextTabs = [], ignoreMetas: nextIgnoreMetas = [] }) {
    const { tabs, ignoreMetas } = this.props;
    tabs !== nextTabs &&
      (() => {
        const { activeIndex } = this.state;
        const nextActiveIndex = R.pipe(
          R.path([activeIndex, 'name']),
          findIndexBy('name', R.__, nextTabs),
          R.when(R.identical(-1), R.always(0)),
        )(tabs);
        this.setState({ activeIndex: nextActiveIndex });
      })();

    !R.equals(ignoreMetas, nextIgnoreMetas) && this.reportMetaChange(this.state.metas, nextIgnoreMetas);
  }

  render() {
    const { activeIndex, metas } = this.state;
    const {
      tabs,
      ignoreMetas,
      appBarProps,
      tabsProps,
      springConfig,
      disabled,
      readonly,
      isRadioStyle = false,
      radioControlValue = '',
      handleSelectCategory = () => { },
      ...rest
    } = this.props;
    const radioActiveIndex = isRadioStyle
      ? R.findIndex(R.propEq('name', radioControlValue), tabs)
      : -1;
    const resolvedActiveIndex = radioActiveIndex >= 0 ? radioActiveIndex : activeIndex;

    // console.log('%crender RawTabs', 'font-size: 12px; color: #00b3b3', this.state, this.props);
    const passedThroughProps = R.omit(['onMetaChange'], rest);

    return (
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <RawBars
            bars={tabs}
            metas={metas}
            ignoreMetas={ignoreMetas}
            activeIndex={resolvedActiveIndex}
            onActiveIndexChange={this.changeActiveIndex}
            appBarProps={appBarProps}
            tabsProps={tabsProps}
            disabled={!!disabled}
            readonly={!!readonly}
            isRadioStyle={isRadioStyle}
            radioControlValue={radioControlValue}
            handleSelectCategory={handleSelectCategory}
          />
        </Grid>
        <Grid item xs={12}>
          <RawViews
            views={tabs}
            activeIndex={resolvedActiveIndex}
            onActiveIndexChange={this.changeActiveIndex}
            disabled={!!disabled}
            readonly={!!readonly}
            springConfig={springConfig}
            onMetasChange={this.changeMetas}
            {...passedThroughProps}
          />
        </Grid>
      </Grid>
    );
  }
}

class Tabs extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      fontRobotoReady: false,
    };

    const fontRoboto = new FontFaceObserver('Roboto');
    // // default is 3s timeout
    fontRoboto.load().then(
      // Successfully loaded
      () => console.log('Font Roboto has loaded'),
    );
  }

  componentDidMount() {
    this.setState({ fontRobotoReady: true });
  }

  render() {
    const { fontRobotoReady } = this.state;
    const { name, ...props } = this.props;

    return fontRobotoReady ? (
      <FormSection name={name}>
        <RawTabs {...props} />
      </FormSection>
    ) : (
      <Loading fullScreenOverlay={false} />
    );
  }
}

class RawSteps extends React.PureComponent {
  static propTypes = {
    steps: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        name: PropTypes.string.isRequired,
        label: PropTypes.string,
      }),
    ).isRequired,
    metas: PropTypes.object.isRequired,
    ignoreMetas: PropTypes.arrayOf(PropTypes.string),
    activeIndex: PropTypes.number.isRequired,
    onActiveIndexChange: PropTypes.func,
    stepperProps: PropTypes.object,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
  };

  render() {
    const {
      steps,
      metas,
      ignoreMetas = [],
      activeIndex,
      onActiveIndexChange,
      stepperProps,
      disabled: stepsDisabled,
    } = this.props;

    // console.log('%crender RawSteps', 'font-size: 12px; color: #00b3b3', this.state, this.props);

    return (
      <MuiStepper {...stepperProps} nonLinear alternativeLabel activeStep={activeIndex}>
        {R.addIndex(R.map)(({ id, name, label }, index) => (
          <Step key={id || name} disabled={!!stepsDisabled}>
            <StepButton
              icon={
                <StatusIndicator
                  active={index === activeIndex && !stepsDisabled}
                  status={R.pipe(
                    () => (ignoreMetas.includes(name) ? R.clone(defaultMeta) : metas[name]),
                    decideStatusFromMeta,
                  )(metas)}
                  pristineIcon={Favorite}
                />
              }
              onClick={() => onActiveIndexChange(index)}
            >
              {label || name}
            </StepButton>
          </Step>
        ))(steps)}
      </MuiStepper>
    );
  }
}

@withStyles((theme) => ({
  badge: {
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  label: {
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(2),
  },
}))
class RawSteppers extends React.PureComponent {
  static propTypes = {
    label: PropTypes.string,
    statusOnLabel: PropTypes.bool,
    steps: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        name: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        body: PropTypes.object.isRequired,
      }),
    ).isRequired,
    ignoreMetas: PropTypes.arrayOf(PropTypes.string),
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
  };

  state = {
    activeIndex: 0,
    metas: R.pipe(
      R.pathOr([], ['steps']),
      R.map(({ name: stepName }) => [stepName, R.clone(defaultMeta)]),
      R.fromPairs,
    )(this.props),
  };

  changeActiveIndex = (activeIndex) => this.setState({ activeIndex });

  reportMetaChange = (metas, ignoreMetas = []) => {
    const { onMetaChange: onSteppersMetaChange } = this.props;
    const steppersMeta = R.pipe(R.omit(ignoreMetas), reduceMetas)(metas);
    onSteppersMetaChange && onSteppersMetaChange(steppersMeta);
  };

  changeMetas = (metas) =>
    this.setState((_, { ignoreMetas = [] }) => {
      const nextMetas = metas;
      this.reportMetaChange(nextMetas, ignoreMetas);
      return { metas: nextMetas };
    });

  UNSAFE_componentWillReceiveProps({ ignoreMetas }) {
    !R.equals(ignoreMetas, this.props.ignoreMetas) && this.reportMetaChange(this.state.metas, ignoreMetas);
  }

  render() {
    const { activeIndex, metas } = this.state;
    const {
      label,
      statusOnLabel = true,
      steps,
      ignoreMetas,
      springConfig,
      disabled,
      readonly,
      stepperProps,
      classes,
      ...rest
    } = this.props;

    // console.log('%crender RawSteppers', 'font-size: 12px; color: #00b3b3', this.state, this.props);
    const passedThroughProps = R.omit(['onMetaChange'], rest);

    return (
      <Grid container spacing={0} justify="center">
        {label && (
          <Grid item xs={12}>
            <Badge
              className={classes.badge}
              badgeContent={
                <StatusIndicator status={R.pipe(reduceMetas, decideStatusFromMeta)(metas)} visible={statusOnLabel} />
              }
            >
              <Typography variant="body1" className={classes.label}>
                {label}
              </Typography>
            </Badge>
          </Grid>
        )}
        <Grid item xs={12}>
          <RawViews
            views={steps}
            activeIndex={activeIndex}
            onActiveIndexChange={this.changeActiveIndex}
            disabled={!!disabled}
            readonly={!!readonly}
            springConfig={springConfig}
            onMetasChange={this.changeMetas}
            {...passedThroughProps}
          />
        </Grid>
        <Grid item xs={8}>
          <RawSteps
            steps={steps}
            metas={metas}
            ignoreMetas={ignoreMetas}
            activeIndex={activeIndex}
            onActiveIndexChange={this.changeActiveIndex}
            stepperProps={stepperProps}
            disabled={!!disabled}
            readonly={!!readonly}
          />
        </Grid>
      </Grid>
    );
  }
}

class Steppers extends React.PureComponent {
  render() {
    const { name, ...props } = this.props;

    return (
      <FormSection name={name}>
        <RawSteppers {...props} />
      </FormSection>
    );
  }
}

@withStyles((theme) => ({
  avatarButton: {
    width: 90,
    height: 90,
  },
  avatarPreview: {
    margin: '0 auto',
    width: 350,
    height: 354, //Canvas drawn by AvatarEditor adds 4px. This prevents flickering on redraw.
  },
  loadedAvatarPreview: {
    margin: '0 auto',
    width: 350,
    height: 354,
    boxShadow: theme.shadows[5],
  },
  avatarEditorPanel: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: theme.spacing(90),
    borderRadius: 10,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
    outline: 'none',
  },
  avatarEditor: {
    backgroundColor: 'white',
  },
  avatarEditorEmpty: {
    width: 350,
    height: 354, // The canvas drawn by AvatarEditor will add extra 4px. This is to prevent flickering effect
    margin: '0 auto',
    position: 'relative',
  },
  center: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
}))
class RawAvatar extends React.PureComponent {
  static propTypes = {
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
  };

  initState = {
    dirty: false, // True if new image uploaded, or editing done on image preview
    image: '',
    preview: '',
    angle: 0,
    scale: 1,
  };

  state = {
    ...this.initState,
    edit: false,
  };

  imgDataHeader = 'data:image/jpeg;base64,';

  labelType = this.getLabelType();

  setPreview = () => {
    const imgCanvas = this.avatarEditor.getImageScaledToCanvas();
    const context = imgCanvas.getContext('2d');
    context.globalCompositeOperation = 'destination-over'; // Set to draw behind current content
    context.fillStyle = '#FFFFFF'; // Set background color
    context.fillRect(0, 0, imgCanvas.width, imgCanvas.height); // draw background on entire canvas
    const convertedCanvas = document.createElement('canvas');
    const convertedCtx = convertedCanvas.getContext('2d');
    convertedCanvas.width = imgCanvas.width;
    convertedCanvas.height = imgCanvas.height;
    convertedCtx.drawImage(imgCanvas, 0, 0);
    this.setState({
      preview: convertedCanvas.toDataURL('image/jpeg', 0.5),
    });
  };
  debouncedSetPreview = debounce(this.setPreview, 200);

  renderAvatarEditor(imageData, angle, scale) {
    if (typeof imageData === 'string' || typeof imageData === 'object') {
      return (
        <Grid item>
          <AvatarEditor
            className={this.props.classes.avatarEditor}
            ref={(node) => {
              this.avatarEditor = node;
            }}
            width={300}
            height={300}
            borderRadius={150}
            rotate={angle}
            color={[235, 235, 235, 0.6]}
            scale={scale}
            image={imageData}
            onPositionChange={this.debouncedSetPreview}
            onImageChange={() => this.setState({ dirty: true })}
            onImageReady={this.setPreview}
          />
        </Grid>
      );
    }
    return (
      // Error handling + catch-all
      <ImageAvatar
        className={this.props.classes.avatarPreview}
        gothumb={false}
        alt={<Error style={{ fontSize: 50 }} color="secondary" />}
      />
    );
  }

  renderSelectImageText() {
    return (
      <Grid item>
        <ImageAvatar
          className={this.props.classes.avatarPreview}
          gothumb={false}
          alt={<InsertPhoto style={{ fontSize: 100 }} />}
        />
      </Grid>
    );
  }

  renderEditor() {
    const { image, angle, scale } = this.state;
    const { classes } = this.props;
    if (!image) return this.renderSelectImageText();
    // Image type will stored in string format after user clicks "Save Photo" on image selection
    // or if image is loaded from server as existing profile image
    if (typeof image === 'string') {
      // Header will be data:image/jpeg after user saves photo but not uploaded or committed to server yet
      if (image.substring(0, this.imgDataHeader.length) === this.imgDataHeader) {
        return this.renderAvatarEditor(image, angle, scale);
      }
      // Image is loaded from the server as a url
      return (
        <Grid item xs={12}>
          <ImageAvatar className={classes.loadedAvatarPreview} gothumb={true} src={image} variant="circle" />
        </Grid>
      );
    }
    // If image is loaded from user's local drive it is in "object" format
    return this.renderAvatarEditor(image, angle, scale);
  }

  /**
   * Toolbar below the avatar editor to rotate and zoom in/out
   * The user can only see the toolbar buttons to edit image when:
   * 1. The image preview is blank - this lets the user know that the controls are available once an image is uploaded
   * 2. After a new image is uploaded from file
   * 3. After a new image is uploaded from file and change is saved locally but not down to server yet
   */
  renderTools() {
    const { image, angle, scale, preview } = this.state;
    let isVisible = 'hidden';
    if (
      !image ||
      (typeof image === 'string' && image.substring(0, this.imgDataHeader.length) === this.imgDataHeader) ||
      typeof image === 'object'
    ) {
      isVisible = 'visible'; // Always render the toolbar but toggle visibility to user to prevent alignment changes / flickering
    }
    return (
      <Grid
        container
        direction="row"
        spacing={0}
        style={{
          visibility: isVisible,
          paddingBottom: 0,
          marginBottom: 0,
        }}
      >
        <Grid item xs={12}>
          <Grid container justify="center" spacing={40}>
            <Grid item>
              <IconButton disabled={!preview} onClick={() => this.setState({ angle: angle - 90 }, this.setPreview)}>
                <RotateLeft style={{ fontSize: 30 }} />
              </IconButton>
            </Grid>
            <Grid item>
              <IconButton disabled={!preview} onClick={() => this.setState({ angle: angle + 90 }, this.setPreview)}>
                <RotateRight style={{ fontSize: 30 }} />
              </IconButton>
            </Grid>
            <Grid item>
              <IconButton
                disabled={!preview || scale >= 2}
                onClick={() => this.setState({ scale: scale + 0.1 }, this.setPreview)}
              >
                <ZoomIn style={{ fontSize: 30 }} />
              </IconButton>
            </Grid>
            <Grid item>
              <IconButton
                disabled={!preview || scale < 0.2}
                onClick={() => this.setState({ scale: scale - 0.1 }, this.setPreview)}
              >
                <ZoomOut style={{ fontSize: 30 }} />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  manageUploadImage = (e) => {
    if (e.target.files[0]) {
      this.setState({
        ...this.initState,
        image: e.target.files[0],
        dirty: true,
      });
    }
  };

  // Renders the "Delete", "Upload", "Save" buttons
  renderControlButtons() {
    const {
      t,
      input: { onChange },
    } = this.props;
    return (
      <Grid container spacing={0} style={{ marginTop: 20 }}>
        <Grid item xs>
          <Button
            className="milo-btn-white"
            variant="contained"
            component="button"
            disabled={!this.state.image}
            style={{ width: 150, padding: 0 }}
            onClick={() => this.setState({ ...this.initState, dirty: true })}
            startIcon={<Delete />}
          >
            {(t && t('common:avatarDialog.remove')) || 'Remove'} {this.labelType}
          </Button>
        </Grid>
        <Grid item xs>
          <input
            accept=".png, .jpg, .jpeg, .svg"
            id="icon-button-file"
            type="file"
            style={{ display: 'none' }}
            onClick={(evt) => {
              evt.target.value = null;
            }} // eslint-disable-line no-param-reassign
            onChange={(evt) => {
              this.manageUploadImage(evt);
            }}
          />
          <label htmlFor="icon-button-file">
            <Button
              className="milo-btn-white"
              variant="contained"
              component="span"
              style={{ width: 150, padding: 0 }}
              startIcon={<AddPhotoAlternate />}
            >
              {(t && t('common:avatarDialog.upload')) || 'Upload'} {this.labelType}
            </Button>
          </label>
        </Grid>
        <Grid item xs={4} />
        <Grid item xs>
          <Button
            variant="contained"
            component="button"
            style={{ width: 150, padding: 0 }}
            disabled={!this.state.dirty}
            className="milo-btn-orange"
            onClick={() => this.setState({ dirty: false, edit: false }, onChange(this.state.preview))}
            startIcon={<Save />}
          >
            {(t && t('common:avatarDialog.save')) || 'Save'} {this.labelType}
          </Button>
        </Grid>
      </Grid>
    );
  }

  /**
   * Returns "Logo" or "Photo" for label based on whether it's individual or group / org entity
   * "Logo" applies to non-individual / group / org entities
   * "Photo" applies to  individual / human entities
   * Current forms that apply to orgs:
   * 1.createGroupOrg
   * 2.createEntityOrg
   * Current forms that apply to individuals:
   * 1.globalProfile
   * 2.provider
   */
  getLabelType() {
    const { t } = this.props;
    let labelType = (t && t('common:avatarDialog.photo')) || 'Photo';
    if (this.props.meta.form.includes('Org')) labelType = (t && t('common:avatarDialog.logo')) || 'Logo';
    return labelType;
  }

  renderTooltip() {
    const {
      t,
      input: { value },
      meta: { touched, error },
      emptyContent = <InsertPhoto style={{ fontSize: 50 }} />,
      errorContent = <Error style={{ fontSize: 50 }} color="secondary" />,
      disabled,
      readonly,
      classes,
    } = this.props;
    let tLabel = `${(t && t('common:avatarDialog.edit')) || 'Edit'} ${this.labelType}`;
    if (!value) tLabel = `${(t && t('common:avatarDialog.add')) || 'Add'} ${this.labelType}`;
    const isDisabled = !!disabled || !!readonly;
    return (
      <Tooltip title={touched && error ? error : tLabel}>
        <span style={isDisabled ? { pointerEvents: 'none' } : {}}>
          <Fab
            style={{ width: 'auto', height: 'auto' }}
            onClick={() => this.setState({ edit: true })}
            disabled={isDisabled}
          >
            <ImageAvatar
              className={classes.avatarButton}
              gothumb={true}
              src={value}
              alt={touched && error ? errorContent : emptyContent}
            />
          </Fab>
        </span>
      </Tooltip>
    );
  }

  renderHeader() {
    const { t } = this.props;
    return (
      <Typography align="center" style={{ fontSize: 25, fontWeight: 'bold' }}>
        {this.props.input.value
          ? `${(t && t('common:avatarDialog.edit')) || 'Edit'} ${this.labelType}`
          : `${(t && t('common:avatarDialog.add')) || 'Add'} ${this.labelType}`}
      </Typography>
    );
  }

  renderCriteriaText() {
    const { t } = this.props;
    return (
      <Typography align="center" style={{ fontSize: 13, lineHeight: 1.5 }}>
        {(t && t('common:avatarDialog.fileTypes')) || 'File types'}: jpg, png, svg <br />
      </Typography>
    );
  }

  render() {
    const { edit } = this.state;
    const {
      input: { value },
      classes,
    } = this.props;
    return (
      <React.Fragment>
        {this.renderTooltip()}
        <Modal open={edit} onRendered={() => this.setState({ image: value })}>
          <Paper className={classes.avatarEditorPanel}>
            <Grid container alignItems="center">
              <Grid item xs />
              <Grid item xs={6}>
                {this.renderHeader()}
              </Grid>
              <Grid item xs>
                <Grid container justify="flex-end">
                  <IconButton onClick={() => this.setState({ ...this.initState, edit: false })}>
                    <Close style={{ fontSize: 30 }} />
                  </IconButton>
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={3} style={{ marginTop: 20 }} alignItems="center">
              <Grid item xs />
              <Grid item xs={6}>
                <Grid container direction="column" alignItems="center" spacing={1}>
                  <Grid item xs>
                    {this.renderEditor()}
                  </Grid>
                  <Grid item xs style={{ marginTop: 2, marginBottom: 2 }}>
                    {this.renderCriteriaText()}
                  </Grid>
                  <Grid item xs>
                    {this.renderTools()}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs />
            </Grid>
            {this.renderControlButtons()}
          </Paper>
        </Modal>
      </React.Fragment>
    );
  }
}

class Avatar extends React.PureComponent {
  render() {
    const { name, ...props } = this.props;

    return <Field name={name} component={RawAvatar} {...props} />;
  }
}

const MEDIA_TYPES = {
  IMAGE: 'image',
  VIDEO: 'video',
};

const CONSTRAINTS = {
  image: {
    formats: ['.jpg', '.jpeg', '.png', '.gif'],
    // maxSize: 4 * 1024 * 1024, // 4MB
    maxSize: 4 * 1000 * 1000, // use this convertion Decimal Unit (Base 10) for user friendly
    minDimensions: '1080 x 1080',
    acceptAttribute: 'image/jpeg,image/png,image/gif',
  },
  video: {
    formats: ['.mp4', '.mov', '.webm'],
    // maxSize: 10 * 1024 * 1024, // 10MB
    maxSize: 10 * 1000 * 1000, // use this convertion Decimal Unit (Base 10) for user friendly
    minDimensions: '1280 x 720',
    acceptAttribute: 'video/mp4,video/quicktime,video/webm',
  },
};

const errorCodes = (t) => [
  {
    id: 0,
    title: t('common:mediaUpload.errors.fileMustBeImageOrVideo.title'),
    description: (
      <Typography variant="body2">
        {t('common:mediaUpload.errors.fileMustBeImageOrVideo.description')}
      </Typography>
    ),
  },
  {
    id: 1,
    title: t('common:mediaUpload.errors.imageFormatNotAccepted.title'),
    description: (
      <Typography variant="body2">
        {t('common:mediaUpload.errors.imageFormatNotAccepted.description')}
      </Typography>
    ),
  },
  {
    id: 2,
    title: t('common:mediaUpload.errors.imageSizeTooLarge.title'),
    description: <Typography variant="body2">{t('common:mediaUpload.errors.imageSizeTooLarge.description')}</Typography>,
  },
  {
    id: 3,
    title: t('common:mediaUpload.errors.videoFormatNotAccepted.title'),
    description: (
      <Typography variant="body2">
        {t('common:mediaUpload.errors.videoFormatNotAccepted.description')}
      </Typography>
    ),
  },
  {
    id: 4,
    title: t('common:mediaUpload.errors.videoSizeTooLarge.title'),
    description: (
      <Typography variant="body2">
        {t('common:mediaUpload.errors.videoSizeTooLarge.description')}
      </Typography>
    ),
  },
  {
    id: 5,
    title: t('common:mediaUpload.errors.imageResolutionTooSmall.title'),
    description: (
      <Typography variant="body2">
        {t('common:mediaUpload.errors.imageResolutionTooSmall.description')}
      </Typography>
    ),
  },
  {
    id: 6,
    title: t('common:mediaUpload.errors.videoResolutionTooLow.title'),
    description: (
      <Typography variant="body2">{t('common:mediaUpload.errors.videoResolutionTooLow.description')}</Typography>
    ),
  },
  {
    id: 7,
    title: t('common:mediaUpload.errors.imageResolutionNotIdeal.title'),
    description: (
      <Typography variant="body2">
        {t('common:mediaUpload.errors.imageResolutionNotIdeal.description')}
      </Typography>
    ),
  },
];

const mediaUploadStyles = (theme) => ({
  mediaContainer: {
    width: '99.25%',
    height: 240,
    position: 'relative',
    marginBottom: '8px',
  },
  dropzone: {
    width: '100%',
    height: '100%',
    border: '2px dashed #E0E0E0',
    borderRadius: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    // cursor: 'pointer',
    backgroundColor: '#F6F8FA',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.main + '08',
    },
  },
  dropzoneActive: {
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.main + '16',
  },
  dropzoneReject: {
    borderColor: theme.palette.error.main,
    backgroundColor: theme.palette.error.main + '08',
  },
  uploadIcon: {
    fontSize: 48,
    color: theme.palette.grey[400],
    marginBottom: theme.spacing(1),
  },
  dragDropText: {
    textAlign: 'center',
    // marginBottom: theme.spacing(1),
    fontWeight: '500',
  },
  uploadText: {
    textAlign: 'center',
    marginBottom: theme.spacing(1),
  },
  uploadSubtext: {
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '14px',
    letterSpacing: '0.4px',
    textAlign: 'center',
    color: '##212121',
  },
  mediaPreviewContainer: {
    width: '100%',
    height: '100%',
    position: 'relative',
    backgroundColor: '#F6F8FA',
    borderRadius: theme.spacing(1),
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
  },
  previewContainer: {
    width: 392,
    height: '100%',
    position: 'relative',
    overflow: 'hidden',
  },
  previewImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  previewVideo: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  previewOverlay: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    borderRadius: '50%',
  },
  errorDialog: {
    '& .MuiDialog-paper': {
      borderRadius: theme.spacing(2),
      padding: theme.spacing(1),
    },
  },
  errorIcon: {
    color: theme.palette.warning.main,
    marginRight: theme.spacing(1),
  },
  linkButton: {
    color: '#007AFF',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  tempMediaPreviewContainer: {
    width: 392,
    height: 240,
    backgroundColor: '#9E9E9E',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

@withStyles(mediaUploadStyles)
class RawMediaUpload extends React.PureComponent {
  initState = {
    dirty: false, // True if new image uploaded, or editing done on image preview
    media: '',
    preview: '',
    angle: 0,
    scale: 1,
  };

  constructor(props) {
    super(props);
    this.state = {
      media: '',
      tempMedia: '',
      preview: '',
      files: [],
      tempFiles: [],
      errors: [],
      showErrorDialog: false,
      showUploadDialog: false,
      showProceedDialog: false,
      uploadType: MEDIA_TYPES.IMAGE,
      isEdit: false,
      menuAnchor: null,
      previewUrls: {},
      tempPreviewUrls: {},
      dirty: false,
      tempAngle: 0,
      tempScale: 1,
      angle: 0,
      scale: 1,
      disableRemove: true,
      disableSave: true,
      isTempDrop: false,
      isPortraitOrSquare: false,
      imageDimensions: null,
    };
    this.imageInputRef = React.createRef();
    this.videoInputRef = React.createRef();
    this.allFilesInputRef = React.createRef();
    this.tempFiles = null;
    this.tempProceedFiles = null;
  }

  async componentDidMount() {
    const { input } = this.props;

    if (input.value && input.value.length > 0) {
      const files = input.value;
      let previewUrl = '';

      // Determine if it's a valid URL or File object
      if (typeof files === 'string') {
        previewUrl = files;
      } else if (files instanceof File || files instanceof Blob) {
        previewUrl = URL.createObjectURL(files[0]);
      } else if (files && files.file_url) {
        // In case file object has a file_url property
        previewUrl = files.file_url;
      }

      // Detect orientation (portrait / landscape)
      let isPortraitOrSquare = true;
      let scale = 1;
      if (previewUrl) {
        try {
          isPortraitOrSquare = await this.checkImageOrientationFromUrl(previewUrl);
          scale = await this.getImageScaleFromUrl(previewUrl);
        } catch (err) {
          console.error('Error detecting image orientation:', err);
        }
      }

      this.setState(
        {
          files,
          tempFiles: files,
          tempMedia: true,
          media: true,
          disableRemove: false,
          isPortraitOrSquare,
          scale: scale < 1 ? scale : 1,
        },
        () => {
          this.generatePreviews(files);
          this.generateTempPreviews(files);
        },
      );
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { input } = this.props;

    if (!_.isEqual(input, prevProps.input)) {
      this.setState({
        files: input.value,
        tempFiles: input.value,
        tempMedia: true,
        media: true,
        // disableRemove: input.value === '',
      });
      this.generatePreviews(input.value);
      this.generateTempPreviews(input.value);
    }

    // return !_.isEqual(input, nextProps.input);
  }

  componentWillUnmount() {
    // Clean up preview URLs to prevent memory leaks
    Object.values(this.state.previewUrls).forEach((url) => {
      if (url.startsWith('blob:')) {
        URL.revokeObjectURL(url);
      }
    });

    Object.values(this.state.tempPreviewUrls).forEach((url) => {
      if (url.startsWith('blob:')) {
        URL.revokeObjectURL(url);
      }
    });
  }

  // Convert File to base64
  convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

  // Convert files to base64 and create file objects
  processFiles = async (files) => {
    console.log('>> processFiles files 1: ', files);
    const processedFiles = await Promise.all(
      files.map(async (file) => {
        if (file instanceof File) {
          const isImage = file.type.startsWith('image/');
          const isVideo = file.type.startsWith('video/');

          console.log('>> processFiles file 2: ', file);

          const base64 = await this.convertFileToBase64(file);
          return {
            name: file.name,
            type: file.type,
            size: file.size,
            lastModified: file.lastModified,
            base64: base64,
            isBase64: true,
            file: file, // Keep original file for videos
          };
          // Convert images to base64, keep videos as File objects for now
          // if (isImage) {
          //   const base64 = await this.convertFileToBase64(file);
          //   return {
          //     name: file.name,
          //     type: file.type,
          //     size: file.size,
          //     lastModified: file.lastModified,
          //     base64: base64,
          //     isBase64: true,
          //   };
          // } else if (isVideo) {
          //   // For videos, you might want to keep as File or convert to base64 as well
          //   // For now, keeping as File object but adding metadata
          //   return {
          //     name: file.name,
          //     type: file.type,
          //     size: file.size,
          //     lastModified: file.lastModified,
          //     file: file, // Keep original file for videos
          //     isBase64: false,
          //   };
          // }
        }
        return file; // Return as-is if already processed
      }),
    );
    return processedFiles;
  };

  generatePreviews = (files) => {
    const previewUrls = {};
    const isUrl = isValidUrl(files);

    if (isUrl) {
      this.setState({ previewUrls: files });
    } else {
      if (files.length > 0) {
        Array.isArray(files) &&
          files.forEach((file, index) => {
            if (file.isBase64 && file.base64) {
              // Use base64 string directly
              previewUrls[index] = file.base64;
            } else if (file.file instanceof File) {
              // Create blob URL for File objects (videos)
              previewUrls[index] = URL.createObjectURL(file.file);
            } else if (file instanceof File) {
              // Legacy support for direct File objects
              previewUrls[index] = URL.createObjectURL(file);
            } else if (file.url) {
              // Existing URL
              previewUrls[index] = file.url;
            }
          });
      }

      this.setState({ previewUrls });
    }
  };

  generateTempPreviews = (files) => {
    const tempPreviewUrls = {};
    const isUrl = isValidUrl(files);

    if (isUrl) {
      this.setState({ previewUrls: files });
    } else {
      if (files.length > 0) {
        Array.isArray(files) &&
          files.forEach((file, index) => {
            if (file.isBase64 && file.base64) {
              // Use base64 string directly
              tempPreviewUrls[index] = file.base64;
            } else if (file.file instanceof File) {
              // Create blob URL for File objects (videos)
              tempPreviewUrls[index] = URL.createObjectURL(file.file);
            } else if (file instanceof File) {
              // Legacy support for direct File objects
              tempPreviewUrls[index] = URL.createObjectURL(file);
            } else if (file.url) {
              // Existing URL
              tempPreviewUrls[index] = file.url;
            }
          });
      }

      this.setState({ tempPreviewUrls });
    }
  };

  validateFile = (file) => {
    const errors = [];
    const fileObj = file instanceof File ? file : file.file;
    const isImage = fileObj.type.startsWith('image/');
    const isVideo = fileObj.type.startsWith('video/');

    if (!isImage && !isVideo) {
      errors.push(0);
      return errors;
    }

    const constraints = isImage ? CONSTRAINTS.image : CONSTRAINTS.video;

    // Check file size
    if (fileObj.size > constraints.maxSize) {
      const maxSizeMB = constraints.maxSize / (1024 * 1024);
      errors.push(isImage ? 2 : 4);
    }

    // Check file format
    const fileExtension =
      '.' +
      fileObj.name
        .split('.')
        .pop()
        .toLowerCase();
    if (!constraints.formats.includes(fileExtension)) {
      errors.push(isImage ? 1 : 3);
    }

    return errors;
  };

  validateImageDimensions = (file) => {
    return new Promise((resolve) => {
      const fileObj = file instanceof File ? file : file.file;
      if (!fileObj.type.startsWith('image/')) {
        resolve([]);
        return;
      }

      const img = new Image();
      img.onload = () => {
        const errors = [];
        if (img.width < 600 || img.height < 600) {
          errors.push(5);
        } else if ((img.width >= 600 || img.height >= 600) && (img.width < 1080 || img.height < 1080)) {
          errors.push(7);
        }
        resolve(errors);
      };
      img.onerror = () => resolve(['Invalid image file']);
      img.src = URL.createObjectURL(fileObj);
    });
  };

  validateVideoDimensions = (file) => {
    return new Promise((resolve) => {
      const fileObj = file instanceof File ? file : file.file;
      if (!fileObj.type.startsWith('video/')) {
        resolve([]);
        return;
      }

      const video = document.createElement('video');
      video.preload = 'metadata';

      video.onloadedmetadata = () => {
        URL.revokeObjectURL(video.src);
        const errors = [];
        if (video.videoWidth < 1280 || video.videoHeight < 720) {
          errors.push(6);
        }
        resolve(errors);
      };

      video.onerror = () => resolve(['Invalid video file']);
      video.src = URL.createObjectURL(fileObj);
    });
  };

  checkIfPortraitOrSquare = (file) => {
    return new Promise((resolve) => {
      const fileObj = file instanceof File ? file : file.file;
      if (!fileObj.type.startsWith('image/')) {
        resolve(false);
        return;
      }

      const img = new Image();
      img.onload = () => {
        const isPortraitOrSquare = img.height >= img.width;
        resolve(isPortraitOrSquare);
      };
      img.onerror = () => resolve(false);
      img.src = URL.createObjectURL(fileObj);
    });
  };

  checkImageOrientationFromUrl = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const isPortraitOrSquare = img.height >= img.width;
        console.log(
          `>> Image loaded: ${img.width}x${img.height} → ${isPortraitOrSquare ? 'portrait/square' : 'landscape'}`,
        );
        resolve(isPortraitOrSquare);
      };
      img.onerror = (err) => {
        console.error('Failed to load image:', err);
        reject(err);
      };
      img.src = url;
    });
  };

  getImageScaleFromUrl = async (url) => {
    try {
      // Extract scale from filename pattern: _scale-1-5 (dash instead of decimal point)
      const scaleMatch = url.match(/_scale-([\d-]+)(?:\.|$|_)/);

      if (scaleMatch && scaleMatch[1]) {
        // Convert dash back to decimal point (e.g., "1-5" -> "1.5")
        const scaleString = scaleMatch[1].replace('-', '.');
        const scale = parseFloat(scaleString);

        if (!isNaN(scale) && scale >= 0.2 && scale <= 2) {
          console.log(`Detected scale from filename: ${scale}`);
          return scale;
        }
      }

      // No scale found in filename, return default
      console.log('No scale found in filename, using default scale 1');
      return 1;
    } catch (error) {
      console.error('Error extracting scale from URL:', error);
      return 1;
    }
  };

  // Reset transformations when new file is uploaded
  onTempDrop = async (acceptedFiles, rejectedFiles) => {
    const { input, multiple = false } = this.props;
    const allErrors = [];
    let isPortraitOrSquare = false;

    // Validate accepted files
    const validFiles = [];
    for (const file of acceptedFiles) {
      const fileErrors = this.validateFile(file);

      const isImage = file.type.startsWith('image/');
      const isVideo = file.type.startsWith('video/');

      // Tambahkan validasi dimensi async
      let dimensionErrors = [];
      if (isImage) {
        dimensionErrors = await this.validateImageDimensions(file);
        // detect orientation
        isPortraitOrSquare = await this.checkIfPortraitOrSquare(file);
      } else if (isVideo) {
        dimensionErrors = await this.validateVideoDimensions(file);
      }

      console.log('>> dimensionErrors onTempDrop: ', dimensionErrors);

      const combinedErrors = [...fileErrors, ...dimensionErrors];

      if (combinedErrors.length > 0) {
        allErrors.push(...combinedErrors);
      }

      if (combinedErrors.length === 0 || (combinedErrors.length > 0 && combinedErrors.includes(7))) {
        validFiles.push(file);
      }
    }

    console.log('>> showErrorDialog onTempDrop:', allErrors);

    if (allErrors.length > 0 && allErrors[0] === 7 && validFiles.length > 0) {
      // Process files to convert images to base64
      // const processedFiles = await this.processFiles(validFiles);
      const newFiles = multiple ? [...this.state.tempFiles, ...validFiles] : validFiles;

      this.setState({
        errors: allErrors,
        showErrorDialog: true,
        disableRemove: false,
        disableSave: false,
        tempFiles: newFiles,
        tempMedia: true,
        angle: 0, // Reset transformations for new file
        scale: 1, // Reset transformations for new file
        isTempDrop: true,
        isPortraitOrSquare,
      });
      return;
    }

    if (allErrors.length > 0) {
      this.setState({
        errors: allErrors,
        showErrorDialog: true,
      });
      return;
    }

    if (validFiles.length > 0) {
      // Process files to convert images to base64
      // const processedFiles = await this.processFiles(validFiles);
      const newFiles = multiple ? [...this.state.tempFiles, ...validFiles] : validFiles;

      this.setState({
        disableRemove: false,
        disableSave: false,
        tempFiles: newFiles,
        tempMedia: true,
        angle: 0, // Reset transformations for new file
        scale: 1, // Reset transformations for new file
      });
      this.generateTempPreviews(newFiles);
      this.tempFiles = newFiles;
    }
  };

  onDrop = async (acceptedFiles, rejectedFiles) => {
    const { input, multiple = false } = this.props;
    const allErrors = [];
    let isPortraitOrSquare = false;

    // Validate accepted files
    const validFiles = [];
    for (const file of acceptedFiles) {
      const fileErrors = this.validateFile(file);
      const isImage = file.type.startsWith('image/');
      const isVideo = file.type.startsWith('video/');

      // Tambahkan validasi dimensi async
      let dimensionErrors = [];
      if (isImage) {
        dimensionErrors = await this.validateImageDimensions(file);
        // detect orientation
        isPortraitOrSquare = await this.checkIfPortraitOrSquare(file);
      } else if (isVideo) {
        dimensionErrors = await this.validateVideoDimensions(file);
      }

      console.log('>> dimensionErrors onDrop: ', dimensionErrors);

      const combinedErrors = [...fileErrors, ...dimensionErrors];

      if (combinedErrors.length > 0) {
        allErrors.push(...combinedErrors);
      }

      if (combinedErrors.length === 0 || (combinedErrors.length > 0 && combinedErrors.includes(7))) {
        validFiles.push(file);
      }
    }

    console.log('>> showErrorDialog onDrop:', allErrors);

    if (allErrors.length > 0 && allErrors[0] === 7 && validFiles.length > 0) {
      const file = validFiles[0];
      const isVideo =
        file.type.startsWith('video/') ||
        file.name.endsWith('.mp4') ||
        file.name.endsWith('.mov') ||
        file.name.endsWith('.webm');

      // Process files to convert images to base64
      // const processedFiles = await this.processFiles(validFiles);
      const newFiles = multiple ? [...this.state.files, ...validFiles] : validFiles;

      this.setState({
        errors: allErrors,
        showErrorDialog: true,
        disableRemove: false,
        disableSave: true,
        files: newFiles,
        tempFiles: newFiles,
        uploadType: isVideo ? 'video' : 'image',
        media: true,
        tempMedia: true,
        isTempDrop: false,
        isPortraitOrSquare,
      });
      return;
    }

    if (allErrors.length > 0) {
      this.setState({
        errors: allErrors,
        showErrorDialog: true,
      });
      return;
    }

    if (validFiles.length > 0) {
      const file = validFiles[0];
      const isVideo =
        file.type.startsWith('video/') ||
        file.name.endsWith('.mp4') ||
        file.name.endsWith('.mov') ||
        file.name.endsWith('.webm');

      // Process files to convert images to base64
      // const processedFiles = await this.processFiles(validFiles);
      const newFiles = multiple ? [...this.state.files, ...validFiles] : validFiles;

      console.log('>> onDrop newFiles: ', newFiles);

      this.setState({
        disableRemove: false,
        disableSave: true,
        files: newFiles,
        tempFiles: newFiles,
        uploadType: isVideo ? 'video' : 'image',
        media: true,
        tempMedia: true,
      });
      this.generatePreviews(newFiles);
      this.generateTempPreviews(newFiles);
      input.onChange(newFiles);
    }
  };

  toggleUploadDialog = (uploadType = MEDIA_TYPES.IMAGE, isEdit = false) => {
    this.setState({
      showUploadDialog: !this.state.showUploadDialog,
      uploadType,
      isEdit,
      // angle: 0, // Reset transformations
      // scale: 1, // Reset transformations
    });
  };

  closeUploadDialog = () => {
    const { files, previewUrls, media, angle, scale } = this.state;
    this.setState({
      tempMedia: media,
      tempFiles: files,
      tempPreviewUrls: previewUrls,
      showUploadDialog: false,
      disableRemove: files.length === 0,
      disableSave: true,
      tempAngle: angle,
      tempScale: scale,
    });
  };

  handleMenuOpen = (event) => {
    this.setState({ menuAnchor: event.currentTarget });
  };

  handleMenuClose = () => {
    this.setState({ menuAnchor: null });
  };

  handleEdit = (uploadType, isEdit) => {
    this.toggleUploadDialog(uploadType, isEdit);
    this.handleMenuClose();
  };

  handleReplace = () => {
    const { uploadType } = this.state;

    const input = document.createElement('input');
    input.type = 'file';
    input.accept = uploadType === 'image' ? CONSTRAINTS.image.acceptAttribute : CONSTRAINTS.video.acceptAttribute;

    input.onchange = (event) => {
      if (event.target.files && event.target.files[0]) {
        this.onDrop([event.target.files[0]], []);
      }
    };

    input.click();
    this.handleMenuClose();
  };

  handleUploadImage = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.imageInputRef.current.click();
  };

  handleUploadVideo = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.videoInputRef.current.click();
  };

  handleSave = () => {
    const { input } = this.props;
    const {
      tempFiles,
      tempMedia,
      previewUrls,
      tempPreviewUrls,
      tempAngle,
      tempScale,
      angle,
      scale,
      uploadType,
    } = this.state;

    // 🧹 Clean up blob URLs
    Object.values(previewUrls).forEach((url) => {
      if (url.startsWith('blob:')) {
        URL.revokeObjectURL(url);
      }
    });

    // 🧾 Normalize tempFiles
    const hasMedia = !!tempMedia && tempFiles && (Array.isArray(tempFiles) ? tempFiles.length > 0 : true);
    if (!hasMedia) {
      // Nothing selected
      this.setState(
        {
          files: [],
          tempFiles: [],
          previewUrls: {},
          tempPreviewUrls: {},
          showUploadDialog: false,
          dirty: true,
          media: false,
          tempMedia: false,
          tempAngle: 0,
          tempScale: 1,
          angle: 0,
          scale: 1,
          disableRemove: true,
          disableSave: true,
        },
        () => input.onChange([]),
      );
      return;
    }

    console.log('>> handleSave tempFiles:', tempFiles);

    // ✅ Fix: tempFiles could be an array or a single string (signed URL)
    const originalFile = Array.isArray(tempFiles) ? tempFiles[0] : tempFiles;

    // 🎥 Video file: no transformation needed
    if (uploadType === 'video') {
      this.setState(
        {
          files: Array.isArray(tempFiles) ? tempFiles : [tempFiles],
          previewUrls: { ...tempPreviewUrls },
          showUploadDialog: false,
          dirty: true,
          media: true,
          tempMedia: true,
          disableRemove: false,
          disableSave: true,
        },
        () => input.onChange(Array.isArray(tempFiles) ? tempFiles : [tempFiles]),
      );
      return;
    }

    // 🖼️ Process image case
    const img = new Image();

    const processImage = (blobSrc, originalType, originalName) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';

      img.onload = () => {
        try {
          const { tempAngle, tempScale, tempPreviewUrls } = this.state;
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          // ✅ Step 1: Determine base dimensions
          let baseWidth = img.width;
          let baseHeight = img.height;

          // If height < 1080, scale up proportionally
          if (baseHeight < 1080) {
            const scaleFactor = 1080 / baseHeight;
            baseHeight = 1080;
            baseWidth = img.width * scaleFactor;
          }

          // ✅ Step 2: Canvas size stays fixed to base image (acts like a viewport)
          canvas.width = baseWidth;
          canvas.height = baseHeight;

          // ✅ Step 3: Prepare rotation
          const radians = (tempAngle * Math.PI) / 180;

          ctx.fillStyle = '#FFFFFF';
          ctx.fillRect(0, 0, canvas.width, canvas.height);

          ctx.save();
          ctx.translate(canvas.width / 2, canvas.height / 2);
          ctx.rotate(radians);

          // ✅ Step 4: Draw scaled (zoomed-in) image — cropped to viewport
          const drawWidth = baseWidth * tempScale;
          const drawHeight = baseHeight * tempScale;

          ctx.drawImage(img, -drawWidth / 2, -drawHeight / 2, drawWidth, drawHeight);

          ctx.restore();

          // ✅ Step 5: Convert to Blob
          canvas.toBlob(
            (blob) => {
              if (!blob) {
                console.error('Failed to generate image blob');
                return;
              }

              const lastDotIndex = originalName.lastIndexOf('.');
              const nameWithoutExt = lastDotIndex > 0 ? originalName.substring(0, lastDotIndex) : originalName;
              const extension = lastDotIndex > 0 ? originalName.substring(lastDotIndex) : '';
              const nameWithoutScale = nameWithoutExt.replace(/_scale-[\d.]+$/, '');
              const scaleFormatted = tempScale.toFixed(1).replace('.', '-');
              const newFileName = `${nameWithoutScale}_scale-${scaleFormatted}${extension}`;

              const transformedFile = new File([blob], newFileName, {
                type: originalType || 'image/jpeg',
                lastModified: Date.now(),
              });

              const updateAngle = tempAngle;
              const updateScale = tempScale;

              this.setState(
                {
                  files: [transformedFile],
                  previewUrls: { ...tempPreviewUrls },
                  showUploadDialog: false,
                  dirty: true,
                  media: true,
                  tempMedia: true,
                  disableRemove: false,
                  disableSave: true,
                  angle: updateAngle,
                  scale: updateScale,
                  tempAngle: 0,
                },
                () => input.onChange([transformedFile]),
              );
            },
            originalType || 'image/jpeg',
            0.9,
          );
        } catch (err) {
          console.error('Error transforming image:', err);
        }
      };

      img.onerror = (err) => {
        console.error('Failed to load image for transformation:', err);
      };

      img.src = blobSrc;
    };

    // 📦 Handle File / Blob / Signed URL
    if (originalFile instanceof Blob) {
      const blobUrl = URL.createObjectURL(originalFile);
      processImage(blobUrl, originalFile.type, originalFile.name || 'image.jpg');
    } else if (typeof originalFile === 'string') {
      // Signed URL case
      fetch(originalFile)
        .then((res) => res.blob())
        .then((blob) => {
          const objectUrl = URL.createObjectURL(blob);
          processImage(objectUrl, blob.type, 'remote_image.jpg');
        })
        .catch((err) => console.error('Failed to fetch image blob from signed URL:', err));
    } else if (originalFile && originalFile.file_url) {
      fetch(originalFile.file_url)
        .then((res) => res.blob())
        .then((blob) => {
          const objectUrl = URL.createObjectURL(blob);
          const name = originalFile.name || originalFile.file_name || 'remote_image.jpg';
          processImage(objectUrl, blob.type, name);
        })
        .catch((err) => console.error('Failed to fetch image blob from file_url:', err));
    }
  };

  handleBrowseFiles = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.allFilesInputRef.current.click();
  };

  handleFileInputChange = (event, type = 'all') => {
    if (event.target.files && event.target.files[0]) {
      this.onTempDrop([event.target.files[0]], []);
    }
    event.target.value = '';
  };

  handleBrowseFileInputChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      this.onDrop([event.target.files[0]], []);
    }
    event.target.value = '';
  };

  handleTempDelete = () => {
    const { files } = this.state;
    this.setState({ tempFiles: [], tempPreviewUrls: {}, disableRemove: true, disableSave: files.length === 0 }, () => {
      this.generateTempPreviews([]);
    });
  };

  handleDelete = () => {
    const { input } = this.props;
    this.setState({
      files: [],
      previewUrls: {},
      tempFiles: [],
      tempPreviewUrls: {},
      media: false,
      tempMedia: false,
      disableRemove: true,
      disableSave: true,
    });
    input.onChange([]);
    this.handleMenuClose();
  };

  closeErrorDialog = () => {
    const { t } = this.props;
    const { errors, isTempDrop } = this.state;

    const getErrors = errorCodes(t);

    const error = Array.isArray(errors) && errors.length > 0 && getErrors.find((e) => e.id === errors[0]);

    if (error && error.id === 7) {
      if (!isTempDrop) {
        this.handleDelete();
      } else {
        this.handleTempDelete();
      }
    }

    this.setState({ showErrorDialog: false, errors: [] });
  };

  proceedSaveImage = () => {
    const { t, input } = this.props;
    const { errors, tempFiles, isTempDrop } = this.state;

    const getErrors = errorCodes(t);

    const error = Array.isArray(errors) && errors.length > 0 && getErrors.find((e) => e.id === errors[0]);

    if (error && error.id === 7) {
      if (!isTempDrop) {
        // this.generatePreviews(tempFiles);
        // input.onChange(tempFiles);
        this.handleSave();
      } else {
        this.generateTempPreviews(tempFiles);
        this.tempFiles = tempFiles;
      }
    }

    this.setState({ showErrorDialog: false, errors: [] });
  };

  renderDropzone = () => {
    const { t, classes, disabled, mode } = this.props;

    return (
      <DropzoneComponent
        t={t}
        onDrop={this.onDrop}
        accept={{
          'image/*': CONSTRAINTS.image.formats,
          'video/*': CONSTRAINTS.video.formats,
        }}
        disabled={disabled}
        multiple={false}
        classes={classes}
        onUploadImage={() => this.toggleUploadDialog('image', false)}
        onUploadVideo={() => this.toggleUploadDialog('video', false)}
        onBrowseFiles={this.handleBrowseFiles}
        mode={mode}
      />
    );
  };

  renderPreview = () => {
    const { t, classes } = this.props;
    const { files, previewUrls, menuAnchor, angle, scale, isPortraitOrSquare } = this.state;

    if (files.length === 0) return null;

    const isUrl = isValidUrl(files);
    const file = isUrl ? files : files[0];
    let isVideo = false;
    if (!isUrl) {
      isVideo =
        file.type.startsWith('video/') ||
        file.name.endsWith('.mp4') ||
        file.name.endsWith('.mov') ||
        file.name.endsWith('.webm');
    } else {
      isVideo = isVideoUrl(file);
    }
    const previewUrl = isUrl ? file : previewUrls[0];

    const transformStyle = {
      transform: `scale(${scale})`,
      transition: 'transform 0.3s ease-in-out',
      width: '100%',
      height: '100%',
      objectFit: !isVideo && isPortraitOrSquare ? 'contain' : 'contain',
      flexShrink: 0,
    };

    return (
      <div className={classes.mediaPreviewContainer}>
        <div className={classes.previewContainer}>
          {isVideo ? (
            <video
              className={classes.previewVideo}
              src={previewUrl}
              controls
              controlsList="nodownload noplaybackrate"
              disablePictureInPicture
              onContextMenu={(e) => e.preventDefault()}
            />
          ) : (
            <img className={classes.previewImage} src={previewUrl} alt="Preview" style={transformStyle} />
          )}

          <IconButton className={classes.previewOverlay} onClick={this.handleMenuOpen} size="small">
            <MoreVertIcon />
          </IconButton>

          <Menu
            anchorEl={menuAnchor}
            open={Boolean(menuAnchor)}
            onClose={this.handleMenuClose}
            getContentAnchorEl={null}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            PaperProps={{
              style: {
                width: 217,
                marginTop: -44,
              },
            }}
          >
            {!isVideo && (
              <MenuItem onClick={() => (isVideo ? this.handleEdit('video', true) : this.handleEdit('image', true))}>
                <ListItemIcon style={{ minWidth: 32 }}>
                  <ModeEdit fontSize="small" style={{ color: '#212121' }} />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ style: { color: '#212121', fontWeight: 500 } }}>
                  {isVideo ? t('common:mediaUpload.buttons.editVideo') : t('common:mediaUpload.buttons.editImage')}
                </ListItemText>
              </MenuItem>
            )}
            <MenuItem onClick={this.handleReplace}>
              <ListItemIcon style={{ minWidth: 32 }}>
                <ExchangeIcon fontSize="small" style={{ color: '#212121' }} />
              </ListItemIcon>
              <ListItemText primaryTypographyProps={{ style: { color: '#212121', fontWeight: 500 } }}>
                {isVideo ? t('common:mediaUpload.buttons.replaceVideo') : t('common:mediaUpload.buttons.replaceImage')}
              </ListItemText>
            </MenuItem>
            <MenuItem onClick={this.handleDelete}>
              <ListItemIcon style={{ minWidth: 32 }}>
                <DeleteForever fontSize="small" style={{ color: '#212121' }} />
              </ListItemIcon>
              <ListItemText primaryTypographyProps={{ style: { color: '#212121', fontWeight: 500 } }}>
                {isVideo ? t('common:mediaUpload.buttons.deleteVideo') : t('common:mediaUpload.buttons.deleteImage')}
              </ListItemText>
            </MenuItem>
          </Menu>
        </div>
      </div>
    );
  };

  renderMediaPreview = () => {
    const {
      classes,
      input: { value: mediaUpload },
    } = this.props;
    const { angle, scale, isPortraitOrSquare } = this.state;

    if (!mediaUpload || mediaUpload.length === 0) return null;

    const isUrl = isValidUrl(mediaUpload);
    const file = isUrl ? mediaUpload : mediaUpload[0];
    let isVideo = false;
    if (!isUrl) {
      isVideo = file && file.type && file.type.startsWith('video/');
    } else {
      isVideo = isVideoUrl(file);
    }
    const previewUrl = isUrl ? file : file.isBase64 ? file.base64 : file.url || '';

    const transformStyle = {
      transform: `rotate(${angle}deg) scale(${scale})`,
      transition: 'transform 0.3s ease-in-out',
      width: '100%',
      height: '100%',
      objectFit: !isVideo && isPortraitOrSquare ? 'contain' : 'contain',
      flexShrink: 0,
    };

    return (
      <div className={classes.mediaPreviewContainer}>
        <div className={classes.previewContainer}>
          {isVideo ? (
            <video
              className={classes.previewVideo}
              src={previewUrl}
              style={transformStyle}
              controls
              controlsList="nodownload noplaybackrate"
              disablePictureInPicture
              onContextMenu={(e) => e.preventDefault()}
            />
          ) : (
            <img className={classes.previewImage} src={previewUrl} style={transformStyle} alt="Preview" />
          )}
        </div>
      </div>
    );
  };

  renderTempMediaPreview = () => {
    const { classes } = this.props;
    const {
      tempFiles,
      tempPreviewUrls,
      uploadType,
      tempAngle,
      tempScale,
      isPortraitOrSquare,
      imageDimensions, // { width, height }
    } = this.state;

    let file = null;
    let previewUrl = '';
    let isVideo = false;

    if (tempFiles.length > 0) {
      const isUrl = isValidUrl(tempFiles);
      if (isUrl) {
        file = tempFiles;
        isVideo = isVideoUrl(file);
      } else {
        file = tempPreviewUrls[0];
        if (file && file.type && file.type.startsWith('video/')) {
          isVideo = true;
        } else {
          isVideo = false;
        }
      }
      previewUrl = file;
    }

    const containerWidth = 392;
    const containerHeight = 240;

    const containerStyle = {
      width: containerWidth + 'px',
      height: containerHeight + 'px',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '0.5px solid #e0e0e0',
      backgroundColor: '#f5f5f5',
      position: 'relative',
    };

    let objectFit = 'fill';
    if (isPortraitOrSquare) {
      objectFit = 'contain';
    }

    // 🧠 Compute adjusted scale dynamically
    let adjustedScale = tempScale;

    if (imageDimensions && imageDimensions.width && imageDimensions.height) {
      const rad = (Math.abs(tempAngle) % 180) * (Math.PI / 180);
      const cos = Math.cos(rad);
      const sin = Math.sin(rad);

      const { width: w, height: h } = imageDimensions;

      // Effective rotated bounding box size
      const rotatedWidth = Math.abs(w * cos) + Math.abs(h * sin);
      const rotatedHeight = Math.abs(w * sin) + Math.abs(h * cos);

      const scaleX = containerWidth / rotatedWidth;
      const scaleY = containerHeight / rotatedHeight;

      // Use smaller scale to ensure it fits in both directions
      // const fitScale = isPortraitOrSquare ? Math.min(scaleX, scaleY) : Math.max(scaleX, scaleY);
      const fitScale = Math.min(scaleX, scaleY);

      adjustedScale = tempScale * fitScale;
    }

    // const transformStyle = {
    //   transform: 'rotate(' + tempAngle + 'deg) scale(' + adjustedScale + ')',
    //   transition: 'transform 0.3s ease-in-out',
    //   width: 'auto',
    //   height: 'auto',
    //   objectFit: objectFit,
    //   flexShrink: 0,
    //   maxWidth: 'none',
    //   maxHeight: 'none',
    //   transformOrigin: 'center center',
    // };

    const transformStyle = {
      transform: `rotate(${tempAngle}deg) scale(${adjustedScale})`,
      transition: 'transform 0.3s ease-in-out',
      width: imageDimensions && imageDimensions.width ? `${imageDimensions.width}px` : 'auto',
      height: imageDimensions && imageDimensions.height ? `${imageDimensions.height}px` : 'auto',
      maxWidth: 'none',
      maxHeight: 'none',
      transformOrigin: 'center center',
      display: 'block',
    };

    // Capture image's natural dimensions when loaded
    const handleImageLoad = (e) => {
      const img = e.target;
      this.setState({
        imageDimensions: {
          width: img.naturalWidth,
          height: img.naturalHeight,
        },
      });
    };

    // 🧩 Placeholder images
    if (tempFiles.length === 0 && uploadType === MEDIA_TYPES.IMAGE) {
      return (
        <div className={classes.tempMediaPreviewContainer}>
          <img src={ImageIcon} alt="Preview" />
        </div>
      );
    }

    if (tempFiles.length === 0 && uploadType === MEDIA_TYPES.VIDEO) {
      return (
        <div className={classes.tempMediaPreviewContainer}>
          <img src={VideoIcon} alt="Preview" />
        </div>
      );
    }

    // 🖼 Render image
    if (tempFiles.length > 0 && uploadType === MEDIA_TYPES.IMAGE) {
      return (
        <div style={containerStyle}>
          <img src={previewUrl} alt="Preview" style={transformStyle} onLoad={handleImageLoad} />
        </div>
      );
    }

    // 🎥 Render video
    if (tempFiles.length > 0 && uploadType === MEDIA_TYPES.VIDEO) {
      return (
        <div className={classes.tempMediaPreviewContainer}>
          <video
            className={classes.previewVideo}
            src={previewUrl}
            controls
            controlsList="nodownload noplaybackrate"
            disablePictureInPicture
            onContextMenu={(e) => e.preventDefault()}
          />
        </div>
      );
    }

    return null;
  };

  renderUploadMediaDialog = () => {
    const { t } = this.props;
    const { showUploadDialog, uploadType, isEdit, disableRemove, disableSave } = this.state;

    let title = isEdit ? t('common:mediaUpload.buttons.editImage') : t('common:mediaUpload.buttons.addImage');
    let description = (
      <Typography variant="body2" style={{ letterSpacing: '0.25px', lineHeight: '18px' }}>
        {t('common:mediaUpload.dropzone.imageFormats')} <strong>.jpg</strong>, <strong>.png</strong> {t('common:mediaUpload.dropzone.or')} <strong>.gif</strong>.
        {t('common:mediaUpload.dropzone.imageResolution')} <strong>4MB</strong>.
      </Typography>
    );

    if (uploadType === MEDIA_TYPES.VIDEO) {
      title = isEdit ? t('common:mediaUpload.buttons.editVideo') : t('common:mediaUpload.buttons.addVideo');
      description = (
        <Typography variant="body2" style={{ letterSpacing: '0.25px', lineHeight: '18px' }}>
          {t('common:mediaUpload.dropzone.videoFormats')} <strong>.mp4</strong>, <strong>.mov</strong> {t('common:mediaUpload.dropzone.or')} <strong>.webm</strong>.
          {t('common:mediaUpload.dropzone.videoResolution')} <strong>10MB</strong>.
        </Typography>
      );
    }

    return (
      <HBModalDialog
        title={title}
        open={showUploadDialog}
        toggleOpenDialog={this.closeUploadDialog}
        width={'654px'}
        height={'600px'}
        borderHeader={true}
      >
        <Grid container spacing={2} style={{ padding: '24px 20px 0px 12px' }}>
          <Grid item xs={12} style={{ marginBottom: '30px' }}>
            {description}
          </Grid>
          <Grid item xs={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {this.renderTempMediaPreview()}
          </Grid>
          {uploadType === MEDIA_TYPES.IMAGE && (
            <Grid item xs={12} style={{ marginTop: '30px' }}>
              {this.renderTools()}
            </Grid>
          )}
        </Grid>
        <Grid
          container
          style={{
            position: 'absolute',
            bottom: 10,
            left: 0,
            right: 0,
            margin: 0,
            padding: '0px 12px 4px 12px',
          }}
        >
          <Grid item xs={8}>
            <Button
              className="milo-btn-white"
              variant="contained"
              component="button"
              disabled={disableRemove}
              style={{
                width: '180px',
                height: '40px',
                justifyContent: 'flex-start',
                marginRight: '16px',
                padding: '6px 12px',
              }}
              onClick={this.handleTempDelete}
            >
              <TrashBinIcon style={{ fontSize: '20px', color: '#616161', marginRight: '12px' }} />
              <Typography
                variant="body1"
                style={{ textTransform: 'none', fontSize: '14px', color: '#616161', letterSpacing: '1.25px' }}
              >
                {uploadType === MEDIA_TYPES.IMAGE ? t('common:mediaUpload.buttons.removeImage') : t('common:mediaUpload.buttons.removeVideo')}
              </Typography>
            </Button>

            <Button
              className="milo-btn-white"
              variant="contained"
              component="button"
              style={{ width: '180px', height: '40px', justifyContent: 'flex-start', padding: '6px 12px' }}
              onClick={uploadType === MEDIA_TYPES.IMAGE ? this.handleUploadImage : this.handleUploadVideo}
            >
              <UploadFileIcon style={{ fontSize: '20px', color: '#616161', marginRight: '12px' }} />
              <Typography
                variant="body1"
                style={{ textTransform: 'none', fontSize: '14px', color: '#616161', letterSpacing: '1.25px' }}
              >
                {uploadType === MEDIA_TYPES.IMAGE ? t('common:mediaUpload.buttons.uploadImage') : t('common:mediaUpload.buttons.uploadVideo')}
              </Typography>
            </Button>
          </Grid>
          <Grid item xs={4} style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              type="button"
              variant="contained"
              className="milo-btn-orange"
              color="primary"
              style={{
                width: '180px',
                height: '40px',
                justifyContent: 'flex-start',
                padding: '6px 12px',
              }}
              disabled={disableSave}
              onClick={this.handleSave}
            >
              <Save style={{ fontSize: '20px', marginRight: '12px' }} />
              <Typography
                variant="body1"
                style={{ textTransform: 'none', fontSize: '14px', color: '#FFFFFF', letterSpacing: '1.25px' }}
              >
                {uploadType === MEDIA_TYPES.IMAGE ? t('common:mediaUpload.buttons.saveImage') : t('common:mediaUpload.buttons.saveVideo')}
              </Typography>
            </Button>
          </Grid>
        </Grid>
      </HBModalDialog>
    );
  };

  renderTools() {
    const { tempFiles, tempMedia, tempScale } = this.state;

    return (
      <Grid
        container
        direction="row"
        spacing={0}
        style={{
          padding: '0px 100px 0px 100px',
          marginBottom: 0,
        }}
      >
        <Grid item xs={12}>
          <Grid container justify="center" spacing={40}>
            <Grid item>
              <IconButton
                disabled={!tempMedia || tempFiles.length === 0}
                onClick={() =>
                  this.setState({
                    tempAngle: this.state.tempAngle - 90,
                    disableSave: false,
                    isPortraitOrSquare: !this.state.isPortraitOrSquare,
                  })
                }
              >
                <RotateLeft style={{ fontSize: 30 }} />
              </IconButton>
            </Grid>
            <Grid item>
              <IconButton
                disabled={!tempMedia || tempFiles.length === 0}
                onClick={() =>
                  this.setState({
                    tempAngle: this.state.tempAngle + 90,
                    disableSave: false,
                    isPortraitOrSquare: !this.state.isPortraitOrSquare,
                  })
                }
              >
                <RotateRight style={{ fontSize: 30 }} />
              </IconButton>
            </Grid>
            <Grid item>
              <IconButton
                disabled={!tempMedia || tempFiles.length === 0 || tempScale >= 2}
                onClick={() => this.setState({ tempScale: tempScale + 0.1, disableSave: false })}
              >
                <ZoomIn style={{ fontSize: 30 }} />
              </IconButton>
            </Grid>
            <Grid item>
              <IconButton
                disabled={!tempMedia || tempFiles.length === 0 || tempScale <= 0.2}
                onClick={() => this.setState({ tempScale: tempScale - 0.1, disableSave: false })}
              >
                <ZoomOut style={{ fontSize: 30 }} />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  renderErrorDialog = () => {
    const { showErrorDialog, errors } = this.state;
    const { t } = this.props;

    if (errors.length === 0) return null;

    const getErrors = errorCodes(t);

    const error = getErrors.find((e) => e.id === errors[0]);

    console.log('>> showErrorDialog: ', errors);

    return (
      <HBModalDialog
        title={error.title}
        open={showErrorDialog}
        toggleOpenDialog={this.closeErrorDialog}
        width={'654px'}
        height={'256px'}
        borderHeader={false}
      >
        <Grid container spacing={2} style={{ padding: '16px 16px 0px 12px' }}>
          <Grid item xs={12}>
            {error.description}
          </Grid>
        </Grid>
        <Grid
          container
          style={{
            position: 'absolute',
            bottom: 10,
            left: 0,
            right: 0,
            margin: 0,
            padding: '0px 12px 4px 0px',
          }}
        >
          <Grid item xs={6}></Grid>
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              type="button"
              variant="contained"
              className="milo-btn-orange"
              color="primary"
              style={{ width: '200px', height: '40px' }}
              onClick={error.id === 7 ? this.proceedSaveImage : this.closeErrorDialog}
            >
              {error.id === 7 ? t('common:mediaUpload.buttons.proceed') : t('common:buttonLabels.ok')}
            </Button>
          </Grid>
        </Grid>
      </HBModalDialog>
    );
  };

  renderView() {
    const {
      classes,
      readonly,
      input: { value: mediaUpload },
    } = this.props;

    if (mediaUpload.length === 0 && readonly) return null;

    return (
      <div className={classes.mediaContainer}>
        {mediaUpload && mediaUpload.length > 0 ? this.renderMediaPreview() : null}
      </div>
    );
  }

  renderEdit() {
    const { classes, readonly } = this.props;
    const { files } = this.state;

    return (
      <div className={classes.mediaContainer}>
        {files.length > 0 ? this.renderPreview() : this.renderDropzone()}

        <input
          ref={this.imageInputRef}
          type="file"
          accept={CONSTRAINTS.image.acceptAttribute}
          onChange={(e) => this.handleFileInputChange(e, 'image')}
          style={{ display: 'none' }}
        />

        <input
          ref={this.videoInputRef}
          type="file"
          accept={CONSTRAINTS.video.acceptAttribute}
          onChange={(e) => this.handleFileInputChange(e, 'video')}
          style={{ display: 'none' }}
        />

        <input
          ref={this.allFilesInputRef}
          type="file"
          accept={`${CONSTRAINTS.image.acceptAttribute},${CONSTRAINTS.video.acceptAttribute}`}
          onChange={(e) => this.handleBrowseFileInputChange(e)}
          style={{ display: 'none' }}
        />

        {this.renderUploadMediaDialog()}
        {this.renderErrorDialog()}
      </div>
    );
  }

  render() {
    const { mode, readonly } = this.props;
    return readonly ? this.renderView() : this.renderEdit();
  }
}

// Separate dropzone component for cleaner code
const DropzoneComponent = ({
  onDrop,
  accept,
  disabled,
  multiple,
  classes,
  onUploadImage,
  onUploadVideo,
  onBrowseFiles,
  mode,
  t,
}) => {
  const { getRootProps, getInputProps, isDragActive, isDragReject } = useDropzone({
    onDrop,
    accept,
    disabled,
    multiple,
    noClick: true,
    noKeyboard: true,
  });

  const getDropzoneClassName = () => {
    let className = classes.dropzone;
    if (isDragActive) className += ` ${classes.dropzoneActive}`;
    if (isDragReject) className += ` ${classes.dropzoneReject}`;
    return className;
  };

  return (
    <div {...getRootProps({ className: getDropzoneClassName() })}>
      {mode !== 'view' && <input {...getInputProps()} />}
      <img src={PhotoIcon} className={classes.uploadIcon} />
      <Typography variant="body1" className={classes.dragDropText}>
        {t('common:mediaUpload.dropzone.dragDropMedia')}
      </Typography>
      <Typography variant="body1" className={classes.uploadText}>
        <span className={classes.dragDropText}>{t('common:mediaUpload.dropzone.or')} </span>
        <span className={classes.linkButton} onClick={mode !== 'view' ? onUploadImage : undefined}>
          {t('common:mediaUpload.dropzone.uploadAnImage')}
        </span>
        ,{' '}
        <span className={classes.linkButton} onClick={mode !== 'view' ? onUploadVideo : undefined}>
          {t('common:mediaUpload.dropzone.uploadAVideo')}
        </span>
        ,{' '}
        <span className={classes.linkButton} onClick={mode !== 'view' ? onBrowseFiles : undefined}>
          {t('common:mediaUpload.dropzone.browseFiles')}
        </span>
        .
      </Typography>
      <Typography className={classes.uploadSubtext}>
        {t('common:mediaUpload.dropzone.imageFormats')} <strong>.jpg</strong>, <strong>.png</strong> {t('common:mediaUpload.dropzone.or')} <strong>.gif</strong>.
        <br />
        {t('common:mediaUpload.dropzone.imageResolution')} <strong>4MB</strong>.
      </Typography>
      <Typography className={classes.uploadSubtext}>
        {t('common:mediaUpload.dropzone.videoFormats')} <strong>.mp4</strong>, <strong>.mov</strong> {t('common:mediaUpload.dropzone.or')} <strong>.webm</strong>.
        <br />
        {t('common:mediaUpload.dropzone.videoResolution')} <strong>10MB</strong>.
      </Typography>
    </div>
  );
};

class MediaUpload extends React.PureComponent {
  render() {
    const { name, t, ...props } = this.props;
    return <Field name={name} component={RawMediaUpload} t={t} {...props} />;
  }
}

@withStyles(mediaUploadStyles)
class RawMediaUpload2 extends React.PureComponent { }
class MediaUpload2 extends React.PureComponent {
  render() {
    const { name, ...props } = this.props;
    return <Field name={name} component={RawMediaUpload2} {...props} />;
  }
}

function isValidUrl(value) {
  try {
    new URL(value);
    return true;
  } catch (err) {
    return false;
  }
}

function isVideoUrl(url) {
  try {
    const parsedUrl = new URL(url);
    const pathname = parsedUrl.pathname.toLowerCase();

    const videoExtensions = ['.mp4', '.mov', '.webm'];

    return videoExtensions.some((ext) => pathname.endsWith(ext));
  } catch (e) {
    return false; // Invalid URL
  }
}

const withReduxForm = (objOrMapper) => (DecoratedComponent) => {
  const getValidationLanguage = (props = {}) =>
    props.lng ||
    props.language ||
    R.path(['i18n', 'language'], props) ||
    R.path(['i18n', 'i18n', 'language'], props) ||
    R.path(['runtimeProps', 'language'], props) ||
    (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('language')) ||
    'en';

  const getValidationTranslator = (props = {}) =>
    props.t ||
    R.path(['runtimeProps', 't'], props);

  const createReduxForm = memoize(
    ({ layout: { header = {}, body = {}, footer = {}, additional = {} } = {}, config = {} } = {}) => {
      const defaultShouldValidate = ({
        values,
        nextProps,
        initialRender,
        lastFieldValidatorKeys,
        fieldValidatorKeys,
        structure,
      }) =>
        initialRender ||
        !structure.deepEqual(values, nextProps && nextProps.values) ||
        !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);

      const withLanguageAwareValidation = (shouldValidate) => (params) => {
        const languageChanged = getValidationLanguage(params.props) !== getValidationLanguage(params.nextProps);
        const translatorChanged = getValidationTranslator(params.props) !== getValidationTranslator(params.nextProps);
        return languageChanged || translatorChanged || shouldValidate(params);
      };

      const mergedConfig = {
        ...config,
        shouldError: withLanguageAwareValidation(config.shouldError || defaultShouldValidate),
        shouldWarn: withLanguageAwareValidation(config.shouldWarn || defaultShouldValidate),
      };

      class FormHeader extends React.PureComponent {
        static propTypes = {
          components: PropTypes.array,
          disabled: PropTypes.bool,
          readonly: PropTypes.bool,
        };

        static defaultProps = {
          components: null,
        };

        render() {
          const {
            components,
            itemProps,
            containerProps,
            divider,
            disabled: formHeaderDisabled,
            readonly: formHeaderReadonly,
            ...rest
          } = {
            ...this.props,
            ...header,
            ...(header.inject && header.inject(this.props)),
          };
          return (
            components && (
              <Grid item xs={12} {...itemProps}>
                <Grid container justify="space-between" alignItems="center" spacing={2} {...containerProps}>
                  {components.map(({ id, component: Component, colSpans, inject, ...props }) => (
                    <Grid key={id} item {...colSpans}>
                      <Component
                        disabled={!!formHeaderDisabled}
                        readonly={!!formHeaderReadonly}
                        {...props}
                        {...(inject ? inject(rest) : {})}
                      />
                    </Grid>
                  ))}
                  {divider && (
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                  )}
                </Grid>
              </Grid>
            )
          );
        }
      }

      @withStyles({
        resetContainer: {
          width: '100%',
          margin: 0,
        },
      })
      class FormBody extends React.PureComponent {
        static propTypes = {
          sections: PropTypes.array,
          wrapper: PropTypes.func,
          disabled: PropTypes.bool,
          readonly: PropTypes.bool,
        };

        static defaultProps = {
          wrapper: R.prop('children'),
        };

        render() {
          const { sections, wrapper: Wrapper, itemProps, containerProps, classes, bodyFooter, ...rest } = {
            ...this.props,
            ...body,
            ...additional,
            ...(body.inject && body.inject(this.props)),
          };

          const getVisibility = (value, props) => {
            if (typeof value === 'boolean') {
              return value;
            } else if (typeof value === 'function') {
              return value(props);
            }
            return false;
          };

          return (
            <Grid item xs={12} {...itemProps}>
              <Wrapper>
                <Grid container justify="center" spacing={2} {...containerProps} className={classes.resetContainer}>
                  {R.filter(
                    R.identity,
                    sections.map(({ id, isVisible = true, inject, additional, ...props }) => {
                      const localProps = inject ? inject(rest) : {};
                      const _getVisibility = getVisibility(isVisible, localProps);
                      if (!_getVisibility) return null;
                      return (
                        <React.Fragment key={id}>
                          <Section {...rest} {...props} {...localProps} />
                          {additional && additional.bodyFooter(rest)}
                        </React.Fragment>
                      );
                    }),
                  )}
                </Grid>
              </Wrapper>
            </Grid>
          );
        }
      }

      class FormFooter extends React.PureComponent {
        static propTypes = {
          components: PropTypes.array,
          disabled: PropTypes.bool,
          hide: PropTypes.bool,
        };

        static defaultProps = {
          components: null,
        };

        render() {
          const {
            components,
            itemProps,
            containerProps,
            divider,
            disabled: formFooterDisabled,
            hide: formFooterHide,
            ...rest
          } = {
            ...this.props,
            ...footer,
            ...(footer.inject && footer.inject(this.props)),
          };

          if (formFooterHide) return null;

          return (
            components && (
              <Grid item xs={12} {...itemProps}>
                <Grid container justify="space-between" alignItems="center" spacing={2} {...containerProps}>
                  {divider && (
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                  )}
                  {components.map(({ id, component: Component, colSpans, inject, ...props }) => (
                    <Grid key={id} item {...colSpans}>
                      <Component disabled={!!formFooterDisabled} {...props} {...(inject ? inject(rest) : {})} />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            )
          );
        }
      }

      class Form extends React.PureComponent {
        static propTypes = {
          autocomplete: PropTypes.string,
          containerProps: PropTypes.object,
          className: PropTypes.string,
          style: PropTypes.any,
        };

        static defaultProps = {
          autocomplete: 'on',
        };

        render() {
          const {
            /* redux-form */
            handleSubmit,
            /* direct */
            autocomplete,
            containerProps,
            className,
            style,
            ...rest
          } = this.props;

          return (
            <form
              noValidate
              style={config.style || {}}
              autoComplete={autocomplete}
              onSubmit={(e) => {
                /* NOTE: this to prevent triggering submission of child form
            from triggering submission of parent form too, if any.
            In React, event propagates along the React hierarchy, not DOM.
            child <form> is not part of parent <form> DOM hierarchy
            created by material-ui's Modal, which probably uses React Portal.
            Ref: https://github.com/erikras/redux-form/issues/3701
          */
                e.stopPropagation();
                handleSubmit(e);
              }}
            >
              <Grid container {...containerProps} className={className} style={style}>
                <FormHeader {...rest} disabled={rest.submitting} />
                <FormBody {...rest} disabled={rest.submitting} />
                <FormFooter {...rest} disabled={rest.submitting} />
              </Grid>
            </form>
          );
        }
      }

      const ReduxFormComponent = reduxForm(mergedConfig)(Form);

      class ReduxFormI18nBridge extends React.PureComponent {
        render() {
          const { t: parentT, tReady: parentTReady, i18n: parentI18n, ...rest } = this.props;

          return (
            <NamespacesConsumer>
              {(injectedT, { i18n, lng, ready }) => (
                <ReduxFormComponent
                  {...rest}
                  /* NOTE: only fall back to the i18next instance when the caller did not
                     supply its own `i18n` prop. Some forms (e.g. feedback/survey) pass a
                     `{ t, i18n }` wrapper down and destructure `t` off it in their
                     `inject`s; overwriting it here handed them i18next's unbound
                     prototype `t`, which throws on call (`this.translator` of undefined). */
                  i18n={parentI18n || i18n}
                  lng={lng}
                  t={parentT || injectedT}
                  tReady={typeof parentTReady === 'boolean' ? parentTReady : ready}
                />
              )}
            </NamespacesConsumer>
          );
        }
      }

      return ReduxFormI18nBridge;
    },
  );

  class WithReduxForm extends React.PureComponent {
    render() {
      const option = R.when(R.is(Function), (mapper) => mapper(this.props))(objOrMapper);
      return <DecoratedComponent {...this.props} Form={createReduxForm(option)} />;
    }
  }

  return WithReduxForm;
};

@withStyles((theme) => ({
  panel: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '80vw',
    maxHeight: '80vh',
    overflow: 'scroll',
    borderRadius: 10,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
  },
}))
@withReduxForm(R.pick(['layout', 'config']))
class RawModalSubFormPanel extends React.PureComponent {
  static propTypes = {
    Form: PropTypes.func.isRequired,
    initialValues: PropTypes.object.isRequired,
    open: PropTypes.bool.isRequired,
    cancel: PropTypes.func.isRequired,
    save: PropTypes.func.isRequired,
    readonly: PropTypes.bool,
    className: PropTypes.string,
    style: PropTypes.object,
    classes: PropTypes.object.isRequired,
  };

  static defaultProps = {
    readonly: false,
  };

  constructor(props) {
    super(props);

    this.form = createRef();
  }

  state = {
    openConfirmDialog: false,
    error: '',
    isConfirmed: false,
    formValues: null,
  };

  handleOpenConfirmDialog = (values) => {
    this.setState({ openConfirmDialog: true, error: 'POTENTIAL_HIGH_ALERTS_VOLUME', formValues: values });
  };

  handleCloseConfirmDialog = () => {
    this.setState({ openConfirmDialog: false, error: '', isConfirmed: false }, () => {
      this.form.current.reset();
    });
  };

  handleConfirm = () => {
    this.setState({ openConfirmDialog: false, error: '', isConfirmed: true });
  };

  submitForm = () => {
    const { save, additionalSubmit, selectedValue } = this.props;
    const { formValues: values } = this.state;

    this.setState({ openConfirmDialog: false, error: '', isConfirmed: true }, () => {
      new Promise((resolve) => {
        const selectedCategory = selectedValue;
        /* Anything that is not explicitly 'advanced' takes the one-time path, including the
           empty string. `selectedCategory` is '' whenever neither category is marked selected —
           the normal state for a vital whose alerts have never been configured — and the chain
           used to test `=== 'oneTime'` with no final else, so that case fell through every
           branch. `resolve` was never called, the promise stayed pending for ever, `save` never
           ran, and the dialog sat in submitting state with nothing logged. */
        if (selectedCategory !== 'advanced') {
          if (values.alertCategory && values.alertCategory.advanced) delete values.alertCategory.advanced.selected;
          if (values.alertCategory && values.alertCategory.oneTime) {
            values.alertCategory.oneTime.selected = true;
          }
          resolve(values);
          save(values);
          additionalSubmit();
        } else {
          if (values.alertCategory && values.alertCategory.oneTime) delete values.alertCategory.oneTime.selected;
          if (values.alertCategory && values.alertCategory.advanced) {
            values.alertCategory.advanced.selected = true;
          }
          resolve(values);
          save(values);
          additionalSubmit();
        }
      });
    });
  };

  checkHasAlertConfig = (alertConfig) => {
    let hasAlert = false;

    for (const subType in alertConfig) {
      // Property is not inherited from prototype
      if (alertConfig.hasOwnProperty(subType)) {
        const subTypeConfig = alertConfig[subType];
        for (const alertInput in subTypeConfig) {
          if (subTypeConfig.hasOwnProperty(alertInput)) {
            const hasConfig = subTypeConfig[alertInput];
            for (const configKey in hasConfig) {
              if (hasConfig.hasOwnProperty(configKey)) {
                const keyValue = hasConfig[configKey];
                const sendVia = keyValue && keyValue.checkeds;
                if (sendVia) {
                  if (sendVia.email || sendVia.sms || sendVia.inApp) hasAlert = true;
                }
              }
            }
          }
        }
      }
    }

    return hasAlert;
  };

  potentialHighAlertValidation = (minutes) => {
    if (Number(minutes) >= 1 && Number(minutes) < 5) {
      return true;
    }

    return false;
  };

  render() {
    const {
      Form,
      initialValues,
      open,
      cancel,
      save,
      readonly,
      containerProps,
      classes,
      className,
      style,
      runtimeProps,
      isOneTimeTask,
      alertRelation = 'PROGRAMME',
      hasRadioTab = false,
      additionalSubmit = () => { },
      selectedValue = '',
    } = this.props;
    const { openConfirmDialog, error, isConfirmed } = this.state;

    return (
      <React.Fragment>
        <Modal open={open}>
          <Paper className={classNames(classes.panel, className)} style={style}>
            <IconButton disableRipple={true} style={{ position: 'absolute', top: 10, right: 10 }} onClick={cancel}>
              <Close style={{ fontSize: 30 }} />
            </IconButton>
            <Form
              ref={this.form}
              readonly={readonly}
              initialValues={initialValues}
              runtimeProps={runtimeProps}
              containerProps={containerProps}
              onSubmit={(values) =>
                new Promise((resolve) => {
                  if (!hasRadioTab) {
                    resolve(values);
                    save(values);
                  } else {
                    /* Not explicitly 'advanced' means the one-time path, the empty string
                       included. See submitForm above for why: '' is the normal state for a
                       vital with no alerts configured, and the old `=== 'oneTime'` chain had no
                       final else, so those submits never resolved and the dialog hung. */
                    const selectedCategory = selectedValue;

                    /* Reads one alert-config value, tolerating a missing branch. These chains
                       used to be dereferenced directly; a vital whose alerts have never been
                       configured can be missing a whole group (warning, critical, or an entire
                       category), and the resulting TypeError is thrown INSIDE this Promise —
                       so it never resolves, the dialog never closes, and the form stays
                       pristine with no error shown anywhere. */
                    const alertValue = (category, group, subType, field) => {
                      const cfg = values.alertCategory
                        && values.alertCategory[category]
                        && values.alertCategory[category].alertConfig;
                      const entry = cfg && cfg[group] && cfg[group][subType];
                      return entry && entry[field] ? entry[field].value : undefined;
                    };

                    if (selectedCategory !== 'advanced') {
                      const oneTimeMissedHours = alertValue('oneTime', 'missed', 'missed', 'hours');
                      const oneTimeMissedMinutes = alertValue('oneTime', 'missed', 'missed', 'minutes');
                      const oneTimeCHMinutes = alertValue('oneTime', 'critical', 'criticallyHigh', 'minutes');
                      const oneTimeCLMinutes = alertValue('oneTime', 'critical', 'criticallyLow', 'minutes');
                      const oneTimeHMinutes = alertValue('oneTime', 'warning', 'high', 'minutes');
                      const oneTimeLMinutes = alertValue('oneTime', 'warning', 'low', 'minutes');

                      const validateMissed =
                        Number(oneTimeMissedHours) === 0 && this.potentialHighAlertValidation(oneTimeMissedMinutes);
                      const validateCH = this.potentialHighAlertValidation(oneTimeCHMinutes);
                      const validateCL = this.potentialHighAlertValidation(oneTimeCLMinutes);
                      const validateH = this.potentialHighAlertValidation(oneTimeHMinutes);
                      const validateL = this.potentialHighAlertValidation(oneTimeLMinutes);

                      const validatePotentialHighAlert =
                        validateMissed || validateCH || validateCL || validateH || validateL;

                      if (
                        alertRelation !== 'QUESTIONNAIRE' &&
                        !isOneTimeTask &&
                        !isConfirmed &&
                        validatePotentialHighAlert
                      ) {
                        this.handleOpenConfirmDialog(values);
                      } else {
                        if (values.alertCategory && values.alertCategory.advanced) delete values.alertCategory.advanced.selected;

                        const oneTimeAlert = (values.alertCategory && values.alertCategory.oneTime
                          && values.alertCategory.oneTime.alertConfig) || {};

                        const hasAlertConfig = this.checkHasAlertConfig(oneTimeAlert);

                        if (hasAlertConfig && values.alertCategory && values.alertCategory.oneTime) {
                          values.alertCategory.oneTime.selected = true;
                        } else {
                          if (values.alertCategory && values.alertCategory.oneTime) delete values.alertCategory.oneTime.selected;
                        }

                        resolve(values);
                        save(values);
                        additionalSubmit();
                      }
                    } else {
                      const advancedMissedHours = alertValue('advanced', 'missed', 'missed', 'hours');
                      const advancedMissedMinutes = alertValue('advanced', 'missed', 'missed', 'minutes');
                      const advancedCHMinutes = alertValue('advanced', 'critical', 'criticallyHigh', 'minutes');
                      const advancedCLMinutes = alertValue('advanced', 'critical', 'criticallyLow', 'minutes');
                      const advancedHMinutes = alertValue('advanced', 'warning', 'high', 'minutes');
                      const advancedLMinutes = alertValue('advanced', 'warning', 'low', 'minutes');

                      const validateMissed =
                        Number(advancedMissedHours) === 0 && this.potentialHighAlertValidation(advancedMissedMinutes);
                      const validateCH = this.potentialHighAlertValidation(advancedCHMinutes);
                      const validateCL = this.potentialHighAlertValidation(advancedCLMinutes);
                      const validateH = this.potentialHighAlertValidation(advancedHMinutes);
                      const validateL = this.potentialHighAlertValidation(advancedLMinutes);

                      const validatePotentialHighAlert =
                        validateMissed || validateCH || validateCL || validateH || validateL;

                      if (
                        alertRelation !== 'QUESTIONNAIRE' &&
                        !isOneTimeTask &&
                        !isConfirmed &&
                        validatePotentialHighAlert
                      ) {
                        this.handleOpenConfirmDialog(values);
                      } else {
                        if (values.alertCategory && values.alertCategory.oneTime) delete values.alertCategory.oneTime.selected;
                        values.alertCategory.advanced.selected = true;

                        resolve(values);
                        save(values);
                        additionalSubmit();
                      }
                    }
                  }
                })
              }
            />
          </Paper>
        </Modal>
        <DialogProgramValidation
          open={openConfirmDialog}
          error={error}
          toggleCloseDialog={this.handleCloseConfirmDialog}
          proceed={this.submitForm}
        />
      </React.Fragment>
    );
  }
}

@withOnMetaChange()
class RawModalSubForm extends React.PureComponent {
  static propTypes = {
    trigger: PropTypes.shape({
      component: PropTypes.func.isRequired,
    }).isRequired,
    layout: PropTypes.object.isRequired,
    config: PropTypes.object.isRequired,
    input: PropTypes.object.isRequired,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    disabled: false,
  };

  state = {
    edit: false,
  };

  render() {
    const { edit } = this.state;
    const {
      trigger: { component: Trigger, ...triggerProps },
      input: { value, onBlur, onFocus },
      disabled,
      onClose,
      ...rest
    } = this.props;

    // console.log('%cModalSubForm', 'font-size: 12px; color: #00b3b3', this.state, this.props);

    return (
      <React.Fragment>
        <Trigger
          {...rest}
          disabled={disabled}
          {...triggerProps}
          onClick={(e) => {
            this.setState({ edit: true }, onFocus.bind(null, e));
          }}
        />
        <RawModalSubFormPanel
          initialValues={value}
          open={edit}
          cancel={() => {
            this.setState({ edit: false }, onBlur.bind(null, value));
            onClose && onClose();
          }}
          save={(values) => this.setState({ edit: false }, onBlur.bind(null, values))}
          {...rest}
        />
      </React.Fragment>
    );
  }
}

class WithoutFormSection extends React.PureComponent {
  static contextTypes = {
    _reduxForm: PropTypes.object,
  };

  static childContextTypes = {
    _reduxForm: PropTypes.object,
  };

  getChildContext() {
    return {
      _reduxForm: {
        ...this.context._reduxForm,
        sectionPrefix: undefined,
      },
    };
  }

  render() {
    return this.props.children;
  }
}

class ModalSubForm extends React.PureComponent {
  render() {
    const { name, absoluteName, ...props } = this.props;

    if (absoluteName) {
      return (
        <WithoutFormSection>
          <Field name={absoluteName} component={RawModalSubForm} {...props} />
        </WithoutFormSection>
      );
    }

    return <Field name={name} component={RawModalSubForm} {...props} />;
  }
}

export {
  withReduxForm,
  withOnMetaChange,
  TextField,
  FreeTextField,
  ShowHidePasswordTextField,
  Phone,
  RawSelect,
  Select,
  TypeSelect,
  TypeSelector,
  Switch,
  RadioGroup,
  RadioboxLabel,
  CheckboxLabel,
  CheckboxGroup,
  Checkbox,
  DatePicker,
  TimePicker,
  RangeSlider,
  Multiple,
  Multiple2,
  Tabs,
  Steppers,
  Avatar,
  MediaUpload,
  ModalSubForm,
  MultiSelect,
  CheckboxRightLabelGroup,
  RawTabs,
};
